require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0088331f232d637f1ba36c7945628da5/code.js', () => { 

var finalQueryRealTOur, error, query, finalQueryTour, addQueryByNotIn, notInString, tag, monat;



BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5'] = async function fn_0088331f232d637f1ba36c7945628da5(tourDatum, tour, kalenderwoche) {
    try {
    if ((new Date((new Date(tourDatum))).getMonth() + 1) < 10) {
      monat = String('0') + String(new Date((new Date(tourDatum))).getMonth() + 1);
    } else {
      monat = String(new Date((new Date(tourDatum))).getMonth() + 1);
    }
    if ((new Date((new Date(tourDatum))).getDate()) < 10) {
      tag = String('0') + String(new Date((new Date(tourDatum))).getDate());
    } else {
      tag = String(new Date((new Date(tourDatum))).getDate());
    }
    query = ['Tour.Name=\'',tour,'\' AND TourDate =',((new Date((['',monat,'/',tag,'/',(new Date((new Date(tourDatum))).getFullYear()),' 00:00:00'].join('')))).valueOf())].join('');
    notInString = (await BackendlessUI.Functions.Custom['fn_2c2365e4eb9b09dd6151d7a103758e8b'](tourDatum, tour));
    if (notInString.length > 0) {
      addQueryByNotIn = String('and KundeExt.Kundennr not in ') + String(notInString);
    } else {
      addQueryByNotIn = '';
    }
    if (kalenderwoche != null) {
      if (0 % 2 == 0) {
        finalQueryTour = ['TourID.Name=\'',tour,'\'',' AND (Wochenart = \'*\' OR Wochenart = \'gerade\')',addQueryByNotIn].join('');
        finalQueryRealTOur = query;
      } else {
        finalQueryTour = ['TourID.Name=\'',tour,'\'',' AND (Wochenart = \'*\' OR Wochenart = \'ungerade\')',addQueryByNotIn].join('');
        finalQueryRealTOur = query;
      }
    } else {
      finalQueryTour = ['TourID.Name=\'',tour,'\''].join('');
      finalQueryRealTOur = query;
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }


  return finalQueryRealTOur
}

})
define('./functions/0186b3ebf395bab8f274da7bd9e98e71/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0186b3ebf395bab8f274da7bd9e98e71'] = async function fn_0186b3ebf395bab8f274da7bd9e98e71() {
  await Backendless.Data.of('KontorUpdateLog').save( ({ 'Datum': (new Date()) }) );

return 
}

})
define('./functions/15dfd26f2a014414e0cee25d93913507/code.js', () => { 

var adressListe, error, j;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



BackendlessUI.Functions.Custom['fn_15dfd26f2a014414e0cee25d93913507'] = async function fn_15dfd26f2a014414e0cee25d93913507(input) {
    adressListe = [];
  for (var j_index in input) {
    j = input[j_index];
    try {
      addItemToList(adressListe, (j['locationMaps']));

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }
  }


  return adressListe
}

})
define('./functions/1657158dad4ae313ac7b59e59ed23dea/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1657158dad4ae313ac7b59e59ed23dea'] = async function fn_1657158dad4ae313ac7b59e59ed23dea() {
    ;await ( async function (message){ alert(message) })((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://maps.googleapis.com/maps/api/geocode/json?')).query(({ 'address': 'Breslauer Straße 1, 24790 Schacht-Audorf','key': 'AIzaSyA0LINu3Z7ryVNYTtilJM6I-HVrEgr3wzg' })).setEncoding('utf8').send()));


  return
}

})
define('./functions/2c1dc622869545821543dae2c746662a/code.js', () => { 

var j;



BackendlessUI.Functions.Custom['GetDateFromDB'] = async function GetDateFromDB() {
    var j_list = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setPageSize(10)));
  for (var j_index in j_list) {
    j = j_list[j_index];
    ;await ( async function (message){ alert(message) })((j['Name1']));
  }



}

})
define('./functions/2c2365e4eb9b09dd6151d7a103758e8b/code.js', () => { 

var notInString, error, listeCount, counter, j, query, tag, monat;



BackendlessUI.Functions.Custom['fn_2c2365e4eb9b09dd6151d7a103758e8b'] = async function fn_2c2365e4eb9b09dd6151d7a103758e8b(TourDatum, TourName) {
    try {
    notInString = '';
    if ((new Date((new Date(TourDatum))).getMonth() + 1) < 10) {
      monat = String('0') + String(new Date((new Date(TourDatum))).getMonth() + 1);
    } else {
      monat = String(new Date((new Date(TourDatum))).getMonth() + 1);
    }
    if ((new Date((new Date(TourDatum))).getDate()) < 10) {
      tag = String('0') + String(new Date((new Date(TourDatum))).getDate());
    } else {
      tag = String(new Date((new Date(TourDatum))).getDate());
    }
    query = ['Tour.Name=\'',TourName,'\' AND TourDate =',((new Date((['',monat,'/',tag,'/',(new Date((new Date(TourDatum))).getFullYear()),' 00:00:00'].join('')))).valueOf())].join('');
    listeCount = (await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(query)));
    if (listeCount > 0) {
      counter = 0;
      notInString = '(';
      var j_list = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setProperties('KundeExt.Kundennr').setPageSize(10)));
      for (var j_index in j_list) {
        j = j_list[j_index];
        counter = counter + 1;
        notInString = [notInString,'\'',(j['Kundennr']),'\''].join('');
        if (counter != listeCount) {
          notInString = String(notInString) + String(',');
        }
      }
      notInString = String(notInString) + String(')');
    }

  } catch (error) {
    console.log(error);

  }


  return notInString
}

})
define('./functions/38ab1f0d78ea0eca78ce55d65199c92a/code.js', () => { 

var nord, sued, west, ost, error, j;



BackendlessUI.Functions.Custom['fn_38ab1f0d78ea0eca78ce55d65199c92a'] = async function fn_38ab1f0d78ea0eca78ce55d65199c92a(input) {
    nord = 0;
  sued = 0;
  ost = 0;
  west = 0;
  for (var j_index in input) {
    j = input[j_index];
    try {
      if (nord != 0 && ost != 0 && sued != 0 && west != 0) {
        if ((j['lng']) > ost) {
          ost = (j['lng']);
        }
        if ((j['lng']) < west) {
          west = (j['lng']);
        }
        if ((j['lat']) > nord) {
          nord = (j['lat']);
        }
        if ((j['lat']) < sued) {
          sued = (j['lat']);
        }
      } else {
        nord = (j['lat']);
        sued = (j['lat']);
        ost = (j['lng']);
        west = (j['lng']);
      }

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }
  }


  return ({ 'Ost': ost,'West': west,'Sued': sued,'Nord': nord })
}

})
define('./functions/3c1ee9467b71bb67e9ea12baf20f08d2/code.js', () => { 

var j, kdnrList, list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



BackendlessUI.Functions.Custom['fn_3c1ee9467b71bb67e9ea12baf20f08d2'] = async function fn_3c1ee9467b71bb67e9ea12baf20f08d2(input) {
    kdnrList = [];
  var j_list = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause(input).setPageSize(10)));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(kdnrList, (j['KundeID']));
  }


  return kdnrList
}

})
define('./functions/4a7e83025854391c63f44636b4641874/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4a7e83025854391c63f44636b4641874'] = function fn_4a7e83025854391c63f44636b4641874(inputDate) {
return 
}

})
define('./functions/ba0c3c756877806f7a8717c220f2462c/code.js', () => { 

var adressListe, error, adresse, tourKunde, j, listRealTour;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



BackendlessUI.Functions.Custom['fn_ba0c3c756877806f7a8717c220f2462c'] = async function fn_ba0c3c756877806f7a8717c220f2462c(query) {
    listRealTour = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setSortBy('PosNr').setPageSize(50)));
  adressListe = [];
  for (var j_index in listRealTour) {
    j = listRealTour[j_index];
    try {
      if ((await Backendless.Data.of('Kunden').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(j['KundeID']),'\''].join(''))))) == 0) {
        ;await ( async function (message){ alert(message) })((String('Kunde nicht gefunden: ') + String(j['KundeID'])));
      }
      tourKunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(j['KundeID']),'\''].join(''))).setPageSize(10)))[0];
      if ((tourKunde['Lieferadrid']) != null && !!(tourKunde['Lieferadrid']).length) {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(tourKunde['Lieferadrid']),'\''].join(''))).setPageSize(10)))[0];
      } else {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(tourKunde['Rgadrid']),'\''].join(''))).setPageSize(10)))[0];
      }
      addItemToList(adressListe, (adresse['locationMaps']));

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }
  }


  return adressListe
}

})
define('./functions/d12f73c1433eb4b70f6aa6b50ce2e7b5/code.js', () => { 

var finalQueryTour, error, query, finalQueryRealTOur, addQueryByNotIn, notInString, tag, monat;



BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5'] = async function fn_d12f73c1433eb4b70f6aa6b50ce2e7b5(tourDatum, tour, kalenderwoche) {
    try {
    if ((new Date((new Date(tourDatum))).getMonth() + 1) < 10) {
      monat = String('0') + String(new Date((new Date(tourDatum))).getMonth() + 1);
    } else {
      monat = String(new Date((new Date(tourDatum))).getMonth() + 1);
    }
    if ((new Date((new Date(tourDatum))).getDate()) < 10) {
      tag = String('0') + String(new Date((new Date(tourDatum))).getDate());
    } else {
      tag = String(new Date((new Date(tourDatum))).getDate());
    }
    query = ['Tour.Name=\'',tour,'\' AND TourDate =',((new Date((['',monat,'/',tag,'/',(new Date((new Date(tourDatum))).getFullYear()),' 00:00:00'].join('')))).valueOf())].join('');
    notInString = (await BackendlessUI.Functions.Custom['fn_2c2365e4eb9b09dd6151d7a103758e8b'](tourDatum, tour));
    if (notInString.length > 0) {
      addQueryByNotIn = String('and KundeExt.Kundennr not in ') + String(notInString);
    } else {
      addQueryByNotIn = '';
    }
    if (kalenderwoche != null) {
      if (0 % 2 == 0) {
        finalQueryTour = ['TourID.Name=\'',tour,'\'',' AND (Wochenart = \'*\' OR Wochenart = \'gerade\')',addQueryByNotIn].join('');
        finalQueryRealTOur = query;
      } else {
        finalQueryTour = ['TourID.Name=\'',tour,'\'',' AND (Wochenart = \'*\' OR Wochenart = \'ungerade\')',addQueryByNotIn].join('');
        finalQueryRealTOur = query;
      }
    } else {
      finalQueryTour = ['TourID.Name=\'',tour,'\''].join('');
      finalQueryRealTOur = query;
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }


  return finalQueryTour
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/ArtikelChangePage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['valueAenderungsinfoMulti'] = '';
  ___arguments.context.pageData['valueAenderungsinfoEinzel'] = '';
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
  ___arguments.context.pageData['ValueMultiplikator'] = '1.0';
  if ((getObjectProperty(___arguments.context.appData, 'Artnr')) != null) {
    (function (message) { alert(message) })((getObjectProperty(___arguments.context.appData, 'Artnr')));
    ___arguments.context.pageData['WhereClauseArtikelInListen'] = (['Artnr=\'',(getObjectProperty(___arguments.context.appData, 'Artnr')),'\''].join(''));
  }
  ___arguments.context.pageData['ValueLieferant'] = '93AF5FEA-E48D-411A-A973-59E4AC3B6421';
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('2888843e31d959a35cf52c184159bfd8', (await Promise.all((await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setSortBy('Name1').setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'Name1')),'value': (getObjectProperty(item, 'objectId')) });}))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2888843e31d959a35cf52c184159bfd8', '93AF5FEA-E48D-411A-A973-59E4AC3B6421');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ArtikelChangePage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelChangePage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelChangePage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelChangePage/components/575806085aa1f308186828388018f6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ArtikelnrAlt'] = (getObjectProperty(___arguments.selectedRecord, 'Artikelnr'));
  ___arguments.context.pageData['WhereClauseArtikelInListen'] = (['ArtikelID=\'',(getObjectProperty(___arguments.selectedRecord, 'Artnr')),'\''].join(''));
  ___arguments.context.pageData['valueAusgewaehltAltMulti'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/ArtikelChangePage/components/a518ab38a5745dd18157c196a0c82b58/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['objectIdArtikel'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['ArtikelID'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));
  ___arguments.context.pageData['valueAusgewaehltNeu'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));
  if ((getObjectProperty(___arguments.selectedRecord, 'Chargentyp')) == null) {
    ___arguments.context.pageData['Verfallskontrolle'] = false;
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'Chargentyp')).indexOf('Verfall') + 1 == 0) {
      ___arguments.context.pageData['Verfallskontrolle'] = false;
    } else {
      ___arguments.context.pageData['Verfallskontrolle'] = true;
    }
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/ArtikelChangePage/components/19280868eac881a8bea914a6ff1324d8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('2888843e31d959a35cf52c184159bfd8', (getObjectProperty(___arguments.selectedRecord, 'LieferantObjId')));
  ___arguments.context.pageData['ValueWoVeNeu'] = (getObjectProperty(___arguments.selectedRecord, 'WoVe'));
  ___arguments.context.pageData['ValueVorratNeu'] = (getObjectProperty(___arguments.selectedRecord, 'Vorrat'));
  ___arguments.context.pageData['ValueBestellenUnterNeu'] = (getObjectProperty(___arguments.selectedRecord, 'BestellenUnter'));
  ___arguments.context.pageData['ValueBemerkungNeu'] = (getObjectProperty(___arguments.selectedRecord, 'Bemerkung'));
  ___arguments.context.pageData['ValueAusgewaehlterArtikelAusListe'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['Kundennr'] = (getObjectProperty(___arguments.selectedRecord, 'Kundennr'));
  ___arguments.context.pageData['LagerplatzID'] = (getObjectProperty(___arguments.selectedRecord, 'LagerplatzID'));
  ___arguments.context.pageData['valueAusgewaehltAlt'] = ([(getObjectProperty(___arguments.selectedRecord, 'Kundennr')),' | ',(getObjectProperty(___arguments.selectedRecord, 'Artnr'))].join(''));
  ___arguments.context.pageData['valueAusgewaehltAltMulti'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/ArtikelChangePage/components/09f77a43be3ad679266a06bf6895bc26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var alterArtikel, bestellenUnterNeu, bestellmengeDurchschnitt, counter, error, j, neuerArtikel, offset, query, rechnungsFaktor, savedObject, tempList, ve, vorratNeu, woveNeu;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((typeof (getObjectProperty(___arguments.context.pageData, 'AltePackungsmenge')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'NeuePackungsmenge')) === 'undefined')) {
    ___arguments.context.pageData['AltePackungsmenge'] = 1;
    ___arguments.context.pageData['NeuePackungsmenge'] = 1;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'AltePackungsmenge')) == 0 || (getObjectProperty(___arguments.context.pageData, 'NeuePackungsmenge')) == 0) {
    (function (message) { alert(message) })('0 als Wert macht keinen Sinn!');
  } else {
    try {
      if (!(getObjectProperty(___arguments.context.pageData, 'valueAenderungsinfoMulti')).length) {
        (function (message) { alert(message) })('Bitte Aenderungsinfo eingeben!');
      } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'valueAusgewaehltAltMulti')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'ArtikelID')) === 'undefined')) {
        (function (message) { alert(message) })('Bitte alten und neuen Artikel auswählen!');
      } else {
        offset = 0;
        counter = 0;
        query = (getObjectProperty(___arguments.context.pageData, 'WhereClauseArtikelInListen'));
        rechnungsFaktor = (getObjectProperty(___arguments.context.pageData, 'AltePackungsmenge')) / (getObjectProperty(___arguments.context.pageData, 'NeuePackungsmenge'));
        while (true) {
          tempList = [];
          tempList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause(query).setPageSize(100).setOffset(offset)));
          if (tempList.length == 0) {
            break;
          }
          for (var j_index in tempList) {
            j = tempList[j_index];
            ve = (getObjectProperty(((await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr=\'',(getObjectProperty(j, 'ArtikelID')),'\''].join(''))).setPageSize(100)))[0]), 'Verkaufseinheit'));
            woveNeu = Math.round((getObjectProperty(j, 'WoVe')) * rechnungsFaktor * 10) / 10;
            vorratNeu = Math.round((getObjectProperty(j, 'Vorrat')) * rechnungsFaktor * 10) / 10;
            if ((getObjectProperty(j, 'BestellenUnter')) == null) {
              bestellenUnterNeu = (getObjectProperty(j, 'BestellenUnter'));
            } else {
              bestellenUnterNeu = Math.round((getObjectProperty(j, 'BestellenUnter')) * rechnungsFaktor * 10) / 10;
            }
            bestellmengeDurchschnitt = 0;
            if ((getObjectProperty(j, 'BestellmengeDurchschnitt')) != null) {
              if ((getObjectProperty(j, 'BestellmengeDurchschnitt')) > 0) {
                bestellmengeDurchschnitt = Math.round((getObjectProperty(j, 'BestellmengeDurchschnitt')) * rechnungsFaktor * 10) / 10;
              }
            }
            try {
              alterArtikel = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setRelated(['Lieferant']).setPageSize(100)))[0];
              neuerArtikel = ({ [`ArtikelID`]: (getObjectProperty(___arguments.context.pageData, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(___arguments.context.pageData, 'ValueBemerkungNeu')),[`LagerplatzID`]: (getObjectProperty(alterArtikel, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(alterArtikel, 'PosNr')),[`Vorrat`]: vorratNeu,[`WoVe`]: woveNeu,[`BestellenUnter`]: bestellenUnterNeu,[`Verfallskontrolle`]: (getObjectProperty(___arguments.context.pageData, 'Verfallskontrolle')),[`BestellmengeDurchschnitt`]: bestellmengeDurchschnitt });
              savedObject = (await Backendless.Data.of('ArtikelInLagerplatz').save( neuerArtikel ));
              await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'LagerplatzIdExt', [(await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(alterArtikel, 'LagerplatzID')),'\''].join(''))).setPageSize(100)))[0]]);
              await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'Lieferant', [(await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(alterArtikel, 'Lieferant.objectId')),'\''].join(''))).setPageSize(10)))[0]]);
              await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'ArtNrExt', [(await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectIdArtikel')),'\''].join(''))).setPageSize(100)))[0]]);
              await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(alterArtikel, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(alterArtikel, 'Bemerkung')),[`Datum`]: (new Date()),[`deletedInfo`]: ['Artikel wurde durch Artnr ',(getObjectProperty(neuerArtikel, 'ArtikelID')),' ersetzt.','Aenderungsinfo: ',(getObjectProperty(___arguments.context.pageData, 'valueAenderungsinfoMulti'))].join(''),[`deleteOrUpdate`]: 'C',[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`Kundennr`]: (getObjectProperty(((await Backendless.Data.of('ArtikelInLagerplatzDetails').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(getObjectProperty(alterArtikel, 'LagerplatzID')),'\''].join(''))).setPageSize(100)))[0]), 'Kundennr')),[`LagerplatzID`]: (getObjectProperty(alterArtikel, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(alterArtikel, 'PosNr')),[`Vorrat`]: (getObjectProperty(alterArtikel, 'Vorrat')),[`objectIdFromList`]: (getObjectProperty(alterArtikel, 'objectId')),[`WoVe`]: (getObjectProperty(alterArtikel, 'WoVe')),[`BestellenUnter`]: (getObjectProperty(alterArtikel, 'BestellenUnter')),[`objectIdLink`]: (getObjectProperty(savedObject, 'objectId')) }) );
              await Backendless.Data.of('ArtikelInLagerplatz').remove( alterArtikel );
              ___arguments.context.pageData['whereClauseArtikelInListe'] = (String('LagerplatzID=\'\''));
              ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));
              ___arguments.context.pageData['WhereClauseArtikelInListen'] = (['ArtikelID=\'',(getObjectProperty(___arguments.context.pageData, 'ArtikelID')),'\''].join(''));
              counter = counter + 1;

            } catch (error) {
              (function (message) { alert(message) })(error);

            }
          }
          offset = offset + 100;
        }
        (function (message) { alert(message) })((['Fertig! Es wurden ',counter,' Datensätze verarbeitet.'].join('')));
      }

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelChangePage/components/b1b79328156c1dc86bdbd868ad98fa72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, alterArtikel, savedObject, neuerArtikel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'valueAenderungsinfoEinzel')).length) {
    (function (message) { alert(message) })('Bitte Aenderungsinfo eingeben');
  } else {
    try {
      if (!!(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')).length && !!(getObjectProperty(___arguments.context.pageData, 'objectIdArtikel')).length) {
        alterArtikel = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''))).setPageSize(10)))[0];
        neuerArtikel = ({ [`ArtikelID`]: (getObjectProperty(___arguments.context.pageData, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(___arguments.context.pageData, 'ValueBemerkungNeu')),[`LagerplatzID`]: (getObjectProperty(alterArtikel, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(alterArtikel, 'PosNr')),[`Vorrat`]: (getObjectProperty(___arguments.context.pageData, 'ValueVorratNeu')),[`WoVe`]: (getObjectProperty(___arguments.context.pageData, 'ValueWoVeNeu')),[`BestellenUnter`]: (getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnterNeu')),[`Verfallskontrolle`]: (getObjectProperty(___arguments.context.pageData, 'Verfallskontrolle')) });
        savedObject = (await Backendless.Data.of('ArtikelInLagerplatz').save( neuerArtikel ));
        await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'LagerplatzIdExt', [(await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))).setPageSize(10)))[0]]);
        await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'ArtNrExt', [(await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectIdArtikel')),'\''].join(''))).setPageSize(10)))[0]]);
        await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'Lieferant', [(await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueLieferant')),'\''].join(''))).setPageSize(10)))[0]]);
        await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`objectIdFromList`]: (getObjectProperty(alterArtikel, 'objectId')),[`ArtikelID`]: (getObjectProperty(alterArtikel, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(alterArtikel, 'Bemerkung')),[`Datum`]: (new Date()),[`deletedInfo`]: ['Artikel wurde durch Artnr ',(getObjectProperty(neuerArtikel, 'ArtikelID')),' ersetzt.','Aenderungsinfo:',(getObjectProperty(___arguments.context.pageData, 'valueAenderungsinfoEinzel'))].join(''),[`deleteOrUpdate`]: 'C',[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`Kundennr`]: (getObjectProperty(___arguments.context.pageData, 'Kundennr')),[`LagerplatzID`]: (getObjectProperty(alterArtikel, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(alterArtikel, 'PosNr')),[`Vorrat`]: (getObjectProperty(alterArtikel, 'Vorrat')),[`WoVe`]: (getObjectProperty(alterArtikel, 'WoVe')),[`BestellenUnter`]: (getObjectProperty(alterArtikel, 'BestellenUnter')),[`objectIdLink`]: (getObjectProperty(savedObject, 'objectId')) }) );
        await Backendless.Data.of('ArtikelInLagerplatz').remove( alterArtikel );
        ___arguments.context.pageData['whereClauseArtikelInListe'] = (String('LagerplatzID=\'\''));
        ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));
        ___arguments.context.pageData['WhereClauseArtikelInListen'] = (['ArtikelID=\'',(getObjectProperty(___arguments.context.pageData, 'ArtikelID')),'\''].join(''));
        ___arguments.context.pageData['ValueBemerkungNeu'] = '';
        ___arguments.context.pageData['ValueVorratNeu'] = '';
        ___arguments.context.pageData['ValueWoVeNeu'] = '';
        ___arguments.context.pageData['ValueBestellenUnterNeu'] = '';
        ___arguments.context.pageData['valueAenderungsinfoEinzel'] = '';
      } else {
        (function (message) { alert(message) })('Keine Auswahl getroffen');
      }

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))


define('./pages/ArtikelChangePage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('Artikel', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelChangePage/components/4f1f7d689e62797d7397072d351df0de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelChangePage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var artikelItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
  ___arguments.context.pageData['whereClauseBestellteArtikel'] = (['objectIdInit = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'objectId')),'\''].join(''));
  ___arguments.context.pageData['whereClauseChart'] = (['OBJECTIDINIT = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'objectId')),'\''].join(''));
  ___arguments.context.pageData['valueArtnr'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'ArtikelID'));
  artikelItem = (await Backendless.Data.of('ArtikelInLagerplatz').loadRelations((getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'objectId')), Backendless.LoadRelationsQueryBuilder.create().setRelationName('ArtNrExt').setPageSize(1).setOffset(0)))[0];
  if (!(typeof artikelItem === 'undefined')) {
    ___arguments.context.pageData['valueBezeichnung'] = (getObjectProperty(artikelItem, 'Bez1'));
  } else {
    ___arguments.context.pageData['valueBezeichnung'] = 'Keine Bezeichnung gefunden';
  }
  ___arguments.context.pageData['valueWove'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'WoVe'));
  ___arguments.context.pageData['valueVorrat'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'Vorrat'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/6792b77bb569c3c81121339326781175/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EinstellungenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ProduktePage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelInLagerplatzDetailsPage/components/8a186a7860083ff8f9c89f03b89f027d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'whereClauseChart')));

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['whereClauseChart'] = (['OBJECTIDINIT = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'ArtikelInLagerplatz')), 'objectId')),'\''].join(''));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/ArtikelPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ArtikelPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/d25a38a928abe2d868b3e2385434529b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelChangePage', ___arguments.context.appData);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/b5d8a9683fc895a8c328dfc8a9988968/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
    var i, listPreise, bisWert, listStaffeln, preise, preiseTemp, staffeln, staffelTemp, help;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['ValueArtnr'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));
  ___arguments.context.pageData['ValueBez1'] = (getObjectProperty(___arguments.selectedRecord, 'Bez1'));
  ___arguments.context.pageData['ValueArtikelgruppe'] = (getObjectProperty(___arguments.selectedRecord, 'Artikelgruppe'));
  ___arguments.context.pageData['ValueBez2'] = (getObjectProperty(___arguments.selectedRecord, 'Bez2'));
  ___arguments.context.pageData['ValueBez3'] = (getObjectProperty(___arguments.selectedRecord, 'Bez3'));
  ___arguments.context.pageData['ValueBez4'] = (getObjectProperty(___arguments.selectedRecord, 'Bez4'));
  ___arguments.context.pageData['ValueEk'] = (getObjectProperty(___arguments.selectedRecord, 'Ek'));
  ___arguments.context.pageData['ValueGtin1'] = (getObjectProperty(___arguments.selectedRecord, 'Gtin1'));
  ___arguments.context.pageData['ValueGtin2'] = (getObjectProperty(___arguments.selectedRecord, 'Gtin2'));
  ___arguments.context.pageData['ValueGtin3'] = (getObjectProperty(___arguments.selectedRecord, 'Gtin3'));
  ___arguments.context.pageData['ValuePreiseinheit'] = (getObjectProperty(___arguments.selectedRecord, 'Preiseinheit'));
  ___arguments.context.pageData['ValuePzn'] = (getObjectProperty(___arguments.selectedRecord, 'Pzn'));
  ___arguments.context.pageData['ValueRabgr'] = (getObjectProperty(___arguments.selectedRecord, 'Rabgr'));
  if ((getObjectProperty(___arguments.selectedRecord, 'SSB')) == null) {
    ___arguments.context.pageData['ValueSSB'] = 'Nein';
  } else if ((getObjectProperty(___arguments.selectedRecord, 'SSB')) == '*') {
    ___arguments.context.pageData['ValueSSB'] = 'Ja (*)';
  } else {
    ___arguments.context.pageData['ValueSSB'] = (getObjectProperty(___arguments.selectedRecord, 'SSB'));
  }
  ___arguments.context.pageData['ValueStaffelpreise'] = (getObjectProperty(___arguments.selectedRecord, 'Staffelpreise'));
  ___arguments.context.pageData['ValueVerkaufseinheit'] = (getObjectProperty(___arguments.selectedRecord, 'Verkaufseinheit'));
  ___arguments.context.pageData['ValueVk1'] = (getObjectProperty(___arguments.selectedRecord, 'Vk1'));
  ___arguments.context.pageData['ValueWarengruppe'] = (getObjectProperty(___arguments.selectedRecord, 'Warengruppe'));
  ___arguments.context.pageData['ValuePictureUrl'] = (['https://eu.backendlessappcontent.com/1D587F4E-EAEB-B148-FF91-47B0E1F88F00/console/szupsyktqbxmnwbhpufwohliqxdftnbwdqzz/files/view/Artikelbilder/',(getObjectProperty(___arguments.selectedRecord, 'Artnr')),'.jpg'].join(''));
  ___arguments.context.appData['Artnr'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));
  if ((getObjectProperty(___arguments.selectedRecord, 'Staffelpreise')) != null) {
    ___arguments.context.pageData['uiStaffelpreisResult'] = '';
    help = (getObjectProperty(___arguments.selectedRecord, 'Staffelpreise'));
    preise = help.slice(((help.indexOf(':') + 1 + 1) - 1), help.length);
    staffeln = help.slice(0, (help.indexOf(':') + 1) - 1);
    listStaffeln = [];
    listPreise = [];
    while (!!staffeln.length) {
      staffelTemp = staffeln.slice(0, (staffeln.indexOf('/') + 1) - 1);
      staffeln = staffeln.slice(((staffeln.indexOf('/') + 1 + 1) - 1), staffeln.length);
      addItemToList(listStaffeln, staffelTemp);
      if (staffeln.indexOf('/') + 1 == 0) {
        addItemToList(listStaffeln, staffeln);
        staffeln = '';
      }
    }
    while (!!preise.length) {
      preiseTemp = preise.slice(0, (preise.indexOf(';') + 1) - 1);
      preise = preise.slice(((preise.indexOf(';') + 1 + 1) - 1), preise.length);
      addItemToList(listPreise, preiseTemp);
      if (preise.indexOf(';') + 1 == 0) {
        addItemToList(listPreise, preise);
        preise = '';
      }
    }
    var i_end = listStaffeln.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      if (i + 1 <= listStaffeln.length) {
        bisWert = listStaffeln[((i + 1) - 1)] - 1;
      } else {
        bisWert = '';
      }
      ___arguments.context.pageData['uiStaffelpreisResult'] = ([(getObjectProperty(___arguments.context.pageData, 'uiStaffelpreisResult')),listStaffeln[(i - 1)],'-',bisWert,'   |   ',listPreise[(i - 1)],' €','\n'].join(''));
    }
  } else {
    ___arguments.context.pageData['uiStaffelpreisResult'] = '';
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/ArtikelPage/components/c16fce55698ecbc7b6f60d0b503e27f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/e0f862c8ab253a5c38c8d7b86d083e68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('c588f7f1bd38b706fb98a76866f342ac');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/53b80658a278393878ff6388ada7e93d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('c588f7f1bd38b706fb98a76866f342ac');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/5b85d2e77fb56038e9084178a7950938/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputArtnr')) == '' || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputArtnr')) === 'undefined')) {
    (function (message) { alert(message) })('Artikelnummer muss ausgefüllt werden! Wenn nur eine PZN vorhanden ist, dann diese bitte auch bei der Artikeln eintragen!');
  } else if ((await Backendless.Data.of('Artikel').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputArtnr')),'\''].join(''))))) > 0) {
    (function (message) { alert(message) })('Artikelnummer bereits vorhanden!');
  } else {
    try {
      result = (await Backendless.Data.of('Artikel').save( ({ [`Artnr`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputArtnr')),[`Pzn`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputPzn')),[`Bez1`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung1')),[`Bez2`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung2')),[`Bez3`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung3')),[`Bez4`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung4')),[`Gtin1`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputGtin1')),[`Gtin2`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputGtin2')),[`ManuellerArtikel`]: true }) ));
      if (result !== null && !Array.isArray(result) && (typeof result === 'object')) {
        ___arguments.context.pageData['ValueArtnr'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputArtnr'));
        ___arguments.context.pageData['ValueBez1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung1'));
        ___arguments.context.pageData['ValueBez2'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung2'));
        ___arguments.context.pageData['ValueBez3'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung3'));
        ___arguments.context.pageData['ValueBez4'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBezeichnung4'));
        ___arguments.context.pageData['ValueGtin1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputGtin1'));
        ___arguments.context.pageData['ValueGtin2'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputGtin2'));
        ___arguments.context.pageData['ValuePzn'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputPzn'));
        ___arguments.context.pageData['whereClauseLogic'] = (['Artnr = \'',(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputArtnr')),'\''].join(''));
        await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('1be891f80dc8d4795b68980814fad8af');
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputArtnr'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputPzn'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputBezeichnung1'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputBezeichnung2'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputBezeichnung3'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputBezeichnung4'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputGtin1'] = '';
        ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputGtin2'] = '';
      } else {
        (function (message) { alert(message) })('Speichern fehlgeschlagen!');
      }

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ArtikelPage/components/1be891f80dc8d4795b68980814fad8af/bundle.js', [], () => ({
  /* content */
  /* handler:onConfirm */
  async ['onConfirm'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('c588f7f1bd38b706fb98a76866f342ac');

  },
  /* handler:onConfirm */
  /* handler:onDeny */
  async ['onDeny'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('c588f7f1bd38b706fb98a76866f342ac');

  },
  /* handler:onDeny */
  /* handler:onDismiss */
  async ['onDismiss'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('c588f7f1bd38b706fb98a76866f342ac');

  },
  /* handler:onDismiss */
  /* content */
}))

define('./pages/BestellungenAllPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
  ___arguments.context.pageData['mail'] = '';
  ___arguments.context.pageData['disableSendButton'] = true;
  ___arguments.context.pageData['uiKundennummer'] = (getObjectProperty(___arguments.context.appData, 'Kundennr'));
  ___arguments.context.pageData['alleArtikelChecked'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/BestellungenAllPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/6792b77bb569c3c81121339326781175/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EinstellungenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ProduktePage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenAllPage/components/aea880e476ca3a88a3c892c803f8f843/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['whereClauseBestellungen'] = (['ID_EXT = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT')),'\''].join(''));
  ___arguments.context.pageData['tourObjectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/BestellungenAllPage/components/1ba3e3e89fa8b4e89ccb0cc875380418/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ID_EXT_ARTIKEL'] = (getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL'));
  ___arguments.context.pageData['anzahlArtikelValue'] = (await Backendless.Data.of('ArtikelInBestellung').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL')),'\''].join('')))));
  if ((getObjectProperty(___arguments.context.pageData, 'alleArtikelChecked')) == true) {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL')),'\''].join(''));
  } else {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''));
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/BestellungenAllPage/components/499586459dc8f2b89868f3b4e87857fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['alleArtikelChecked'] = ___arguments.value;
  if (___arguments.value == true) {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.context.pageData, 'ID_EXT_ARTIKEL')),'\''].join(''));
  } else {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.context.pageData, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BestellungenAllPage/components/7c18d35b8c01bcb8250dd05823c56f68/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error, lagerplatz, artikelInListe;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    artikelInListe = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.selectedRecord, 'objectIdInit')),'\''].join(''))).setPageSize(1)))[0];
    if (!(typeof artikelInListe === 'undefined')) {
      lagerplatz = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(artikelInListe, 'LagerplatzID')),'\''].join(''))).setPageSize(1)))[0];
      if (!(typeof lagerplatz === 'undefined')) {
        ___arguments.context.pageData['valueLagerplatz'] = (getObjectProperty(lagerplatz, 'LagerplatzName'));
      } else {
        ___arguments.context.pageData['valueLagerplatz'] = 'Lagerplatz nicht mehr vorhanden.';
      }
    } else {
      ___arguments.context.pageData['valueLagerplatz'] = 'Nicht gefunden. Artikel wurde geändert.';
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/BestellungenAllPage/components/17bd4e9d05090ba808883fa664665034/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'mail')).length > 0 && (getObjectProperty(___arguments.context.pageData, 'mail')).indexOf('.') + 1 > 0 && (getObjectProperty(___arguments.context.pageData, 'mail')).indexOf('@') + 1 > 0) {
    ___arguments.context.pageData['disableSendButton'] = false;
  } else {
    ___arguments.context.pageData['disableSendButton'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BestellungenAllPage/components/bf98e6e82eaf5fafee1353392c78034b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var artikelItem, bestellungItem, error, fileText, offset, realTour, tempList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'tourObjectId')) === 'undefined') {
      (function (message) { alert(message) })('Bitte Tour auswählen');
    } else if ((getObjectProperty(___arguments.context.pageData, 'mail')).indexOf('@mar-med.de') + 1 == 0) {
      (function (message) { alert(message) })('Aktuell ist das Senden nur an @mar-med.de Adressen möglich.');
    } else {
      fileText = '';
      realTour = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'tourObjectId')),'\''].join(''))).setPageSize(10)))[0];
      fileText = String(fileText) + String(['Hauptkundennummer:;',(getObjectProperty(realTour, 'KundeID')),'\n','Name:;',(getObjectProperty(realTour, 'Name')),'\n','Datum:;',[(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getDate()),'.',(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getMonth() + 1),'.',(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getFullYear())].join(''),'\n','\n'].join(''));
      var bestellungItem_list = (await Backendless.Data.of('Bestellungen').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT = \'',(getObjectProperty(realTour, 'ID_EXT')),'\''].join(''))).setPageSize(100)));
      for (var bestellungItem_index in bestellungItem_list) {
        bestellungItem = bestellungItem_list[bestellungItem_index];
        fileText = String(fileText) + String(['Kundennummer:;',(getObjectProperty(bestellungItem, 'Kundennr')),'\n','Name:;',(getObjectProperty(bestellungItem, 'Name')),'\n','Beschreibung:;',(getObjectProperty(bestellungItem, 'Beschreibung')),'\n','Erfasser:;',(getObjectProperty(bestellungItem, 'Erfasser')),'\n','\n'].join(''));
        fileText = String(fileText) + String(['Artnr;','Bezeichnung;','Ist-Bestand;','Bestellmenge;','BestellmengePaketdienst;','Vorrat;','WoVe;','\n',''].join(''));
        offset = 0;
        while (true) {
          tempList = [];
          tempList = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(bestellungItem, 'ID_EXT_ARTIKEL')),'\''].join(''))).setPageSize(100).setOffset(offset)));
          if (tempList.length == 0) {
            break;
          }
          for (var artikelItem_index in tempList) {
            artikelItem = tempList[artikelItem_index];
            fileText = String(fileText) + String([(getObjectProperty(artikelItem, 'ArtikelID')),';',(getObjectProperty(artikelItem, 'Bezeichnung')),';',(getObjectProperty(artikelItem, 'IstBestand')),';',(getObjectProperty(artikelItem, 'Bestellmenge')),';',(getObjectProperty(artikelItem, 'BestellmengePaketdienst')),';',(getObjectProperty(artikelItem, 'Vorrat')),';',(getObjectProperty(artikelItem, 'WoVe')),';','\n'].join(''));
          }
          offset = 100 + offset;
        }
        fileText = String(fileText) + String('\n \n \n');
      }
      (function (message) { alert(message) })(fileText);
      await Backendless.Files.saveFile(encodePath('/'), 'DataBestellung.csv', fileText, true);
      await Backendless.Messaging.sendEmail('marmed superstore - CSV-Datei', new Backendless.Bodyparts({ textmessage: (['Guten Tag,','\n \n','anbei erhalten Sie die angeforderten Daten als CSV-Datei. Sie können diese mit Excel oder ähnlichen Programmen öffnen.','\n \n','Ihr','\n','marmed superstore - Team'].join('')) }), ensureArray((getObjectProperty(___arguments.context.pageData, 'mail'))), ensureArray('/DataBestellung.csv').filter(item => !!item));
      (function (message) { alert(message) })('Ausgeführt');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
  ___arguments.context.pageData['mail'] = '';
  ___arguments.context.pageData['disableSendButton'] = true;
  ___arguments.context.pageData['uiKundennummer'] = (getObjectProperty(___arguments.context.appData, 'Kundennr'));
  if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['whereClauseRealTour'] = (['KundeID = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''));
    ___arguments.context.pageData['Zusatztext'] = '';
  } else if ((await Backendless.Data.of('BereicheInTouren').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['KundennrAuftrag = \'',(getObjectProperty(___arguments.context.appData, 'TourKundeID')),'\''].join(''))))) > 0) {
    ___arguments.context.pageData['whereClauseRealTour'] = (['KundeID = \'',(getObjectProperty(((await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundennrAuftrag = \'',(getObjectProperty(___arguments.context.appData, 'TourKundeID')),'\''].join(''))).setPageSize(1)))[0]), 'KundeTourID')),'\''].join(''));
    ___arguments.context.pageData['uiKundennummer'] = (getObjectProperty(___arguments.context.appData, 'TourKundeID'));
    ___arguments.context.pageData['Zusatztext'] = (['(',(getObjectProperty(___arguments.context.appData, 'Kundennr')),')'].join(''));
  } else {
    (function (message) { alert(message) })('Keine Bestellungen vorhanden! Sie werden zurückgeleitet!');
    (function () { window.history.back(); })();
  }
  ___arguments.context.pageData['whereClauseBestellungen'] = (['ID_EXT = \'','','\''].join(''));
  ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'','','\''].join(''));
  ___arguments.context.pageData['alleArtikelChecked'] = false;
  ___arguments.context.pageData['valueBestellwert'] = ' --- €';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/BestellungenPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/6792b77bb569c3c81121339326781175/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EinstellungenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ProduktePage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/BestellungenPage/components/aea880e476ca3a88a3c892c803f8f843/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['whereClauseBestellungen'] = (['ID_EXT = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT')),'\''].join(''));
  ___arguments.context.pageData['tourObjectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/BestellungenPage/components/1ba3e3e89fa8b4e89ccb0cc875380418/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ID_EXT_ARTIKEL'] = (getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL'));
  ___arguments.context.pageData['anzahlArtikelValue'] = (await Backendless.Data.of('ArtikelInBestellung').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL')),'\''].join('')))));
  if ((getObjectProperty(___arguments.context.pageData, 'alleArtikelChecked')) == true) {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL')),'\''].join(''));
  } else {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.selectedRecord, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''));
  }
  ___arguments.context.pageData['valueBestellwert'] = (String(getObjectProperty(___arguments.selectedRecord, 'BestellWertBestellung')) + String(' €'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/BestellungenPage/components/499586459dc8f2b89868f3b4e87857fc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['alleArtikelChecked'] = ___arguments.value;
  if (___arguments.value == true) {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.context.pageData, 'ID_EXT_ARTIKEL')),'\''].join(''));
  } else {
    ___arguments.context.pageData['whereClauseArtikelInBestellung'] = (['ID_EXT_ARTIKEL = \'',(getObjectProperty(___arguments.context.pageData, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BestellungenPage/components/7c18d35b8c01bcb8250dd05823c56f68/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error, lagerplatz, artikelInListe;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    artikelInListe = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.selectedRecord, 'objectIdInit')),'\''].join(''))).setPageSize(1)))[0];
    if (!(typeof artikelInListe === 'undefined')) {
      lagerplatz = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(artikelInListe, 'LagerplatzID')),'\''].join(''))).setPageSize(1)))[0];
      if (!(typeof lagerplatz === 'undefined')) {
        ___arguments.context.pageData['valueLagerplatz'] = (getObjectProperty(lagerplatz, 'LagerplatzName'));
      } else {
        ___arguments.context.pageData['valueLagerplatz'] = 'Lagerplatz nicht mehr vorhanden.';
      }
    } else {
      ___arguments.context.pageData['valueLagerplatz'] = 'Nicht gefunden. Artikel wurde geändert.';
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/BestellungenPage/components/17bd4e9d05090ba808883fa664665034/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'mail')).length > 0 && (getObjectProperty(___arguments.context.pageData, 'mail')).indexOf('.') + 1 > 0 && (getObjectProperty(___arguments.context.pageData, 'mail')).indexOf('@') + 1 > 0) {
    ___arguments.context.pageData['disableSendButton'] = false;
  } else {
    ___arguments.context.pageData['disableSendButton'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/BestellungenPage/components/bf98e6e82eaf5fafee1353392c78034b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, fileText, offset, artikelStammItem, adressItem, artikelItem, tempList, bestellungItem, kundeItem, realTour;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'tourObjectId')) === 'undefined') {
      (function (message) { alert(message) })('Bitte Tour auswählen');
    } else if ((getObjectProperty(___arguments.context.pageData, 'mail')).indexOf('@mar-med.de') + 1 == 0) {
      (function (message) { alert(message) })('Aktuell ist das Senden nur an @mar-med.de Adressen möglich.');
    } else {
      fileText = '';
      realTour = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'tourObjectId')),'\''].join(''))).setPageSize(10)))[0];
      fileText = String(fileText) + String(['Hauptkundennummer:;',(getObjectProperty(realTour, 'KundeID')),'\n','Name:;',(getObjectProperty(realTour, 'Name')),'\n','Datum:;',[(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getDate()),'.',(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getMonth() + 1),'.',(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getFullYear())].join(''),'\n','\n'].join(''));
      var bestellungItem_list = (await Backendless.Data.of('Bestellungen').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT = \'',(getObjectProperty(realTour, 'ID_EXT')),'\''].join(''))).setPageSize(100)));
      for (var bestellungItem_index in bestellungItem_list) {
        bestellungItem = bestellungItem_list[bestellungItem_index];
        kundeItem = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr = \'',(getObjectProperty(bestellungItem, 'Kundennr')),'\''].join(''))).setPageSize(10)))[0];
        adressItem = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id = \'',!((getObjectProperty(kundeItem, 'Lieferadrid')) === null) ? (getObjectProperty(kundeItem, 'Lieferadrid')) : (!((getObjectProperty(kundeItem, 'Rgadrid')) === null) ? (getObjectProperty(kundeItem, 'Rgadrid')) : (getObjectProperty(kundeItem, 'Abadrid'))),'\''].join(''))).setPageSize(10)))[0];
        fileText = String(fileText) + String(['Kundennummer:;',(getObjectProperty(bestellungItem, 'Kundennr')),'\n','Name:;',(getObjectProperty(bestellungItem, 'Name')),'\n','Beschreibung:;',(getObjectProperty(bestellungItem, 'Beschreibung')),'\n','Erfasser:;',(getObjectProperty(bestellungItem, 'Erfasser')),'\n','\n'].join(''));
        fileText = String(fileText) + String(['Artnr;','Bezeichnung;','Ist-Bestand;','Bestellmenge;','BestellmengePaketdienst;','Vorrat;','WoVe;','SSB;','\n'].join(''));
        offset = 0;
        while (true) {
          tempList = [];
          tempList = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(bestellungItem, 'ID_EXT_ARTIKEL')),'\''].join(''))).setPageSize(100).setOffset(offset)));
          if (tempList.length == 0) {
            break;
          }
          for (var artikelItem_index in tempList) {
            artikelItem = tempList[artikelItem_index];
            artikelStammItem = (await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(artikelItem, 'ArtikelID')),'\''].join(''))).setPageSize(10)))[0];
            if (typeof artikelStammItem === 'undefined') {
              (function (message) { alert(message) })((getObjectProperty(artikelItem, 'ArtikelID')));
              (function (message) { alert(message) })((JSON.stringify(artikelStammItem)));
            }
            if (typeof artikelItem === 'undefined') {
              (function (message) { alert(message) })('UND');
              (function (message) { alert(message) })((JSON.stringify(artikelStammItem)));
            }
            if (typeof adressItem === 'undefined') {
              (function (message) { alert(message) })((getObjectProperty(artikelItem, 'ArtikelID')));
              (function (message) { alert(message) })((JSON.stringify(artikelStammItem)));
            }
            fileText = String(fileText) + String([(getObjectProperty(artikelItem, 'ArtikelID')),';',(getObjectProperty(artikelItem, 'Bezeichnung')),';',((JSON.stringify((getObjectProperty(artikelItem, 'IstBestand')))).replace('.', ',')),';',((JSON.stringify((getObjectProperty(artikelItem, 'Bestellmenge')))).replace('.', ',')),';',((JSON.stringify((getObjectProperty(artikelItem, 'BestellmengePaketdienst')))).replace('.', ',')),';',((JSON.stringify((getObjectProperty(artikelItem, 'Vorrat')))).replace('.', ',')),';',((JSON.stringify((getObjectProperty(artikelItem, 'WoVe')))).replace('.', ',')),';',(adressItem !== null && !Array.isArray(adressItem) && (typeof adressItem === 'object')) && (artikelStammItem !== null && !Array.isArray(artikelStammItem) && (typeof artikelStammItem === 'object')) ? (((getObjectProperty(artikelStammItem, 'SSB')) === null) ? 'nein' : (((getObjectProperty(artikelStammItem, 'SSB')).indexOf((getObjectProperty(adressItem, 'Bundesland'))) !== -1) || ((getObjectProperty(artikelStammItem, 'SSB')).indexOf('*') !== -1) ? 'ja' : 'nein')) : 'Keine Info',';','\n'].join(''));
          }
          offset = 100 + offset;
        }
        fileText = String(fileText) + String('\n \n \n');
      }
      await Backendless.Files.saveFile(encodePath('/'), 'DataBestellung.csv', fileText, true);
      await Backendless.Messaging.sendEmail('marmed superstore - CSV-Datei', new Backendless.Bodyparts({ textmessage: (['Moin, ','\n \n','anbei erhältst du die angeforderten Daten als CSV-Datei. Sie können diese mit Excel oder ähnlichen Programmen öffnen.','\n \n','Ihr','\n','marmed superstore - Team'].join('')) }), ensureArray((getObjectProperty(___arguments.context.pageData, 'mail'))), ensureArray('/DataBestellung.csv').filter(item => !!item));
      (function (message) { alert(message) })('Ausgeführt');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(''));
  ___arguments.context.pageData['InputUser'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'));
  ___arguments.context.pageData['whereClause'] = (['User = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\''].join(''));
  ___arguments.context.pageData['InputKennzeichen'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'FirmenFahrzeugKennzeichen'));
  ___arguments.context.pageData['Wert'] = '0,00 €';
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('67a81848e624718b296fa58ec5b8fc38', [({ [`label`]: '1',[`value`]: '1' }), ({ [`label`]: '2',[`value`]: '2' }), ({ [`label`]: '3',[`value`]: '3' }), ({ [`label`]: '4',[`value`]: '4' }), ({ [`label`]: '5',[`value`]: '5' }), ({ [`label`]: '6',[`value`]: '6' }), ({ [`label`]: '7',[`value`]: '7' }), ({ [`label`]: '8',[`value`]: '8' }), ({ [`label`]: '9',[`value`]: '9' }), ({ [`label`]: '10',[`value`]: '10' }), ({ [`label`]: '11',[`value`]: '11' }), ({ [`label`]: '12',[`value`]: '12' })]);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('67a81848e624718b296fa58ec5b8fc38', ((new Date((new Date())).getMonth() + 1) == 1 ? 12 : (new Date((new Date())).getMonth() + 1) - 1));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('6d28ee9f1f083e988d5f68187e48c3f8', [({ [`label`]: (new Date((new Date())).getFullYear()) - 1,[`value`]: (new Date((new Date())).getFullYear()) - 1 }), ({ [`label`]: (new Date((new Date())).getFullYear()),[`value`]: (new Date((new Date())).getFullYear()) }), ({ [`label`]: (new Date((new Date())).getFullYear()) + 1,[`value`]: (new Date((new Date())).getFullYear()) + 1 })]);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6d28ee9f1f083e988d5f68187e48c3f8', ((new Date((new Date())).getMonth() + 1) == 1 ? (new Date((new Date())).getFullYear()) - 1 : (new Date((new Date())).getFullYear())));
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('8f8888581658cafc814852eccfda40b8', [({ [`label`]: 'Zuhause',[`value`]: 'Zuhause' })]);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8f8888581658cafc814852eccfda40b8', 'Zuhause');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/CarCharging/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TourArchivePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/10f7415fcd5b728b74ca76696c188d26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ArtikelChangePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SettingsPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/cca63bc26a26a9384308eff8bf1feafe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TempControlPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/d97c71e87a380fc4357fe4ce03e5c608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('CarChargingMain', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/be58471b8007f36b05cdf034a7788d78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, checkValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'fileurl')) === 'undefined') {
      (function (message) { alert(message) })('Keine Datei hochgeladen');
    } else {
      checkValue = true;
      if (typeof (getObjectProperty(___arguments.context.pageData, 'RadioButtonValue')) === 'undefined') {
        checkValue = false;
      } else if ((typeof (getObjectProperty(___arguments.context.pageData, 'InputKwh')) === 'undefined') || (getObjectProperty(___arguments.context.pageData, 'InputKwh')) <= 0) {
        checkValue = false;
      } else if (typeof (getObjectProperty(___arguments.context.pageData, 'InputUser')) === 'undefined') {
        checkValue = false;
      } else if (typeof (getObjectProperty(___arguments.context.pageData, 'InputKennzeichen')) === 'undefined') {
        checkValue = false;
      }
      if (checkValue == false) {
        (function (message) { alert(message) })('Nicht alle Felder ausgefüllt oder ausgewählt!');
      } else {
        if ((await Backendless.Data.of('ElectricCarCharging').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Monat = ',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('67a81848e624718b296fa58ec5b8fc38')),' and Jahr = ',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('6d28ee9f1f083e988d5f68187e48c3f8')),' and Kennzeichen = \'',(getObjectProperty(___arguments.context.pageData, 'InputKennzeichen')),'\''].join(''))))) == 0) {
          await Backendless.Data.of('ElectricCarCharging').save(({ [`Datum`]: (new Date()),[`Monat`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('67a81848e624718b296fa58ec5b8fc38')),[`Jahr`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('6d28ee9f1f083e988d5f68187e48c3f8')),[`Kennzeichen`]: (getObjectProperty(___arguments.context.pageData, 'InputKennzeichen')),[`User`]: (getObjectProperty(___arguments.context.pageData, 'InputUser')),[`KwhGesamt`]: (getObjectProperty(___arguments.context.pageData, 'InputKwh')),[`LocationChargingStation`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('8f8888581658cafc814852eccfda40b8')),[`FahrzeugAnzahlHaushalt`]: (getObjectProperty(___arguments.context.pageData, 'RadioButtonValue')),[`File`]: (getObjectProperty(___arguments.context.pageData, 'fileurl')),[`Wert`]: (getObjectProperty(___arguments.context.pageData, 'RawWert')) }), true);
          ___arguments.context.pageData['whereClause'] = (String('User = \'') + String('\''));
          ___arguments.context.pageData['whereClause'] = (['User = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'\''].join(''));
          await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('1248f7d8e5a860b89378d64d80789bf3');
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4390ad36ae1b7b815684ba8c30b62fb', false);
          ___arguments.context.pageData['FileNameContent'] = '';
          (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('7f88b4683b4807a39fb8246f60781648');
          await Backendless.Messaging.sendEmail('Neue Beantragung für das Laden zuhause', new Backendless.Bodyparts({ textmessage: (['Datum: ',(new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth() + 1),'.',(new Date((new Date())).getFullYear()),'\n','Mitarbeiter: ',(getObjectProperty(___arguments.context.pageData, 'InputUser')),'\n','Kennzeichen: ',(getObjectProperty(___arguments.context.pageData, 'InputKennzeichen')),'\n','Monat/Jahr: ',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('67a81848e624718b296fa58ec5b8fc38')),'/',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('6d28ee9f1f083e988d5f68187e48c3f8')),'\n','Standort: ',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('8f8888581658cafc814852eccfda40b8')),'\n','kWh: ',(getObjectProperty(___arguments.context.pageData, 'InputKwh')),'\n','Preis pro kWh: ','0,3436 €','\n','Wert: ',(getObjectProperty(___arguments.context.pageData, 'Wert'))].join('')) }), ensureArray(['gerrit.marttila@mar-med.de', 'andrea.schlemmer@mar-med.de']), ensureArray([(getObjectProperty(___arguments.context.pageData, 'fileurl'))]).filter(item => !!item));
          ___arguments.context.pageData['fileurl'] = null;
          ___arguments.context.pageData['InputKwh'] = null;
          ___arguments.context.pageData['Wert'] = '0.00 €';
          ___arguments.context.pageData['RawWert'] = 0;
        } else {
          (function (message) { alert(message) })('Unter diesem Kennzeichen mit dem gleichen Monat und dem gleichen Jahr gibt es bereits Anträge!');
        }
      }
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/CarCharging/components/2c684a08c1b8e0688b787827e0e8460e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.checkedValue == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af44bffe52e8c278ede8fcd28a3f79b8', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('af44bffe52e8c278ede8fcd28a3f79b8', true);
  }
  ___arguments.context.pageData['RadioButtonValue'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/CarCharging/components/7f88b4683b4807a39fb8246f60781648/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
      ___arguments.context.pageData['FileNameContent'] = (String('Datei: ') + String(___arguments.uploadedFilesPath));
  ___arguments.context.pageData['fileurl'] = ___arguments.uploadedFilesPath;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4390ad36ae1b7b815684ba8c30b62fb', true);

  },
  /* handler:onUploadSuccess */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(generateUUID().long()),'_',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/CarCharging/components/f5d66ae17711799853f7db62d3a863ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  if (typeof ___arguments.value === 'number' && !isNaN(___arguments.value)) {
    ___arguments.context.pageData['Wert'] = (String(roundDecimals((___arguments.value * 0.3436),2)) + String(' €'));
    ___arguments.context.pageData['RawWert'] = (roundDecimals((___arguments.value * 0.3436),2));
  } else {
    ___arguments.context.pageData['Wert'] = '0.00 €';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, tempList, bereichVerschiebenList, offset, j, counter, weiter, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (!(await Backendless.UserService.isValidLogin())) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
    }
    if (typeof (getObjectProperty(___arguments.context.appData, 'Kundennr')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);
    } else {
      if ((getObjectProperty(___arguments.context.appData, 'Kundennr')) == null) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);
      }
    }
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'','KEINESUCHERGEBNISSEERZEUGEN','\''].join(''));
    ___arguments.context.pageData['visibleProgress'] = false;
    ___arguments.context.pageData['visibleSearch'] = true;
    ___arguments.context.pageData['bereichVerschiebenDisabled'] = true;
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fdd8d1c82f08215a4c1f6ec8b5cce446', (await Promise.all((await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setSortBy('Name1').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Name1')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fdd8d1c82f08215a4c1f6ec8b5cce446', '93AF5FEA-E48D-411A-A973-59E4AC3B6421');
    ___arguments.context.pageData['ValueLieferant'] = '93AF5FEA-E48D-411A-A973-59E4AC3B6421';
    ___arguments.context.pageData['whereClauseLagerplatz'] = (['BereichID=\'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''));
    ___arguments.context.pageData['contentHeader'] = (String('Einlagerungsliste: ') + String(getObjectProperty(___arguments.context.appData, 'Kundennr')));
    ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
    if ((await Backendless.Data.of('LagerplatzInBereich').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))))) == 0) {
      (function (message) { alert(message) })('Keine Lagerorte vorhanden!');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }
  try {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2408e8e84aa87318a2ec2f3692613593')), 'display')) == true) {
      offset = 0;
      counter = 0;
      bereichVerschiebenList = [];
      weiter = true;
      tempList = [];
      while (weiter) {
        tempList = [];
        tempList = (await Backendless.Data.of('BereicheView').find(Backendless.DataQueryBuilder.create().setSortBy('KundeID').setPageSize(100).setOffset(offset)));
        if (tempList.length == 0) {
          weiter = false;
        } else {
          for (var j_index in tempList) {
            j = tempList[j_index];
            counter = counter + 1;
            addItemToList(bereichVerschiebenList, j);
          }
        }
        offset = offset + 100;
      }
      tempList = [];
      for (var item_index in bereichVerschiebenList) {
        item = bereichVerschiebenList[item_index];
        addItemToList(tempList, ({ [`label`]: [(getObjectProperty(item, 'KundeID')),' | ',(getObjectProperty(item, 'Name')),' | ',(getObjectProperty(item, 'Bereich')),' | ',(getObjectProperty(item, 'Beschreibung'))].join(''),[`value`]: (getObjectProperty(item, 'objectIdBereich')) }));
      }
      (function (message) { alert(message) })('');
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('8cdf02e68d9f0708247876e84ef11cc8', (await Promise.all(tempList.map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'label')),[`value`]: (getObjectProperty(item, 'value')) });}))));
    }
    ___arguments.context.pageData['bereich'] = ((await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setPageSize(10)))[0]);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/5968ec682e78f0245268cea8bd6777f8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.selectedRecord, 'objectId')),'\''].join(''));
  ___arguments.context.pageData['LagerplatzID'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['LagerplatzObject'] = ___arguments.selectedRecord;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e00e2bfce368d255cc87fe587bc722ed', true);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/66f8f8983497e84e24e48518282b37c8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['showChangeButtonNeu'] = true;
  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'showChangeButtonStamm')) === 'undefined') && !(typeof (getObjectProperty(___arguments.context.pageData, 'showChangeButtonNeu')) === 'undefined')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ce6a35a8ae01844684a45f7fe6ea9b28', true);
  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Chargentyp')) == null) {
    ___arguments.context.pageData['Verfallskontrolle'] = false;
  } else {
    if ((getObjectProperty(___arguments.selectedRecord, 'Chargentyp')).indexOf('Verfall') + 1 == 0) {
      ___arguments.context.pageData['Verfallskontrolle'] = false;
    } else {
      ___arguments.context.pageData['Verfallskontrolle'] = true;
    }
  }
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fdd8d1c82f08215a4c1f6ec8b5cce446', '93AF5FEA-E48D-411A-A973-59E4AC3B6421');
  ___arguments.context.pageData['ArtikelID'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));
  ___arguments.context.pageData['PznId'] = (getObjectProperty(___arguments.selectedRecord, 'Pzn'));
  ___arguments.context.pageData['objectIdArtikel'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  if ((getObjectProperty(___arguments.selectedRecord, 'Aktiv')) == false) {
    (function (message) { alert(message) })('Achtung!!! Artikel ist inaktiv!');
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/3b8a556b64f10a3875f8ff080a3865ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error, offset, artikel, liste, item, artikelListe, lagerplatz, lagerplatzListe, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['whereClauseLagerplatz'] = (['BereichID=\'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''));

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var error, textListe, offset, j, gesamtAnzahl, liste;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == 13) {
    try {
      ___arguments.context.pageData['visibleProgress'] = true;
      ___arguments.context.pageData['visibleSearch'] = false;
      offset = 0;
      liste = [];
      textListe = '';
      gesamtAnzahl = (await Backendless.Data.of('ArtikelInLagerplatzDetails').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(ArtikelID LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\' or Bez1 LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\') and BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join('')))));
      while (offset <= gesamtAnzahl) {
        var j_list = (await Backendless.Data.of('ArtikelInLagerplatzDetails').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ArtikelID LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\' or Bez1 LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\') and BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setPageSize(100).setOffset(offset)));
        for (var j_index in j_list) {
          j = j_list[j_index];
          textListe = String(textListe) + String(['Lagerort: ',(getObjectProperty(j, 'LagerplatzName')),'\n',(getObjectProperty(j, 'ArtikelID')),'     ',(getObjectProperty(j, 'Bez1')),'\n','WoVe: ',(getObjectProperty(j, 'WoVe')),'     ','Vorrat: ',(getObjectProperty(j, 'Vorrat')),'\n \n'].join(''));
        }
        offset = offset + 100;
      }
      if (!textListe.length) {
        (function (message) { alert(message) })('Nichts gefunden!');
      } else {
        (function (message) { alert(message) })(textListe);
      }
      ___arguments.context.pageData['visibleProgress'] = false;
      ___arguments.context.pageData['visibleSearch'] = true;

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/e00e2bfce368d255cc87fe587bc722ed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, tempHistoryObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LagerplatzObject')), 'PosNr')) == 0 || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LagerplatzObject')), 'PosNr')) == 9999) {
    (function (message) { alert(message) })('Lagerorte "Neue Artikel" und "NB" können nicht gelöscht werden!');
  } else {
    if ((await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))))) > 0) {
      (function (message) { alert(message) })('Artikel noch vorhanden');
    } else {
      (function (message) { alert(message) })('Keine Artikel im Lagerplatz vorhanden. Lagerplatz wird gelöscht.');
      try {
        tempHistoryObject = ({ [`BereichID`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LagerplatzObject')), 'BereichID')),[`LagerplatzName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LagerplatzObject')), 'LagerplatzName')),[`KundeTourID`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LagerplatzObject')), 'KundeTourID')),[`objectIdInit`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'LagerplatzObject')), 'objectId')) });
        await Backendless.Data.of('LagerplatzInBereichHistory').save( tempHistoryObject );
        await Backendless.Data.of('LagerplatzInBereich').remove( (getObjectProperty(___arguments.context.pageData, 'LagerplatzID')) );
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e00e2bfce368d255cc87fe587bc722ed', false);
        ___arguments.context.pageData['whereClauseLagerplatz'] = '';
        ___arguments.context.pageData['whereClauseLagerplatz'] = (['BereichID=\'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''));

      } catch (error) {
        (function (message) { alert(message) })(error);

      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/4f08d7adc92919b8f68ee00850a5905e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, valueObjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ValueLagerplatz')) == 'Neue Artikel' || (getObjectProperty(___arguments.context.pageData, 'ValueLagerplatz')) == 'NB') {
    (function (message) { alert(message) })('Lagerplatz darf nicht NB oder neue Artikel heißen!');
  } else {
    try {
      valueObjectId = (await Backendless.Data.of('LagerplatzInBereich').save( ({ [`BereichID`]: (getObjectProperty(___arguments.context.appData, 'BereichID')),[`LagerplatzName`]: (getObjectProperty(___arguments.context.pageData, 'ValueLagerplatz')),[`PosNr`]: (await Backendless.Data.of('LagerplatzInBereich').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzName != \'Neue Artikel\' and LagerplatzName != \'NB\' and BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))))) + 1 }) ));
      await Backendless.Data.of('LagerplatzInBereich').setRelation(valueObjectId, 'BereichExt', [(await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setPageSize(10)))[0]]);
      ___arguments.context.pageData['ValueLagerplatz'] = '';
      ___arguments.context.pageData['whereClauseLagerplatz'] = '';
      ___arguments.context.pageData['whereClauseLagerplatz'] = (['BereichID=\'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''));

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/ad980a38cc0863412e01ed18a4e8ac78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, mailListe, mainText, headerText, partnerItem, vertreterItem, kunde, userName, aktuellItem, bezeichnung, user, bezeichnungItem, lagerort, bereich, savedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  if ((getObjectProperty(___arguments.context.pageData, 'ArtikelID')) != null && (getObjectProperty(___arguments.context.pageData, 'LagerplatzID')) != null) {
    try {
      savedObject = (await Backendless.Data.of('ArtikelInLagerplatz').save( ({ [`ArtikelID`]: (getObjectProperty(___arguments.context.pageData, 'ArtikelID')),[`LagerplatzID`]: (getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),[`WoVe`]: (typeof (getObjectProperty(___arguments.context.pageData, 'ValueWoVe')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'ValueWoVe')))) ? (getObjectProperty(___arguments.context.pageData, 'ValueWoVe')) : 0,[`Vorrat`]: (typeof (getObjectProperty(___arguments.context.pageData, 'ValueVorrat')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'ValueVorrat')))) ? (getObjectProperty(___arguments.context.pageData, 'ValueVorrat')) : 0,[`Bemerkung`]: (getObjectProperty(___arguments.context.pageData, 'ValueBemerkung')),[`BestellenUnter`]: (typeof (getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnter')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnter')))) ? (getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnter')) : 0,[`PosNr`]: 1 + (await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))))),[`Verfallskontrolle`]: (getObjectProperty(___arguments.context.pageData, 'Verfallskontrolle')),[`FremdArtikelInternEinlagerung`]: (typeof (getObjectProperty(___arguments.context.pageData, 'internEinlagerung')) === 'undefined') ? false : (typeof (getObjectProperty(___arguments.context.pageData, 'internEinlagerung')) === 'undefined') }) ));
      await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'ArtNrExt', [(await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectIdArtikel')),'\''].join(''))).setPageSize(10)))[0]]);
      await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'Lieferant', [(await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueLieferant')),'\''].join(''))).setPageSize(10)))[0]]);
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fdd8d1c82f08215a4c1f6ec8b5cce446', '93AF5FEA-E48D-411A-A973-59E4AC3B6421');
      await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'LagerplatzIdExt', [(await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))).setPageSize(10)))[0]]);
      await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(___arguments.context.pageData, 'ArtikelID')),[`LagerplatzID`]: (getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),[`WoVe`]: (typeof (getObjectProperty(___arguments.context.pageData, 'ValueWoVe')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'ValueWoVe')))) ? (getObjectProperty(___arguments.context.pageData, 'ValueWoVe')) : 0,[`Vorrat`]: (typeof (getObjectProperty(___arguments.context.pageData, 'ValueVorrat')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'ValueVorrat')))) ? (getObjectProperty(___arguments.context.pageData, 'ValueVorrat')) : 0,[`Bemerkung`]: (getObjectProperty(___arguments.context.pageData, 'ValueBemerkung')),[`BestellenUnter`]: (typeof (getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnter')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnter')))) ? (getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnter')) : 0,[`PosNr`]: (getObjectProperty(savedObject, 'PosNr')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`deleteOrUpdate`]: 'N',[`deletedInfo`]: (getObjectProperty(___arguments.context.pageData, 'ValueHinweis')),[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`objectIdFromList`]: (getObjectProperty(savedObject, 'objectId')),[`Datum`]: (new Date()),[`FremdArtikelInternEinlagerung`]: (typeof (getObjectProperty(___arguments.context.pageData, 'internEinlagerung')) === 'undefined') ? false : (typeof (getObjectProperty(___arguments.context.pageData, 'internEinlagerung')) === 'undefined') }) );
      ___arguments.context.pageData['ValueSuche'] = '';
      ___arguments.context.pageData['ValueWoVe'] = 0;
      ___arguments.context.pageData['ValueVorrat'] = 0;
      ___arguments.context.pageData['ValueBemerkung'] = '';
      ___arguments.context.pageData['ValueHinweis'] = '';
      ___arguments.context.pageData['ValueBestellenUnter'] = 0;
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b8a556b64f10a3875f8ff080a3865ff')));

    } catch (error) {
      await Backendless.Messaging.sendEmail('marmed.marla - Error Add Artikel', new Backendless.Bodyparts({ textmessage: ([(getObjectProperty(error, 'message')),'\n',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))].join('')) }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);

    }
  } else {
    (function (message) { alert(message) })('Falsche Auswahl');
  }
  ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'','','\''].join(''));
  ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/c248ea68f63c23b8701846c8f1545c9f/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    var error, liefe;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['showChangeButtonStamm'] = true;
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'showChangeButtonStamm')) === 'undefined') && !(typeof (getObjectProperty(___arguments.context.pageData, 'showChangeButtonNeu')) === 'undefined')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ce6a35a8ae01844684a45f7fe6ea9b28', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b105b241567a22b697847988d6f4a908', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d3e810f85b084a28b1b81d9869989f61', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0105f0fddc48f778bfbd3524600b97e8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec986648820a7618258689e86907144f', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16b63d08715813143ed9625801d5cf58', true);
    ___arguments.context.pageData['ValueArtnr'] = (getObjectProperty(___arguments.selectedRecord, 'Artnr'));
    ___arguments.context.pageData['ValueAusgewaehlterArtikelAusListe'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
    ___arguments.context.pageData['ValueWoVeNeu'] = (getObjectProperty(___arguments.selectedRecord, 'WoVe'));
    ___arguments.context.pageData['ValueBemerkungNeu'] = (getObjectProperty(___arguments.selectedRecord, 'Bemerkung'));
    ___arguments.context.pageData['ValueVorratNeu'] = (getObjectProperty(___arguments.selectedRecord, 'Vorrat'));
    ___arguments.context.pageData['ValueBestellenUnterNeu'] = (getObjectProperty(___arguments.selectedRecord, 'BestellenUnter'));
    ___arguments.context.pageData['ValueInternEinlagerungNeu'] = (getObjectProperty(___arguments.selectedRecord, 'FremdArtikelInternEinlagerung'));
    ___arguments.context.pageData['AusgeweaehlterArtikel'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['Lieferant'] = (getObjectProperty(___arguments.selectedRecord, 'LieferantObjId'));
    ___arguments.context.appData['ArtikelInLagerplatz'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['historieChartWhereClause'] = (['objectIdFromList = \'',(getObjectProperty(___arguments.selectedRecord, 'objectId')),'\''].join(''));
    ___arguments.context.pageData['WhereClauseHistorie'] = (['objectIdFromList = \'',(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/e0a8aa7f12b84cc5e6a1896813f85f78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EinlagerungslistenHistoryPage', ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/566d28ba16d58bb8c758aac52eefb2e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, j, k;


  try {
    var j_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(___arguments.context.pageData['ValueAusgewaehlterArtikelAusListe']),'\''].join(''))).setPageSize(10)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((j['PosNr']) > 1) {
        var k_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(j['LagerplatzID']),'\' AND PosNr=',(j['PosNr']) - 1,''].join(''))).setPageSize(10)));
        for (var k_index in k_list) {
          k = k_list[k_index];
          k['PosNr'] = ((j['PosNr']) / 1);
          await Backendless.Data.of('ArtikelInLagerplatz').save( k );
        }
        j['PosNr'] = ((j['PosNr']) - 1);
        await Backendless.Data.of('ArtikelInLagerplatz').save( j );
      } else {
        ;await ( async function (message){ alert(message) })('Artikel ist bereits an erster Position');
      }
    }
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (String(''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(___arguments.context.pageData['LagerplatzID']),'\''].join(''));

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/2db74fe88cd428ce82d451e83e585c6a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, j, k;


  try {
    var j_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(___arguments.context.pageData['ValueAusgewaehlterArtikelAusListe']),'\''].join(''))).setPageSize(10)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((j['PosNr']) < (await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(j['LagerplatzID']),'\''].join('')))))) {
        var k_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(j['LagerplatzID']),'\' AND PosNr=',(j['PosNr']) + 1,''].join(''))).setPageSize(10)));
        for (var k_index in k_list) {
          k = k_list[k_index];
          k['PosNr'] = ((k['PosNr']) - 1);
          await Backendless.Data.of('ArtikelInLagerplatz').save( k );
        }
        j['PosNr'] = ((j['PosNr']) + 1);
        await Backendless.Data.of('ArtikelInLagerplatz').save( j );
      } else {
        ;await ( async function (message){ alert(message) })('Artikel ist bereits an letzter Stelle');
      }
    }
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (String(''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(___arguments.context.pageData['LagerplatzID']),'\''].join(''));

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/ce6a35a8ae01844684a45f7fe6ea9b28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')) === 'undefined') && !(typeof (getObjectProperty(___arguments.context.pageData, 'objectIdArtikel')) === 'undefined')) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('8c83e7a897da7f2a94f8942e91b8bfde');
    } else {
      (function (message) { alert(message) })('Bitte alten Artikel aus der Liste und neuen Artikel auswählen!');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/bbebe0e2ef114564dfeea8a5d996caa5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/a6a883cec07eafa8d5fc7b187343f338/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/83d8e5a88838898876f81bb873f5f8c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, altePosNr, alterLagerort, itemUpdate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    itemUpdate = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''))).setPageSize(10)))[0];
    altePosNr = (getObjectProperty(itemUpdate, 'PosNr'));
    alterLagerort = (getObjectProperty(itemUpdate, 'LagerplatzID'));
    itemUpdate['PosNr'] = (1 + (await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID=\'',(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueSelect')),'\''].join(''))))));
    itemUpdate['LagerplatzID'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueSelect'));
    await Backendless.Data.of('ArtikelInLagerplatz').save( itemUpdate );
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(itemUpdate, 'LagerplatzIdExt', [(await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(itemUpdate, 'LagerplatzID')),'\''].join(''))).setPageSize(10)))[0]]);
    var j_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',alterLagerort,'\' AND PosNr > \'',altePosNr,'\''].join(''))).setPageSize(10)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['PosNr'] = ((getObjectProperty(j, 'PosNr')) - 1);
      await Backendless.Data.of('ArtikelInLagerplatz').save( j );
    }
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'','','\''].join(''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('4978d0f87ff1cef660b859fbd476f828');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/eea86fa3b6034888471ab9f8e9c86a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var artikel, artikelListe, artikelRelation, error, gesamtAnzahl, item, j, lagerplatz, lagerplatzListe, liste, offset, textListe;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['visibleProgress'] = true;
    ___arguments.context.pageData['visibleSearch'] = false;
    offset = 0;
    liste = [];
    textListe = '';
    gesamtAnzahl = (await Backendless.Data.of('ArtikelInLagerplatzDetails').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(ArtikelID LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\' or Bez1 LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\') and BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join('')))));
    while (offset <= gesamtAnzahl) {
      var j_list = (await Backendless.Data.of('ArtikelInLagerplatzDetails').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ArtikelID LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\' or Bez1 LIKE \'%',(getObjectProperty(___arguments.context.pageData, 'ValueSuche')),'%\') and BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setPageSize(100).setOffset(offset)));
      for (var j_index in j_list) {
        j = j_list[j_index];
        textListe = String(textListe) + String(['Lagerort: ',(getObjectProperty(j, 'LagerplatzName')),'\n',(getObjectProperty(j, 'ArtikelID')),'     ',(getObjectProperty(j, 'Bez1')),'\n','WoVe: ',(getObjectProperty(j, 'WoVe')),'     ','Vorrat: ',(getObjectProperty(j, 'Vorrat')),'\n \n'].join(''));
      }
      offset = offset + 100;
    }
    if (!textListe.length) {
      (function (message) { alert(message) })('Nichts gefunden!');
    } else {
      (function (message) { alert(message) })(textListe);
    }
    ___arguments.context.pageData['visibleProgress'] = false;
    ___arguments.context.pageData['visibleSearch'] = true;

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/0105f0fddc48f778bfbd3524600b97e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ArtikelInLagerplatzDetailsPage', ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/11d679e8ae0aba5a717ba70d379659b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, lagerplatzDavor, lagerplatzSelect;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    lagerplatzSelect = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))).setPageSize(1)))[0];
    if ((getObjectProperty(lagerplatzSelect, 'PosNr')) == 1) {
      (function (message) { alert(message) })('Ist bereits an Position 1');
    } else {
      lagerplatzDavor = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(lagerplatzSelect, 'BereichID')),'\' AND PosNr = \'',(getObjectProperty(lagerplatzSelect, 'PosNr')) - 1,'\''].join(''))).setPageSize(1)))[0];
      lagerplatzDavor['PosNr'] = ((getObjectProperty(lagerplatzDavor, 'PosNr')) + 1);
      lagerplatzSelect['PosNr'] = ((getObjectProperty(lagerplatzSelect, 'PosNr')) - 1);
      await Backendless.Data.of('LagerplatzInBereich').save( lagerplatzSelect );
      await Backendless.Data.of('LagerplatzInBereich').save( lagerplatzDavor );
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/ac7b637f0bd1e9585d784f16fbbcc198/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, lagerplatzDahinter, lagerplatzSelect, lagerplatzDavor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    lagerplatzSelect = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))).setPageSize(1)))[0];
    if ((getObjectProperty(lagerplatzSelect, 'PosNr')) == (await Backendless.Data.of('LagerplatzInBereich').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(lagerplatzSelect, 'BereichID')),'\''].join('')))))) {
      (function (message) { alert(message) })('Ist bereits letzter Position');
    } else {
      lagerplatzDahinter = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(lagerplatzSelect, 'BereichID')),'\' AND PosNr = \'',(getObjectProperty(lagerplatzSelect, 'PosNr')) + 1,'\''].join(''))).setPageSize(1)))[0];
      lagerplatzDahinter['PosNr'] = ((getObjectProperty(lagerplatzDahinter, 'PosNr')) - 1);
      lagerplatzSelect['PosNr'] = ((getObjectProperty(lagerplatzSelect, 'PosNr')) + 1);
      await Backendless.Data.of('LagerplatzInBereich').save( lagerplatzSelect );
      await Backendless.Data.of('LagerplatzInBereich').save( lagerplatzDahinter );
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/8cdf02e68d9f0708247876e84ef11cc8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['idVerschiebBereich'] = ___arguments.value;
  ___arguments.context.pageData['bereichVerschiebenDisabled'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/c158b108bb649158dbd85168459e5c23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, offset, posNrAktuell, j, item, vorhandeneLagerplaetze, vorhandeneArtikel, updateArtikelInListe, tempList, weiter, tempNr;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    weiter = true;
    offset = 0;
    tempList = [];
    tempNr = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.pageData, 'idVerschiebBereich')),'\' and PosNr > 0 and PosNr < 9999'].join(''))).setSortBy('PosNr DESC').setPageSize(1)))[0];
    if (typeof tempNr === 'undefined') {
      posNrAktuell = 0;
    } else {
      posNrAktuell = (getObjectProperty(tempNr, 'PosNr'));
    }
    while (weiter) {
      tempList = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setSortBy('PosNr').setPageSize(100).setOffset(offset)));
      if (tempList.length == 0) {
        break;
      } else {
        for (var j_index in tempList) {
          j = tempList[j_index];
          vorhandeneLagerplaetze = [];
          vorhandeneLagerplaetze = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.pageData, 'idVerschiebBereich')),'\' and LagerplatzName = \'',(getObjectProperty(j, 'LagerplatzName')),'\''].join(''))).setPageSize(1)));
          if (vorhandeneLagerplaetze.length > 0) {
            updateArtikelInListe = [];
            updateArtikelInListe = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setPageSize(100)));
            for (var item_index in updateArtikelInListe) {
              item = updateArtikelInListe[item_index];
              vorhandeneArtikel = [];
              vorhandeneArtikel = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty((vorhandeneLagerplaetze[0]), 'objectId')),'\' and ArtikelID = \'',(getObjectProperty(item, 'ArtikelID')),'\''].join(''))).setPageSize(100)));
              if (vorhandeneArtikel.length > 0) {
                (vorhandeneArtikel[0])['WoVe'] = ((getObjectProperty(item, 'WoVe')) + (getObjectProperty((vorhandeneArtikel[0]), 'WoVe')));
                (vorhandeneArtikel[0])['Vorrat'] = ((getObjectProperty(item, 'Vorrat')) + (getObjectProperty((vorhandeneArtikel[0]), 'Vorrat')));
                (vorhandeneArtikel[0])['Bemerkung'] = ([(getObjectProperty((vorhandeneArtikel[0]), 'Bemerkung')),' ',(getObjectProperty(item, 'Bemerkung'))].join(''));
                await Backendless.Data.of('ArtikelInLagerplatz').save( (vorhandeneArtikel[0]) );
                await Backendless.Data.of('ArtikelInLagerplatz').remove( item );
              } else {
                item['LagerplatzID'] = (getObjectProperty((vorhandeneLagerplaetze[0]), 'objectId'));
                item['PosNr'] = (1 + (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty((vorhandeneLagerplaetze[0]), 'objectId')),'\''].join(''))).setPageSize(10))).length);
                await Backendless.Data.of('ArtikelInLagerplatz').save( item );
              }
            }
            await Backendless.Data.of('LagerplatzInBereich').remove( j );
          } else {
            j['PosNr'] = (posNrAktuell + 1);
            j['BereichID'] = (getObjectProperty(___arguments.context.pageData, 'idVerschiebBereich'));
            await Backendless.Data.of('LagerplatzInBereich').save( j );
            posNrAktuell = posNrAktuell + 1;
          }
        }
      }
      offset = offset + 100;
    }
    (function (message) { alert(message) })('Es wurden alle Artikel und Lagerplätze verschoben! Bereich wird nun gelöscht.');
    await Backendless.Data.of('BereicheInTouren').remove( (getObjectProperty(___arguments.context.appData, 'BereichID')) );
    (function () { window.history.back(); })();

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/09e8aa7deec1e088876976d8f6180c8b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4ba48088fb284748f3789158a1c457d8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/56d8197adc9ef7580b489ff8eeaa83d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, returnObject, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    returnObject = (await Backendless.Data.of('Lieferanten').save( ({ [`Name1`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputName1')),[`Name2`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputName2')),[`Name3`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputName3')),[`Mail`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputMail')),[`Telefon`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputTelefon')),[`Strasse`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputStrasse')),[`Ort`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputOrt')),[`Plz`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputPlz')) }) ));
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('fdd8d1c82f08215a4c1f6ec8b5cce446', (await Promise.all((await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setSortBy('Name1').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Name1')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fdd8d1c82f08215a4c1f6ec8b5cce446', (getObjectProperty(returnObject, 'objectId')));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4ba48088fb284748f3789158a1c457d8');
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputName1'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputName2'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputName3'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputStrasse'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputOrt'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputPlz'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputMail'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputTelefon'] = '';

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/9c6ed5de9732930f7b0c9cce8bd18393/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5ff871948a8f0ac8a2587c4a20168a28', false);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4ba48088fb284748f3789158a1c457d8');
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputName1'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputName2'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputName3'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputStrasse'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputOrt'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputPlz'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputMail'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputTelefon'] = '';

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/a1b8d72afc23dda89df813e876b8d522/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Lieferant'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/d3e810f85b084a28b1b81d9869989f61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')) == null) {
      (function (message) { alert(message) })('Kein Artikel ausgewählt oder Hinweistext vergessen.');
    } else {
      ___arguments.context.pageData['deleteModeForModal'] = true;
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('d66e4908d01886dcf273cee808b8e1c8');
    }

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/dfc85348f9c7df685f8e09686667c9d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, counter, saveOk;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    saveOk = true;
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis')) == '' || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis')) === 'undefined')) {
      saveOk = false;
      (function (message) { alert(message) })('Hinweistext eingeben!');
    }
    if (saveOk) {
      var j_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''))).setPageSize(100)));
      for (var j_index in j_list) {
        j = j_list[j_index];
        await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(j, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(j, 'Bemerkung')),[`Datum`]: (new Date()),[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`deletedInfo`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis')),[`LagerplatzID`]: (getObjectProperty(j, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(j, 'PosNr')),[`Vorrat`]: (getObjectProperty(j, 'Vorrat')),[`WoVe`]: (getObjectProperty(j, 'WoVe')),[`BestellenUnter`]: (getObjectProperty(j, 'BestellenAb')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`deleteOrUpdate`]: 'D',[`objectIdFromList`]: (getObjectProperty(j, 'objectId')) }) );
        await Backendless.Data.of('ArtikelInLagerplatz').remove( j );
      }
      counter = 1;
      var j_list2 = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''))).setPageSize(100)));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        j['PosNr'] = counter;
        counter = counter + 1;
        await Backendless.Data.of('ArtikelInLagerplatz').save( j );
      }
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueHinweis'] = '';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b105b241567a22b697847988d6f4a908', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d3e810f85b084a28b1b81d9869989f61', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ce6a35a8ae01844684a45f7fe6ea9b28', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec986648820a7618258689e86907144f', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0105f0fddc48f778bfbd3524600b97e8', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('16b63d08715813143ed9625801d5cf58', false);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('dc9e7c685088f237eb8884e845e84f06');
    }
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (String(''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/b105b241567a22b697847988d6f4a908/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'AusgeweaehlterArtikel')) === 'undefined') {
    (function (message) { alert(message) })('Bitte Artikel aus Liste auswählen!');
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0735d33883c8a776032822d8f3cc35b2');
    ___arguments.context.pageData['deleteModeForModal'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/f3758fb8f2d9f518f28e463e1ff822b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratAlt'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0527ef4577c834f81d6275e8a3290fe8', false);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['HinweistextPflicht'] = false;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0527ef4577c834f81d6275e8a3290fe8', true);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['HinweistextPflicht'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/23927a28a248c083a4c8a13a8488d479/bundle.js', [], () => ({
  /* content */
  /* handler:onConfirm */
  async ['onConfirm'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0735d33883c8a776032822d8f3cc35b2');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d66e4908d01886dcf273cee808b8e1c8');

  },
  /* handler:onConfirm */
  /* handler:onDeny */
  async ['onDeny'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d66e4908d01886dcf273cee808b8e1c8');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0735d33883c8a776032822d8f3cc35b2');

  },
  /* handler:onDeny */
  /* handler:onDismiss */
  async ['onDismiss'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d66e4908d01886dcf273cee808b8e1c8');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('0735d33883c8a776032822d8f3cc35b2');

  },
  /* handler:onDismiss */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/ad286ce81548221823fea8e87117b448/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var error, liefe, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(getObjectProperty(___arguments.context.pageData, 'deleteModeForModal'))) {
      (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('a1b8d72afc23dda89df813e876b8d522', (await Promise.all((await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setSortBy('Name1').setPageSize(100))).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'Name1')),[`value`]: (getObjectProperty(item, 'objectId')) });}))));
      liefe = (getObjectProperty(___arguments.context.pageData, 'Lieferant'));
      if (liefe == null) {
        (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a1b8d72afc23dda89df813e876b8d522', '93AF5FEA-E48D-411A-A973-59E4AC3B6421');
      } else {
        (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a1b8d72afc23dda89df813e876b8d522', liefe);
      }
    }
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['deleteButtonDisabled'] = true;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['updateModeForModal'] = (getObjectProperty(___arguments.context.pageData, 'updateModeForModal'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['deleteModeForModal'] = (getObjectProperty(___arguments.context.pageData, 'updateModeForModal'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueArtnr'] = (getObjectProperty(___arguments.context.pageData, 'ValueArtnr'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueAusgewaehlterArtikelAusListe'] = (getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueWoVeNeu'] = (getObjectProperty(___arguments.context.pageData, 'ValueWoVeNeu'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueBemerkungNeu'] = (getObjectProperty(___arguments.context.pageData, 'ValueBemerkungNeu'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueVorratNeu'] = (getObjectProperty(___arguments.context.pageData, 'ValueVorratNeu'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueVorratAlt'] = (getObjectProperty(___arguments.context.pageData, 'ValueVorratNeu'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueBestellenUnterNeu'] = (getObjectProperty(___arguments.context.pageData, 'ValueBestellenUnterNeu'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['ValueInternEinlagerungNeu'] = (getObjectProperty(___arguments.context.pageData, 'ValueInternEinlagerungNeu'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Lieferant'] = (getObjectProperty(___arguments.context.pageData, 'Lieferant'));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/c168025833230928d087e1a89938e788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, saveOk, test, zweiteHaelfte, ersteHaelfte;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  try {
    saveOk = true;
    if ((JSON.stringify((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu')))).indexOf(',') !== -1) {
      ersteHaelfte = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu')).slice(0, ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu')).indexOf(',') + 1) - 1);
      zweiteHaelfte = subsequenceFromStartLast((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu')), (((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu')).indexOf(',') + 1 + 1) - 1));
    }
    test = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu'));
    if (typeof test === 'number' && !isNaN(test)) {
    } else {
      (function (message) { alert(message) })('Keine korrekte Eingabe');
      saveOk = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'HinweistextPflicht')) == true) {
      if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis')) == '' || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis')) === 'undefined')) {
        saveOk = false;
        (function (message) { alert(message) })('Hinweistext eingeben!');
      }
    }
    if (saveOk) {
      var j_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''))).setPageSize(10)));
      for (var j_index in j_list) {
        j = j_list[j_index];
        await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(j, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(j, 'Bemerkung')),[`Datum`]: (new Date()),[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`deletedInfo`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis')),[`LagerplatzID`]: (getObjectProperty(j, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(j, 'PosNr')),[`Vorrat`]: (getObjectProperty(j, 'Vorrat')),[`WoVe`]: (getObjectProperty(j, 'WoVe')),[`BestellenUnter`]: (getObjectProperty(j, 'BestellenUnter')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`deleteOrUpdate`]: 'U',[`objectIdFromList`]: (getObjectProperty(j, 'objectId')),[`FremdArtikelInternEinlagerung`]: (getObjectProperty(j, 'FremdArtikelInternEinlagerung')) }) );
        j['Vorrat'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueVorratNeu'));
        j['WoVe'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueWoVeNeu'));
        j['BestellenUnter'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueBestellenUnterNeu'));
        j['Bemerkung'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueBemerkungNeu'));
        j['FremdArtikelInternEinlagerung'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueInternEinlagerungNeu'));
        await Backendless.Data.of('ArtikelInLagerplatz').save( j );
        await Backendless.Data.of('ArtikelInLagerplatz').setRelation(j, 'Lieferant', [(await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'Lieferant')),'\''].join(''))).setPageSize(10)))[0]]);
        ___arguments.context.pageData['ValueHinweis'] = '';
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('23927a28a248c083a4c8a13a8488d479');
    }
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (String(''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/0527ef4577c834f81d6275e8a3290fe8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == '') {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['deleteButtonDisabled'] = true;
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['deleteButtonDisabled'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/dc9e7c685088f237eb8884e845e84f06/bundle.js', [], () => ({
  /* content */
  /* handler:onConfirm */
  async ['onConfirm'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d66e4908d01886dcf273cee808b8e1c8');

  },
  /* handler:onConfirm */
  /* handler:onDeny */
  async ['onDeny'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d66e4908d01886dcf273cee808b8e1c8');

  },
  /* handler:onDeny */
  /* handler:onDismiss */
  async ['onDismiss'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d66e4908d01886dcf273cee808b8e1c8');

  },
  /* handler:onDismiss */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/2218f5b8ba4a6013d5d8a25d90e87878/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, alterArtikel, savedObject, neuerArtikel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    alterArtikel = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''))).setPageSize(10)))[0];
    neuerArtikel = ({ 'ArtikelID': (getObjectProperty(___arguments.context.pageData, 'ArtikelID')),'Bemerkung': (getObjectProperty(___arguments.context.pageData, 'ValueBemerkungNeu')),'LagerplatzID': (getObjectProperty(alterArtikel, 'LagerplatzID')),'PosNr': (getObjectProperty(alterArtikel, 'PosNr')),'Vorrat': (getObjectProperty(___arguments.context.pageData, 'ValueVorratNeu')),'WoVe': (getObjectProperty(___arguments.context.pageData, 'ValueWoVeNeu')),'Verfallskontrolle': (getObjectProperty(___arguments.context.pageData, 'Verfallskontrolle')) });
    savedObject = (await Backendless.Data.of('ArtikelInLagerplatz').save( neuerArtikel ));
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'ArtNrExt', [(getObjectProperty(___arguments.context.pageData, 'objectIdArtikel'))]);
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'Lieferant', [(await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueLieferant')),'\''].join(''))).setPageSize(10)))[0]]);
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'LagerplatzIdExt', [(getObjectProperty(___arguments.context.pageData, 'LagerplatzID'))]);
    await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ 'ArtikelID': (getObjectProperty(alterArtikel, 'ArtikelID')),'Bemerkung': (getObjectProperty(alterArtikel, 'Bemerkung')),'Datum': (new Date()),'deletedInfo': ['Artikel wurde durch Artnr ',(getObjectProperty(neuerArtikel, 'ArtikelID')),' ersetzt.'].join(''),'deleteOrUpdate': 'C','fromUser': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'Kundennr': (getObjectProperty(___arguments.context.appData, 'Kundennr')),'LagerplatzID': (getObjectProperty(alterArtikel, 'LagerplatzID')),'PosNr': (getObjectProperty(alterArtikel, 'PosNr')),'Vorrat': (getObjectProperty(alterArtikel, 'Vorrat')),'WoVe': (getObjectProperty(alterArtikel, 'WoVe')),'objectIdFromList': (getObjectProperty(alterArtikel, 'objectId')),'objectIdLink': (getObjectProperty(savedObject, 'objectId')) }) );
    await Backendless.Data.of('ArtikelInLagerplatz').remove( alterArtikel );
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (String('LagerplatzID=\'\''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2218f5b8ba4a6013d5d8a25d90e87878');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('80bf2a58a0a8c1219ee827c8e31bc7e4');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onSubmit */
  /* handler:onClose */
  ['onClose'](___arguments) {
    
  },
  /* handler:onClose */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/80bf2a58a0a8c1219ee827c8e31bc7e4/bundle.js', [], () => ({
  /* content */
  /* handler:onConfirm */
  async ['onConfirm'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('8c83e7a897da7f2a94f8942e91b8bfde');

  },
  /* handler:onConfirm */
  /* handler:onDeny */
  async ['onDeny'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2218f5b8ba4a6013d5d8a25d90e87878');

  },
  /* handler:onDeny */
  /* handler:onDismiss */
  async ['onDismiss'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2218f5b8ba4a6013d5d8a25d90e87878');

  },
  /* handler:onDismiss */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/1c58ee78c4b9e50bbd98a29825088828/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseHistorie'] = (getObjectProperty(___arguments.context.pageData, 'WhereClauseHistorie'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['historieChartwhereClause'] = (getObjectProperty(___arguments.context.pageData, 'historieChartwhereClause'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/ec986648820a7618258689e86907144f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('0c92ebf80e78c0a8bcb28d381436e294');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/16b63d08715813143ed9625801d5cf58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b988383cbc582b38fa982c28cdd94b44');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/fea8ae61cafafb0531224394d8d55928/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('f3085b1d1198fa1808b89aa87eb8270a', (await Promise.all((await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setSortBy('PosNr').setPageSize(100))).map(async item => {; return ({ 'label': (getObjectProperty(item, 'LagerplatzName')),'value': (getObjectProperty(item, 'objectId')) });}))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/4978d0f87ff1cef660b859fbd476f828/bundle.js', [], () => ({
  /* content */
  /* handler:onConfirm */
  async ['onConfirm'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b988383cbc582b38fa982c28cdd94b44');

  },
  /* handler:onConfirm */
  /* handler:onDeny */
  async ['onDeny'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b988383cbc582b38fa982c28cdd94b44');

  },
  /* handler:onDeny */
  /* handler:onDismiss */
  async ['onDismiss'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b988383cbc582b38fa982c28cdd94b44');

  },
  /* handler:onDismiss */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/5a533718352d5b5221a8a7e831e8b19d/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, offset, posNrAktuell, j, item, vorhandeneLagerplaetze, vorhandeneArtikel, updateArtikelInListe, tempList, weiter, tempNr;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    weiter = true;
    offset = 0;
    tempList = [];
    tempNr = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.pageData, 'idVerschiebBereich')),'\''].join(''))).setSortBy('PosNr DESC').setPageSize(1)))[0];
    if (typeof tempNr === 'undefined') {
      posNrAktuell = 0;
    } else {
      posNrAktuell = (getObjectProperty(tempNr, 'PosNr'));
    }
    while (weiter) {
      tempList = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.appData, 'BereichID')),'\''].join(''))).setSortBy('PosNr').setPageSize(100).setOffset(offset)));
      if (tempList.length == 0) {
        break;
      } else {
        for (var j_index in tempList) {
          j = tempList[j_index];
          vorhandeneLagerplaetze = [];
          vorhandeneLagerplaetze = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.pageData, 'idVerschiebBereich')),'\' and LagerplatzName = \'',(getObjectProperty(j, 'LagerplatzName')),'\''].join(''))).setPageSize(1)));
          if (vorhandeneLagerplaetze.length > 0) {
            updateArtikelInListe = [];
            updateArtikelInListe = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setPageSize(10)));
            for (var item_index in updateArtikelInListe) {
              item = updateArtikelInListe[item_index];
              vorhandeneArtikel = [];
              vorhandeneArtikel = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty((vorhandeneLagerplaetze[0]), 'objectId')),'\' and ArtikelID = \'',(getObjectProperty(item, 'ArtikelID')),'\''].join(''))).setPageSize(10)));
              if (vorhandeneArtikel.length > 0) {
                (vorhandeneArtikel[0])['WoVe'] = ((getObjectProperty(item, 'WoVe')) + (getObjectProperty((vorhandeneArtikel[0]), 'WoVe')));
                (vorhandeneArtikel[0])['Vorrat'] = ((getObjectProperty(item, 'Vorrat')) + (getObjectProperty((vorhandeneArtikel[0]), 'Vorrat')));
                (vorhandeneArtikel[0])['Bemerkung'] = ([(getObjectProperty((vorhandeneArtikel[0]), 'Bemerkung')),' ',(getObjectProperty(item, 'Bemerkung'))].join(''));
                await Backendless.Data.of('ArtikelInLagerplatz').save( (vorhandeneArtikel[0]) );
                await Backendless.Data.of('ArtikelInLagerplatz').remove( item );
              } else {
                item['LagerplatzID'] = (getObjectProperty((vorhandeneLagerplaetze[0]), 'objectId'));
                item['PosNr'] = (1 + (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty((vorhandeneLagerplaetze[0]), 'objectId')),'\''].join(''))).setPageSize(10))).length);
                await Backendless.Data.of('ArtikelInLagerplatz').save( item );
              }
            }
            await Backendless.Data.of('LagerplatzInBereich').remove( j );
          } else {
            j['PosNr'] = (posNrAktuell + 1);
            j['BereichID'] = (getObjectProperty(___arguments.context.pageData, 'idVerschiebBereich'));
            await Backendless.Data.of('LagerplatzInBereich').save( j );
            posNrAktuell = posNrAktuell + 1;
          }
        }
      }
      offset = offset + 100;
    }
    (function (message) { alert(message) })('Es wurden alle Artikel und Lagerplätze verschoben! Bereich wird nun gelöscht.');
    await Backendless.Data.of('BereicheInTouren').remove( (getObjectProperty(___arguments.context.appData, 'BereichID')) );
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5a533718352d5b5221a8a7e831e8b19d');
    (function () { window.history.back(); })();

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onSubmit */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('5a533718352d5b5221a8a7e831e8b19d');

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/27d757c7f67e68089488a968e52801b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['internEinlagerung'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/f16b26286a7875f543a8a4d803d822a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, alterArtikel, savedObject, neuerArtikel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    alterArtikel = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueAusgewaehlterArtikelAusListe')),'\''].join(''))).setPageSize(10)))[0];
    neuerArtikel = ({ [`ArtikelID`]: (getObjectProperty(___arguments.context.pageData, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(___arguments.context.pageData, 'ValueBemerkungNeu')),[`LagerplatzID`]: (getObjectProperty(alterArtikel, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(alterArtikel, 'PosNr')),[`Vorrat`]: (getObjectProperty(___arguments.context.pageData, 'ValueVorratNeu')),[`WoVe`]: (getObjectProperty(___arguments.context.pageData, 'ValueWoVeNeu')),[`Verfallskontrolle`]: (getObjectProperty(___arguments.context.pageData, 'Verfallskontrolle')) });
    savedObject = (await Backendless.Data.of('ArtikelInLagerplatz').save( neuerArtikel ));
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'ArtNrExt', [(getObjectProperty(___arguments.context.pageData, 'objectIdArtikel'))]);
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'Lieferant', [(await Backendless.Data.of('Lieferanten').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'ValueLieferant')),'\''].join(''))).setPageSize(10)))[0]]);
    await Backendless.Data.of('ArtikelInLagerplatz').setRelation(savedObject, 'LagerplatzIdExt', [(getObjectProperty(___arguments.context.pageData, 'LagerplatzID'))]);
    await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(alterArtikel, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(alterArtikel, 'Bemerkung')),[`Datum`]: (new Date()),[`deletedInfo`]: ['Artikel wurde durch Artnr ',(getObjectProperty(neuerArtikel, 'ArtikelID')),' ersetzt.',' Info: ',(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'ValueHinweis'))].join(''),[`deleteOrUpdate`]: 'C',[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`LagerplatzID`]: (getObjectProperty(alterArtikel, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(alterArtikel, 'PosNr')),[`Vorrat`]: (getObjectProperty(alterArtikel, 'Vorrat')),[`WoVe`]: (getObjectProperty(alterArtikel, 'WoVe')),[`objectIdFromList`]: (getObjectProperty(alterArtikel, 'objectId')),[`objectIdLink`]: (getObjectProperty(savedObject, 'objectId')) }) );
    await Backendless.Data.of('ArtikelInLagerplatz').remove( alterArtikel );
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (String('LagerplatzID=\'\''));
    ___arguments.context.pageData['whereClauseArtikelInListe'] = (['LagerplatzID=\'',(getObjectProperty(___arguments.context.pageData, 'LagerplatzID')),'\''].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).show() })('80bf2a58a0a8c1219ee827c8e31bc7e4');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/70e8005866735d185e789045bef8a638/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('8c83e7a897da7f2a94f8942e91b8bfde');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/45e797f8f6eb005757d84688b3280d58/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['changeButtonDisabled'] = true;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['artnrNeu'] = (getObjectProperty(___arguments.context.pageData, 'ArtikelID'));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['artnrAlt'] = (getObjectProperty(___arguments.context.pageData, 'ValueArtnr'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/363ecdce810aa7889ea8cc982a88079b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == '') {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['changeButtonDisabled'] = true;
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['changeButtonDisabled'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/f5ad59584448077b373a5c58c2fcd525/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['historieChartWhereClause'] = (getObjectProperty(___arguments.context.pageData, 'historieChartWhereClause'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/EinlagerungslistenDetailsPage/components/7ca419b3603ac67963eb2398f39a1dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['bereich.BereichAbwesend'] = ___arguments.value;
  await Backendless.Data.of('BereicheInTouren').save((getObjectProperty(___arguments.context.pageData, 'bereich')), true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  if ((getObjectProperty(___arguments.context.appData, 'Kundennr')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
  ___arguments.context.pageData['WhereClauseHistory'] = (['Kundennr=\'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagerungslistenHistoryPage/components/0aa79023a11eae0f1c131b5cc6263ab7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  if (typeof (getObjectProperty(___arguments.context.appData, 'TourKundeID')) === 'undefined') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'TourKundeID')) == null) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);
    }
  }
  ___arguments.context.pageData['einlagerungDeaktivieren'] = false;
  ___arguments.context.pageData['StatusInitialDelete'] = false;
  ___arguments.context.pageData['contentHeader'] = (String('Einlagerungsliste: ') + String(getObjectProperty(___arguments.context.appData, 'TourKundeID')));
  ___arguments.context.pageData['contentHeader2'] = ((getObjectProperty(___arguments.context.appData, 'TourKundeID')) != (getObjectProperty(___arguments.context.appData, 'Kundennr')) ? [' (Gesuchte Kdnr: ',(getObjectProperty(___arguments.context.appData, 'Kundennr')),')'].join('') : '');
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));
  ___arguments.context.pageData['ValueCheckboxAuftrag'] = false;
  if ((await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('KundeID=') + String(getObjectProperty(___arguments.context.appData, 'TourKundeID')))))) == 0) {
    (function (message) { alert(message) })('Keine Einlagerungsliste vorhanden!');
  } else {
    if ((await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID=',(getObjectProperty(___arguments.context.appData, 'TourKundeID')),'AND Aktiv = false'].join(''))))) > 0) {
      ___arguments.context.pageData['einlagerungDeaktivieren'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7862f89877c93f2e3fafdd0d9ca438', true);
    } else {
      ___arguments.context.pageData['einlagerungDeaktivieren'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7862f89877c93f2e3fafdd0d9ca438', false);
    }
  }
  ___arguments.context.pageData['whereLogic'] = (['KundeID=\'',(getObjectProperty(___arguments.context.appData, 'TourKundeID')),'\''].join(''));
  ___arguments.context.pageData['whereClauseBereiche'] = 'KundeTourID=\'999\'';
  ___arguments.context.pageData['whereClauseLagerplatz'] = 'BereichID=\'999\'';
  ___arguments.context.pageData['whereClauseArtikelInListe'] = 'LagerplatzID=\'999\'';
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('6aa87918023d5148da1ceb0ebcf1b31d', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Name')),[`label`]: (getObjectProperty(item, 'Name')) });}))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/7ba8304d97877d37ab9d2b6a76bbc598/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var deleteObjectId, error, loeschenMoeglich, saveHistoryObject, whereClauseTemp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['KundeID'] = (getObjectProperty(___arguments.selectedRecord, 'KundeID'));
  ___arguments.context.pageData['whereClauseBereiche'] = (['KundeTourID=\'',(getObjectProperty(___arguments.selectedRecord, 'KundeID')),'\''].join(''));
  if ((getObjectProperty(___arguments.context.pageData, 'LoeschmodusTour')) != true) {
    ___arguments.context.pageData['whereClauseBereiche'] = (['KundeTourID=\'',(getObjectProperty(___arguments.selectedRecord, 'KundeID')),'\''].join(''));
    ___arguments.context.pageData['bereichIdSelected'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
    ___arguments.context.pageData['kundeIdSelected'] = (getObjectProperty(___arguments.selectedRecord, 'KundeID'));
  } else {
    loeschenMoeglich = false;
    if ((await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID=\'',(getObjectProperty(___arguments.selectedRecord, 'KundeID')),'\''].join(''))))) > 1) {
      loeschenMoeglich = true;
    } else {
      if ((await Backendless.Data.of('BereicheInTouren').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['KundeTourID=\'',(getObjectProperty(___arguments.selectedRecord, 'KundeID')),'\''].join(''))))) > 0) {
        (function (message) { alert(message) })('Es sind noch Bereiche in dieser Tour vorhanden, Löschen ist nicht möglich.');
      } else {
        loeschenMoeglich = true;
      }
    }
    if (loeschenMoeglich == true) {
      try {
        whereClauseTemp = (getObjectProperty(___arguments.context.pageData, 'whereLogic'));
        deleteObjectId = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
        saveHistoryObject = ___arguments.selectedRecord;
        saveHistoryObject['objectIdInit'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
        saveHistoryObject['objectId'] = null;
        saveHistoryObject['created'] = null;
        saveHistoryObject['updated'] = null;
        await Backendless.Data.of('KundeTourHistory').save( saveHistoryObject );
        await Backendless.Data.of('KundeTour').remove( deleteObjectId );
        ___arguments.context.pageData['LoeschmodusTour'] = false;
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58b8124470f8168d5abaad2f16e8e9a8', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6f3dec833f88aa9b0a8f308ea3ac208', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aa87918023d5148da1ceb0ebcf1b31d', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f46b24c8ac313cb8a13848bdd5da9358', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b4803782a9d20d8012837d87e3813a8', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8039f4f475c1bb78050cbcc28a58cf58', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18ff188a748db28481196887e8800f8', true);
        ___arguments.context.pageData['whereLogic'] = '';
        ___arguments.context.pageData['whereLogic'] = whereClauseTemp;

      } catch (error) {
        (function (message) { alert(message) })(error);

      }
    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onMounted */
  onMounted(___arguments) {
    
  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/40d8032af8bd6bb53e28e168e5d834e8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error, whereClauseTemp, deleteObjectId, saveHistoryObject, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Loeschmodus')) != true) {
    ___arguments.context.pageData['BereichID'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
    ___arguments.context.appData['BereichID'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
    ___arguments.context.appData['Kundennr'] = (getObjectProperty(___arguments.context.appData, 'Kundennr'));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EinlagerungslistenDetailsPage', ___arguments.context.appData);
  } else {
    try {
      whereClauseTemp = (getObjectProperty(___arguments.context.pageData, 'whereClauseBereiche'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2f181fac0f41177c3d38f0f2dba37168', true);
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2f181fac0f41177c3d38f0f2dba37168');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc994158a3d8adf8426bcb38ca81426a', false);
      ___arguments.context.pageData['bereichDelete'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
  }

  },
  /* handler:onRecordSelect */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['whereClauseBereiche'] = 'KundeTourID=\'NONE\'';
  ___arguments.context.pageData['whereClauseLagerplatz'] = 'BereichID=\'NONE\'';
  ___arguments.context.pageData['whereClauseArtikelInListe'] = 'LagerplatzID=\'NONE\'';

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/b5cb9bed8659c3288dd8f02748127ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var count, savedObject, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (null != (getObjectProperty(___arguments.context.pageData, 'valueName')) && null != (getObjectProperty(___arguments.context.pageData, 'bereichIdSelected'))) {
      count = (typeof count == 'number' ? count : 0) + 1;
      savedObject = (await Backendless.Data.of('BereicheInTouren').save( ({ 'KundeTourID': (getObjectProperty(___arguments.context.pageData, 'kundeIdSelected')),'Beschreibung': (getObjectProperty(___arguments.context.pageData, 'valueBeschreibung')),'Name': (getObjectProperty(___arguments.context.pageData, 'valueName')),'KundennrAuftrag': (getObjectProperty(___arguments.context.pageData, 'valueKundennrAuftrag')),'ExtraAuftrag': (getObjectProperty(___arguments.context.pageData, 'ValueCheckboxAuftrag')) }) ));
      await Backendless.Data.of('BereicheInTouren').setRelation(savedObject, 'KundeTourExt', [(await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'bereichIdSelected')),'\''].join(''))).setPageSize(10)))[0]]);
      await Backendless.Data.of('LagerplatzInBereich').save( ({ 'LagerplatzName': 'Neue Artikel','BereichID': (getObjectProperty(savedObject, 'objectId')),'PosNr': 0 }) );
      await Backendless.Data.of('LagerplatzInBereich').save( ({ 'LagerplatzName': 'NB','BereichID': (getObjectProperty(savedObject, 'objectId')),'PosNr': 9999 }) );
      ___arguments.context.pageData['valueBeschreibung'] = '';
      ___arguments.context.pageData['valueName'] = '';
      ___arguments.context.pageData['valueKundennrAuftrag'] = '';
      ___arguments.context.pageData['ValueCheckboxAuftrag'] = false;
      ___arguments.context.pageData['whereClauseBereiche'] = (['KundeTourID=\'','','\''].join(''));
      ___arguments.context.pageData['whereClauseBereiche'] = (['KundeTourID=\'',(getObjectProperty(___arguments.context.pageData, 'kundeIdSelected')),'\''].join(''));
    } else {
      (function (message) { alert(message) })('Name und Beschreibung ausfüllen und Tour links auswählen');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/b3886e786b988023edc8cf96d3276609/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Loeschmodus')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91812b289328e67d00518ca87fa55b34', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('56084e0885f82525d1d80f7e199af908', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5cb9bed8659c3288dd8f02748127ea8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3483b9208c4c17887ffcb28ced8468b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c5835d6bc2dee480ac86e8862e81b26', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dc8628400a8de36658894e83d283b81', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dc8628400a8de36658894e83d283b81', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c5835d6bc2dee480ac86e8862e81b26', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91812b289328e67d00518ca87fa55b34', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('56084e0885f82525d1d80f7e199af908', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5cb9bed8659c3288dd8f02748127ea8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3483b9208c4c17887ffcb28ced8468b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2a8cc150df87d280fc87f98a0575428', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22983a6851a70b99dc81a0c3de2d2098', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/c18ff188a748db28481196887e8800f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, kunde;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (null != (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) && null != (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')) && null != (getObjectProperty(___arguments.context.pageData, 'valueName')) && null != (getObjectProperty(___arguments.context.pageData, 'ValueTour'))) {
    try {
      ___arguments.context.pageData['SavedObject'] = (await Backendless.Data.of('KundeTour').save( ({ 'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['TourID=\'',(getObjectProperty(___arguments.context.pageData, 'ValueTour')),'\''].join(''))))),'Name': (getObjectProperty(___arguments.context.pageData, 'valueName')),'TourID': undefined,'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'KundeID': (getObjectProperty(___arguments.context.appData, 'Kundennr')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ValueTour')),'Wochenart': (getObjectProperty(___arguments.context.pageData, 'ValueWochenart')) }) ));
      kunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''))).setPageSize(10)))[0];
      await Backendless.Data.of('KundeTour').setRelation((getObjectProperty(___arguments.context.pageData, 'SavedObject')), 'KundeExt', [kunde]);
      await Backendless.Data.of('Kunden').setRelation(kunde, 'KundeTourExt', [(getObjectProperty(___arguments.context.pageData, 'SavedObject'))]);
      await Backendless.Data.of('KundeTour').setRelation((getObjectProperty(___arguments.context.pageData, 'SavedObject')), 'TourID', [(await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'selectTourVal')),'\''].join(''))).setPageSize(10)))[0]]);
      ___arguments.context.pageData['valueName'] = '';

    } catch (error) {
      (function (message) { alert(message) })((String('Error: ') + String(error)));

    }
  } else {
    (function (message) { alert(message) })('Bitte Name, Intervall, Startdatum und Tour eingeben.');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/7bafd0e16a388db68458e95818a6ad48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['LoeschmodusTour'] = ___arguments.value;
  if (___arguments.value == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8039f4f475c1bb78050cbcc28a58cf58', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('be45ceb883a914c8fc49eb182bb8e9b2', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aa87918023d5148da1ceb0ebcf1b31d', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18ff188a748db28481196887e8800f8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58b8124470f8168d5abaad2f16e8e9a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6f3dec833f88aa9b0a8f308ea3ac208', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b4803782a9d20d8012837d87e3813a8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f46b24c8ac313cb8a13848bdd5da9358', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8039f4f475c1bb78050cbcc28a58cf58', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('be45ceb883a914c8fc49eb182bb8e9b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6aa87918023d5148da1ceb0ebcf1b31d', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c18ff188a748db28481196887e8800f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58b8124470f8168d5abaad2f16e8e9a8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a6f3dec833f88aa9b0a8f308ea3ac208', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b4803782a9d20d8012837d87e3813a8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f46b24c8ac313cb8a13848bdd5da9358', true);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/6aa87918023d5148da1ceb0ebcf1b31d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['ValueTour'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/1a0a41c288fc2d9d5e9c3bbf284fff24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/8039f4f475c1bb78050cbcc28a58cf58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value != '*' && (___arguments.context.pageData['ValueIntervall']) != 14) {
    ;await ( async function (message){ alert(message) })('Achtung! Das Intervall wurde auf 14 angepasst!');
    ___arguments.context.pageData['ValueIntervall'] = 14;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/2db5355de8786be437b87ca3643c13b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.pageData['einlagerungDeaktivieren'] = ___arguments.value;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7862f89877c93f2e3fafdd0d9ca438', true);
    var item_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID=',(getObjectProperty(___arguments.context.appData, 'Kundennr')),''].join(''))).setPageSize(100)));
    for (var item_index in item_list) {
      item = item_list[item_index];
      item['Aktiv'] = false;
      await Backendless.Data.of('KundeTour').save( item );
    }
  } else {
    ___arguments.context.pageData['einlagerungDeaktivieren'] = ___arguments.value;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b7862f89877c93f2e3fafdd0d9ca438', false);
    var item_list2 = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((String('KundeID=') + String(getObjectProperty(___arguments.context.appData, 'Kundennr')))).setPageSize(100)));
    for (var item_index2 in item_list2) {
      item = item_list2[item_index2];
      item['Aktiv'] = true;
      await Backendless.Data.of('KundeTour').save( item );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/cc994158a3d8adf8426bcb38ca81426a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'KundeID')) == null) {
      (function (message) { alert(message) })('Bitte Tour-Element auswählen!');
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d8d8b0461ed524dbbc88bab8ba5850cf', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22983a6851a70b99dc81a0c3de2d2098', true);
      ___arguments.context.pageData['StatusInitialDelete'] = true;
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/22983a6851a70b99dc81a0c3de2d2098/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d8d8b0461ed524dbbc88bab8ba5850cf', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22983a6851a70b99dc81a0c3de2d2098', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2a8cc150df87d280fc87f98a0575428', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cc994158a3d8adf8426bcb38ca81426a', true);
  ___arguments.context.pageData['StatusInitialDelete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/d8d8b0461ed524dbbc88bab8ba5850cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemBereich, itemLp, itemArtikel, listAr, offsetAr, listLp, offsetLp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var itemBereich_list = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeTourID = \'',(getObjectProperty(___arguments.context.pageData, 'KundeID')),'\''].join(''))).setPageSize(100)));
    for (var itemBereich_index in itemBereich_list) {
      itemBereich = itemBereich_list[itemBereich_index];
      offsetLp = 0;
      while (true) {
        listLp = [];
        listLp = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(itemBereich, 'objectId')),'\''].join(''))).setPageSize(100).setOffset(offsetLp)));
        if (listLp.length == 0) {
          break;
        }
        for (var itemLp_index in listLp) {
          itemLp = listLp[itemLp_index];
          offsetAr = 0;
          while (true) {
            listAr = [];
            listAr = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty(itemLp, 'objectId')),'\''].join(''))).setPageSize(100).setOffset(offsetAr)));
            if (listAr.length == 0) {
              break;
            }
            for (var itemArtikel_index in listAr) {
              itemArtikel = listAr[itemArtikel_index];
              await Backendless.Data.of('ArtikelInLagerplatz').remove( itemArtikel );
            }
          }
          await Backendless.Data.of('LagerplatzInBereich').remove( itemLp );
        }
      }
      await Backendless.Data.of('BereicheInTouren').remove( itemBereich );
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/f46b24c8ac313cb8a13848bdd5da9358/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    if ((new Date()) > ___arguments.value) {
      (function (message) { alert(message) })('Datum in Vergangenheit!');
      ___arguments.context.pageData['ValueStartDatum'] = null;
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/0588f1d92e68fba81a52cfd8b378ed5a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  try {
    if (getValueLength(___arguments.value) > 0) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['disableYesButton'] = false;
    } else {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['disableYesButton'] = true;
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/f98d50ae372522b967911ee8101b08d8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['disableYesButton'] = true;
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['BereichID'] = (getObjectProperty(___arguments.context.pageData, 'BereichID'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/b0c8c52acfa84808b00abe07fc4adc58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, bereichItem, artikelItem, offsetLp, lagerplatzItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    offsetLp = 0;
    var repeat_end = Math.ceil((await Backendless.Data.of('LagerplatzInBereich').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.pageData, 'bereichDelete')),'\''].join(''))))) / 100);
    for (var count = 0; count < repeat_end; count++) {
      var lagerplatzItem_list = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(___arguments.context.pageData, 'bereichDelete')),'\''].join(''))).setPageSize(100).setOffset(offsetLp)));
      for (var lagerplatzItem_index in lagerplatzItem_list) {
        lagerplatzItem = lagerplatzItem_list[lagerplatzItem_index];
        var artikelItem_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty(lagerplatzItem, 'objectId')),'\''].join(''))).setPageSize(100)));
        for (var artikelItem_index in artikelItem_list) {
          artikelItem = artikelItem_list[artikelItem_index];
          await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`FremdArtikelInternEinlagerung`]: (getObjectProperty(artikelItem, 'FremdArtikelInternEinlagerung')),[`ArtikelID`]: (getObjectProperty(artikelItem, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(artikelItem, 'Bemerkung')),[`BestellenUnter`]: (getObjectProperty(artikelItem, 'BestellenUnter')),[`Datum`]: (new Date()),[`deletedInfo`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'valueLoeschgrund')),[`deleteOrUpdate`]: (getObjectProperty(artikelItem, 'D')),[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`LagerplatzID`]: (getObjectProperty(artikelItem, 'LagerplatzID')),[`LetzterIstBestand`]: (getObjectProperty(artikelItem, 'LetzterIstBestand')),[`objectIdFromList`]: (getObjectProperty(artikelItem, 'objectId')),[`objectIdLink`]: undefined,[`PosNr`]: (getObjectProperty(artikelItem, 'PosNr')),[`Vorrat`]: (getObjectProperty(artikelItem, 'Vorrat')),[`WoVe`]: (getObjectProperty(artikelItem, 'WoVe')) }) );
          await Backendless.Data.of('ArtikelInLagerplatz').remove( artikelItem );
        }
        await Backendless.Data.of('LagerplatzInBereichHistory').save( ({ [`BereichID`]: (getObjectProperty(lagerplatzItem, 'BereichID')),[`ExtraAuftrag`]: (getObjectProperty(lagerplatzItem, 'ExtraAuftrag')),[`KundeTourID`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`LagerplatzName`]: (getObjectProperty(lagerplatzItem, 'LagerplatzName')),[`objectIdInit`]: (getObjectProperty(lagerplatzItem, 'objectId')) }) );
        await Backendless.Data.of('LagerplatzInBereich').remove( lagerplatzItem );
      }
      offsetLp = offsetLp + 100;
    }
    bereichItem = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'bereichDelete')),'\''].join(''))).setPageSize(10)))[0];
    await Backendless.Data.of('BereicheInTourenHistory').save( ({ [`Beschreibung`]: (getObjectProperty(bereichItem, 'Beschreibung')),[`ExtraAuftrag`]: (getObjectProperty(bereichItem, 'ExtraAuftrag')),[`KundennrAuftrag`]: (getObjectProperty(bereichItem, 'KundennrAuftrag')),[`KundeTourID`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`Name`]: (getObjectProperty(bereichItem, 'Name')),[`objectIdInit`]: (getObjectProperty(bereichItem, 'objectId')) }) );
    await Backendless.Data.of('BereicheInTouren').remove( bereichItem );
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['valueLoeschgrund'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dc8628400a8de36658894e83d283b81', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c5835d6bc2dee480ac86e8862e81b26', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91812b289328e67d00518ca87fa55b34', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('56084e0885f82525d1d80f7e199af908', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5cb9bed8659c3288dd8f02748127ea8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3483b9208c4c17887ffcb28ced8468b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22983a6851a70b99dc81a0c3de2d2098', false);
    ___arguments.context.pageData['Loeschmodus'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2f181fac0f41177c3d38f0f2dba37168');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/f5a854180688ebce17982ff5f6186a59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['valueLoeschgrund'] = '';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6dc8628400a8de36658894e83d283b81', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7c5835d6bc2dee480ac86e8862e81b26', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91812b289328e67d00518ca87fa55b34', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('56084e0885f82525d1d80f7e199af908', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5cb9bed8659c3288dd8f02748127ea8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e3483b9208c4c17887ffcb28ced8468b', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22983a6851a70b99dc81a0c3de2d2098', false);
    ___arguments.context.pageData['Loeschmodus'] = false;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2f181fac0f41177c3d38f0f2dba37168');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/EinlagungslistenPage/components/8198337adc58805a6c585e18f6c76858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, realTour, fileText, offset, artikelItem, artikelStammItem, adressItem, tempList, bestellungItem, kundeItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    ___arguments.context.pageData['InventurProgress'] = true;
    ___arguments.context.pageData['InventurMailDisabled'] = true;
    ___arguments.context.pageData['InventurMailButtonDisabled'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'InventurMail')).indexOf('@mar-med.de') + 1 == 0) {
      (function (message) { alert(message) })('Aktuell ist das Senden nur an @mar-med.de Adressen möglich.');
    } else {
      fileText = '';
      realTour = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID=\'',(getObjectProperty(___arguments.context.appData, 'TourKundeID')),'\''].join(''))).setSortBy('created DESC').setPageSize(1)))[0];
      if (!(realTour !== null && !Array.isArray(realTour) && (typeof realTour === 'object'))) {
        (function (message) { alert(message) })('Keine Einlagerung gefunden');
        return ;
      }
      fileText = String(fileText) + String(['Hauptkundennummer:;',(getObjectProperty(realTour, 'KundeID')),'\n','Name:',(getObjectProperty(realTour, 'Name')),'\n','Inventur-Datum:',[(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getDate()),'.',(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getMonth() + 1),'.',(new Date((new Date((getObjectProperty(realTour, 'EndTime'))))).getFullYear())].join(''),'\n','\n'].join(''));
      var bestellungItem_list = (await Backendless.Data.of('Bestellungen').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT = \'',(getObjectProperty(realTour, 'ID_EXT')),'\''].join(''))).setPageSize(100)));
      for (var bestellungItem_index in bestellungItem_list) {
        bestellungItem = bestellungItem_list[bestellungItem_index];
        kundeItem = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr = \'',(getObjectProperty(bestellungItem, 'Kundennr')),'\''].join(''))).setPageSize(10)))[0];
        adressItem = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id = \'',!((getObjectProperty(kundeItem, 'Lieferadrid')) === null) ? (getObjectProperty(kundeItem, 'Lieferadrid')) : (!((getObjectProperty(kundeItem, 'Rgadrid')) === null) ? (getObjectProperty(kundeItem, 'Rgadrid')) : (getObjectProperty(kundeItem, 'Abadrid'))),'\''].join(''))).setPageSize(10)))[0];
        fileText = String(fileText) + String(['Kundennummer:;',(getObjectProperty(bestellungItem, 'Kundennr')),'\n','Name:;',(getObjectProperty(bestellungItem, 'Name')),'\n','Beschreibung:;',(getObjectProperty(bestellungItem, 'Beschreibung')),'\n','Erfasser:;',(getObjectProperty(bestellungItem, 'Erfasser')),'\n','\n'].join(''));
        fileText = String(fileText) + String(['Artnr;','Bezeichnung;','Ist-Bestand;','\n'].join(''));
        offset = 0;
        while (true) {
          tempList = [];
          tempList = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(bestellungItem, 'ID_EXT_ARTIKEL')),'\''].join(''))).setPageSize(100).setOffset(offset)));
          if (tempList.length == 0) {
            break;
          }
          for (var artikelItem_index in tempList) {
            artikelItem = tempList[artikelItem_index];
            artikelStammItem = (await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(artikelItem, 'ArtikelID')),'\''].join(''))).setPageSize(10)))[0];
            if (typeof artikelStammItem === 'undefined') {
              (function (message) { alert(message) })((getObjectProperty(artikelItem, 'ArtikelID')));
              (function (message) { alert(message) })((JSON.stringify(artikelStammItem)));
            }
            if (typeof artikelItem === 'undefined') {
              (function (message) { alert(message) })('UND');
              (function (message) { alert(message) })((JSON.stringify(artikelStammItem)));
            }
            if (typeof adressItem === 'undefined') {
              (function (message) { alert(message) })((getObjectProperty(artikelItem, 'ArtikelID')));
              (function (message) { alert(message) })((JSON.stringify(artikelStammItem)));
            }
            fileText = String(fileText) + String([(getObjectProperty(artikelItem, 'ArtikelID')),';',(getObjectProperty(artikelItem, 'Bezeichnung')),';',((JSON.stringify((getObjectProperty(artikelItem, 'IstBestand')))).replace('.', ',')),'\n'].join(''));
          }
          offset = 100 + offset;
        }
        fileText = String(fileText) + String('\n \n \n');
      }
      await Backendless.Files.saveFile(encodePath('/'), (['Inventur_',(getObjectProperty(realTour, 'KundeID')),'.csv'].join('')), (String('\uFEFF') + String(fileText)), true);
      await Backendless.Messaging.sendEmail((['marmed superstore - Inventur als CSV-Datei von Hauptkundennummer ',(getObjectProperty(realTour, 'KundeID')),'.csv'].join('')), new Backendless.Bodyparts({ textmessage: (['Moin, ','\n \n','anbei erhältst du die angeforderten Daten als CSV-Datei. Sie können diese mit Excel oder ähnlichen Programmen öffnen.','\n \n','Ihr','\n','marmed superstore - Team'].join('')) }), ensureArray([(getObjectProperty(___arguments.context.pageData, 'InventurMail'))]), ensureArray((['/Inventur_',(getObjectProperty(realTour, 'KundeID')),'.csv'].join(''))).filter(item => !!item));
      ___arguments.context.pageData['InventurMailDisabled'] = false;
      ___arguments.context.pageData['InventurMailButtonDisabled'] = false;
      ___arguments.context.pageData['InventurProgress'] = false;
      (function (message) { alert(message) })('Gesendet');
    }

  } catch (error) {
    ___arguments.context.pageData['InventurProgress'] = false;
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Kalenderwoche/components/10a8a2249b8401a8d1d2a8f8dcdda7b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, input;


  try {
    input = (new Date((___arguments.context.pageData['ValueDate'])).getDay());
    if (input == 0) {
      ___arguments.context.pageData['ValueOutput'] = 'Sonntag';
    } else if (input == 1) {
      ___arguments.context.pageData['ValueOutput'] = 'Montag';
    } else if (input == 2) {
      ___arguments.context.pageData['ValueOutput'] = 'Dienstag';
    } else if (input == 3) {
      ___arguments.context.pageData['ValueOutput'] = 'Mittwoch';
    } else if (input == 4) {
      ___arguments.context.pageData['ValueOutput'] = 'Donnerstag';
    } else if (input == 5) {
      ___arguments.context.pageData['ValueOutput'] = 'Freitag';
    } else if (input == 6) {
      ___arguments.context.pageData['ValueOutput'] = 'Samstag';
    }
    ;await ( async function (message){ alert(message) })((new Date((___arguments.context.pageData['ValueDate'])).getFullYear()));
    ;await ( async function (message){ alert(message) })((new Date(([(new Date((___arguments.context.pageData['ValueDate'])).getDate()),'/',(new Date((___arguments.context.pageData['ValueDate'])).getMonth() + 1),'/',(new Date((___arguments.context.pageData['ValueDate'])).getFullYear())].join('')))));
    ___arguments.context.pageData['ValueOutput'] = (new Date((new Date(([(new Date((___arguments.context.pageData['ValueDate'])).getMonth() + 1),'/',(new Date((___arguments.context.pageData['ValueDate'])).getDate()),'/',(new Date((___arguments.context.pageData['ValueDate'])).getFullYear())].join(''))))).getMonth() + 1);

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);
    ___arguments.context.pageData['ValueOutput'] = error;

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var adresse, adressid, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  if (typeof (getObjectProperty(___arguments.context.appData, 'Kundennr')) === 'undefined') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);
  }
  ___arguments.context.pageData['selectedGeopoint'] = (new Backendless.Data.LineString([(new Backendless.Data.Point().setX(9.584508415532538).setY(54.311574629223884)), (new Backendless.Data.Point().setX(9.6).setY(54.311574629223884)), (new Backendless.Data.Point().setX(9.8).setY(54.311574629223884))]));
  ___arguments.context.pageData['zoomLevel'] = 10;
  var j_list = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((String('Kundennr=') + String(getObjectProperty(___arguments.context.appData, 'Kundennr')))).setPageSize(10)));
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData['uiName'] = (getObjectProperty(j, 'Name1'));
    ___arguments.context.pageData['uiVertreter'] = (getObjectProperty(j, 'Vertreter'));
    ___arguments.context.pageData['uiPartner'] = (getObjectProperty(j, 'Partner'));
    ___arguments.context.pageData['uiKundengruppe'] = (getObjectProperty(j, 'Kundengruppe'));
    ___arguments.context.pageData['uiLogistikinfo'] = (getObjectProperty(j, 'Logistikinfo'));
    ___arguments.context.pageData['uiBemerkungen'] = (getObjectProperty(j, 'Bemerkungen'));
    ___arguments.context.pageData['uiVersandart'] = (getObjectProperty(j, 'Versandart'));
    ___arguments.context.pageData['uiZahlungsart'] = (getObjectProperty(j, 'Zahlungsart'));
    ___arguments.context.pageData['uiZahlungsart'] = (getObjectProperty(j, 'Zahlungsart'));
    ___arguments.context.pageData['uiAllgemeinerRabatt'] = (getObjectProperty(j, 'AllgemeinerRabatt'));
    ___arguments.context.pageData['kdnr'] = (['Kdliefnr=\'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''));
    if ((getObjectProperty(j, 'Lieferadrid')) != null) {
      adressid = (getObjectProperty(j, 'Lieferadrid'));
    } else if ((getObjectProperty(j, 'Abadrid')) != null) {
      adressid = (getObjectProperty(j, 'Abadrid'));
    } else {
      adressid = (getObjectProperty(j, 'Rgadrid'));
    }
  }
  if (adressid != null) {
    adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id = \'',adressid,'\''].join(''))).setPageSize(1)))[0];
    if (adresse != null) {
      ___arguments.context.pageData['selectedGeopoint'] = (new Backendless.Data.Point().setX((getObjectProperty(adresse, 'lng'))).setY((getObjectProperty(adresse, 'lat'))));
    }
  }
  ___arguments.context.pageData['whereClauseBerichtItem'] = (['Kundennr = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''));
  ___arguments.context.pageData['WhereClauseBerichte'] = (['Kundennr = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\' and Aktiv = 1'].join(''));
  if ((await Backendless.Data.of('BereicheInTouren').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['KundennrAuftrag = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''))))) > 0) {
    ___arguments.context.appData['TourKundeID'] = (getObjectProperty(((await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundennrAuftrag = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\''].join(''))).setPageSize(1)))[0]), 'KundeTourID'));
  } else {
    ___arguments.context.appData['TourKundeID'] = (getObjectProperty(___arguments.context.appData, 'Kundennr'));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/KundePage/components/41a83c7d053ed062d407ea58f908cd78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/0cc88a4accb623088128bf93a18838b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/bb7aa2f8f648bc2982884e6b5d28b992/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/15482c78cd0861f8824a9fe8b35515f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EinlagungslistenPage', ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/d5f8f9de2b0e69f833f38cde306c19e5/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  ['onMapCenterAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedGeopoint')) == null ? ({ 'lng': 0,'lat': 0 }) : (getObjectProperty(___arguments.context.pageData, 'selectedGeopoint')))

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPointsAssignment */
  onPointsAssignment(___arguments) {
      return ((___arguments.context.pageData['selectedGeopoint']) == null ? [] : [(___arguments.context.pageData['selectedGeopoint'])])

  },  
  /* handler:onPointsAssignment */
  /* content */
}))

define('./pages/KundePage/components/57a8ea5166d175481ce87008fb1820b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundePreisePage', ___arguments.context.appData);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/97d854182a5e0318c698df78824d287a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('BestellungenPage', ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/d603a54507ac184f760f549ca088f4f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('EinlagungslistenPage', ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/68746e98d21b2adafbd29d28ff2c7b6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('BestellungenPage', ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/d026281c6fb8fa133a3840148b84d431/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['SelectedItem'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['InputBericht'] = (getObjectProperty(___arguments.selectedRecord, 'Bericht'));
    ___arguments.context.pageData['InputBetreff'] = (getObjectProperty(___arguments.selectedRecord, 'Betreff'));
    ___arguments.context.pageData['InputAnsprechpartner'] = (getObjectProperty(___arguments.selectedRecord, 'Ansprechpartner'));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('1db86bc885725fc5bc25fb3a93787a1b');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/KundePage/components/591a649535c8548b12bca12692c8fec8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1db86bc885725fc5bc25fb3a93787a1b');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/9d63717809e8fd87e4c8d5c7b73835ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    item = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'SelectedItem'));
    item['Aktiv'] = false;
    await Backendless.Data.of('Wochenbericht').save(item, true);
    ___arguments.context.pageData['WhereClauseBerichte'] = 'Kundennr = \'998877\'';
    ___arguments.context.pageData['WhereClauseBerichte'] = (['Kundennr = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\' and Aktiv = 1'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1db86bc885725fc5bc25fb3a93787a1b');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/4698c5b8ba88eac8be650a1898988586/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, valid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    valid = true;
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBetreff')) == '') {
      (function (message) { alert(message) })('Betreff nicht ausgefüllt!');
      valid = false;
    }
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBericht')) == '') {
      (function (message) { alert(message) })('Bericht nicht ausgefüllt!');
      valid = false;
    }
    if (valid == true) {
      item = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'SelectedItem'));
      item['Bericht'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBericht'));
      item['Betreff'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBetreff'));
      item['Ansprechpartner'] = ((typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputAnsprechpartner')) === 'undefined') || ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputAnsprechpartner')) === null) ? '' : (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputAnsprechpartner')));
      item['Datum'] = (new Date());
      item['Userid'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel'));
      await Backendless.Data.of('Besuchsberichte').save(item, true);
      ___arguments.context.pageData['WhereClauseBerichte'] = 'Kundennr = \'998877\'';
      ___arguments.context.pageData['WhereClauseBerichte'] = (['Kundennr = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\' and Aktiv = 1'].join(''));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1db86bc885725fc5bc25fb3a93787a1b');
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/fcdb3348b9081b4fc725a1b51ac88328/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InputBericht'] = '';
  ___arguments.context.pageData['InputAnsprechpartner'] = '';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e7fed6453378349796689918449806a8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/e1f801a1dd2d30c88e1badb52f286c58/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.Data.of('DocumentRef').save( ({ [`Aktiv`]: true,[`Id`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),[`Src`]: (JSON.stringify(___arguments.uploadedFilesPath)).slice((((JSON.stringify(___arguments.uploadedFilesPath)).indexOf('/') + 1 + 1) - 1), ((JSON.stringify(___arguments.uploadedFilesPath)).lastIndexOf('"') + 1) - 1),[`Bemerkung`]: 'Dokument',[`Table`]: 'Besuchsberichte' }) );
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseDateien'] = (['Id = \'','12345','\''].join(''));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseDateien'] = (['Id = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),'\' and Aktiv = 1'].join(''));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('e1f801a1dd2d30c88e1badb52f286c58');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (message) { alert(message) })(___arguments.error);

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/KundePage/components/6a28d42bae4841a8ecd20792de498409/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('244e61c836ab226257e9a018a3f89454', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac6390569d988b08e145b57810288fb8', true);
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['SelectedFile'] = ___arguments.selectedRecord;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/KundePage/components/244e61c836ab226257e9a018a3f89454/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'SelectedFile'))['Aktiv'] = false;
  await Backendless.Data.of('DocumentRef').save((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'SelectedFile')), true);
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseDateien'] = (['Id = \'','12345','\''].join(''));
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseDateien'] = (['Id = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),'\' and Aktiv = 1'].join(''));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('244e61c836ab226257e9a018a3f89454', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/963954eb952878b81c382ffdbf8c4768/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBericht')) == '' || ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBericht')) === null) || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBericht')) === 'undefined')) {
    (function (message) { alert(message) })('Kein Bericht ausgefüllt!');
  } else {
    await Backendless.Data.of('Besuchsberichte').save( ({ [`Aktiv`]: true,[`Betreff`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBetreff')),[`Bericht`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputBericht')),[`Ansprechpartner`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'InputAnsprechpartner')),[`Datum`]: (new Date()),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`Anlagedatum`]: (new Date()),[`Id`]: (generateUUID().long()),[`Userid`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')) }) );
    ___arguments.context.pageData['WhereClauseBerichte'] = (['Kundennr = \'','123456789','\' and Aktiv = 1'].join(''));
    ___arguments.context.pageData['WhereClauseBerichte'] = (['Kundennr = \'',(getObjectProperty(___arguments.context.appData, 'Kundennr')),'\' and Aktiv = 1'].join(''));
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e7fed6453378349796689918449806a8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/064a2bdc18f8dca82fae0bb8a9c948dc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputBericht'] = (getObjectProperty(___arguments.context.pageData, 'InputBericht'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputBetreff'] = (getObjectProperty(___arguments.context.pageData, 'InputBetreff'));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['InputAnsprechpartner'] = (getObjectProperty(___arguments.context.pageData, 'InputAnsprechpartner'));
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedItem')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedItem'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedItem')) === 'object')) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['SelectedItem'] = (getObjectProperty(___arguments.context.pageData, 'SelectedItem'));
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseDateien'] = (['Id = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),'\' And Aktiv = 1'].join(''));
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseAufgaben'] = (['ExtId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),'\''].join(''));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('244e61c836ab226257e9a018a3f89454', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac6390569d988b08e145b57810288fb8', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a28d42bae4841a8ecd20792de498409', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('244e61c836ab226257e9a018a3f89454', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1f801a1dd2d30c88e1badb52f286c58', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5b1005d44e2b0733eb875a87d882138', false);
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/KundePage/components/ac6390569d988b08e145b57810288fb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://eu.backendlessappcontent.com/1D587F4E-EAEB-B148-FF91-47B0E1F88F00/E3B4C2E3-C10A-4707-8B97-06ED12C3409C/files/UploadedDocuments/') + String(getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'SelectedFile')), 'Src'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/b5b1005d44e2b0733eb875a87d882138/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5b1005d44e2b0733eb875a87d882138', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('637e36888ac88bde91fccbb8c938a473', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebca41d842c848df13cf1f69d2eac935', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', false);
    (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('d718e5cc98f8e4899a680d0801068bdd', (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'kuerzel')),[`label`]: (getObjectProperty(item, 'name')) });}))));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/2a15d0580498cc4824b4fcdc39a89e7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5b1005d44e2b0733eb875a87d882138', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('637e36888ac88bde91fccbb8c938a473', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebca41d842c848df13cf1f69d2eac935', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', true);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/3ea83de8dbc8900a88e83628ea6ea0b1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentTabId() })('dee84848c0268082e5f7f0162848a498')) == 'TabDateien')

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('6f6d1e1d04ad62b8b51fe8aab11534d9')['WhereClauseDateien'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'WhereClauseDateien'));
  ___arguments.context.getPodDataModelByUid('6f6d1e1d04ad62b8b51fe8aab11534d9')['WhereClauseAufgaben'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'WhereClauseAufgaben'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/KundePage/components/984e1f086688daafd70887610d78cce3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentTabId() })('dee84848c0268082e5f7f0162848a498')) == 'TabAufgaben')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/KundePage/components/637e36888ac88bde91fccbb8c938a473/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, returnObject, bericht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    returnObject = (await Backendless.Data.of('AufgabeMitarbeiter').save( ({ [`AnUser`]: (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['kuerzel = \'',(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'anUserText')),'\''].join(''))).setPageSize(10)))[0]), 'email')),[`Bemerkung`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'bemerkungText')),[`Eilig`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'eiligCheckbox')),[`ExtId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),[`Typ`]: 'Besuchsbericht',[`VonUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }) ));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['anUserText'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['bemerkungText'] = '';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['eiligCheckbox'] = false;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseAufgaben'] = 'ExtId = \'ABC\'';
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['WhereClauseAufgaben'] = (['ExtId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedItem')), 'objectId')),'\''].join(''));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5b1005d44e2b0733eb875a87d882138', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('637e36888ac88bde91fccbb8c938a473', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebca41d842c848df13cf1f69d2eac935', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', true);
    bericht = (await Backendless.Data.of('Besuchsberichte').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(returnObject, 'ExtId')),'\''].join(''))).setPageSize(10)))[0];
    await Backendless.Messaging.sendEmail('Es wurde eine Aufgabe für dich erstellt', new Backendless.Bodyparts({ htmlmessage: ([(getObjectProperty(returnObject, 'Eilig')) ? '<p><span style="color:#d32f2f;"><strong>EILIGE AUFGABE</strong></span></p>' : '','<p><span style="color:#8ec119;font-family:Arial, Helvetica, sans-serif;"><strong>Von:</strong></span><span style="font-family:Arial, Helvetica, sans-serif;"> ',(getObjectProperty(returnObject, 'VonUser')),'</span></p>','<p><span style="color:#8ec119;font-family:Arial, Helvetica, sans-serif;"><strong>Aufgabentext: </strong></span><span style="font-family:Arial, Helvetica, sans-serif;">',(getObjectProperty(returnObject, 'Bemerkung')),'</span><br>&nbsp;</p>','<hr>','<p><br><span style="color:hsl(213, 93%, 30%);font-family:Arial, Helvetica, sans-serif;"><strong>Daten Besuchsbericht</strong></span><br><br><span style="color:#8ec119;font-family:Arial, Helvetica, sans-serif;"><strong>Ansprechpartner: </strong></span><span style="font-family:Arial, Helvetica, sans-serif;">',(getObjectProperty(bericht, 'Ansprechpartner')),'</span><br><br><span style="color:#8ec119;font-family:Arial, Helvetica, sans-serif;"><strong>Besuchsbericht vom ',[(new Date((new Date())).getDate()),'.',(new Date((new Date())).getMonth() + 1),'.',(new Date((new Date())).getFullYear())].join(''),': </strong></span><span style="font-family:Arial, Helvetica, sans-serif;"><strong> </strong>',(getObjectProperty(bericht, 'Bericht')),'</span></p>'].join('')) }), ensureArray([(getObjectProperty(returnObject, 'AnUser'))]), undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/cf6832e3f1a85c456a8730640b38ed77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a28d42bae4841a8ecd20792de498409', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac6390569d988b08e145b57810288fb8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('244e61c836ab226257e9a018a3f89454', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1f801a1dd2d30c88e1badb52f286c58', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebca41d842c848df13cf1f69d2eac935', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5b1005d44e2b0733eb875a87d882138', false);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf6832e3f1a85c456a8730640b38ed77'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf6832e3f1a85c456a8730640b38ed77'))['background-color'] = '#043373';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b5480bc8a868a8eff0415438fef68235'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b5480bc8a868a8eff0415438fef68235'))['background-color'] = '#E4E0E0';

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/b5480bc8a868a8eff0415438fef68235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a28d42bae4841a8ecd20792de498409', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac6390569d988b08e145b57810288fb8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('244e61c836ab226257e9a018a3f89454', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1f801a1dd2d30c88e1badb52f286c58', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ebca41d842c848df13cf1f69d2eac935', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5248e0825c1f7e8bed38a7682d188ca4', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a15d0580498cc4824b4fcdc39a89e7a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('637e36888ac88bde91fccbb8c938a473', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5b1005d44e2b0733eb875a87d882138', true);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b5480bc8a868a8eff0415438fef68235'))['color'] = '#FFFFFF';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b5480bc8a868a8eff0415438fef68235'))['background-color'] = '#043373';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf6832e3f1a85c456a8730640b38ed77'))['color'] = '#000000';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cf6832e3f1a85c456a8730640b38ed77'))['background-color'] = '#E4E0E0';

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePage/components/5248e0825c1f7e8bed38a7682d188ca4/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['objectIdTask'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/KundePreisePage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var j;


  if (!(await Backendless.UserService.isValidLogin())) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);
  }
  var j_list = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((String('Kundennr=') + String(___arguments.context.appData['Kundennr']))).setPageSize(10)));
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData['uiKundennummer'] = (['Kunde: ',(j['Kundennr']),' - ',(j['Name1'])].join(''));
    if ((j['AllgemeinerRabatt']) == null) {
      ___arguments.context.pageData['uiKundenrabatt'] = '---';
    } else {
      ___arguments.context.pageData['uiKundenrabatt'] = (String(j['AllgemeinerRabatt']) + String(' %'));
      ___arguments.context.pageData['Kundenrabatt'] = (j['AllgemeinerRabatt']);
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/KundePreisePage/components/41a83c7d053ed062d407ea58f908cd78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePreisePage/components/0cc88a4accb623088128bf93a18838b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePreisePage/components/bb7aa2f8f648bc2982884e6b5d28b992/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePreisePage/components/15482c78cd0861f8824a9fe8b35515f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EinlagungslistenPage', ___arguments.context.appData);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundePreisePage/components/62ea6171ab58eef28e7833589e089cc8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
    var i, listPreise, bisWert, listStaffeln, preise, preiseTemp, staffeln, staffelTemp, help;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((___arguments.selectedRecord['Rabgr']) == null) {
    ___arguments.context.pageData['uiRabgr'] = '---';
  } else {
    ___arguments.context.pageData['uiRabgr'] = (___arguments.selectedRecord['Rabgr']);
  }
  ___arguments.context.pageData['uiVk'] = (String(___arguments.selectedRecord['Vk1']) + String(' €'));
  ___arguments.context.pageData['ValuePictureUrl'] = (['https://eu.backendlessappcontent.com/1D587F4E-EAEB-B148-FF91-47B0E1F88F00/31D52F93-6FE5-4901-A33C-8915ABD6F01B/files/Artikelbilder/',(___arguments.selectedRecord['Artnr']),'.jpg'].join(''));
  if ((___arguments.selectedRecord['SSB']) == null) {
    ___arguments.context.pageData['uiSSB'] = 'nein';
    if ((___arguments.selectedRecord['Rabgr']) == 'R') {
      if (!((___arguments.context.pageData['uiKundenrabatt']) == '---')) {
        ___arguments.context.pageData['uiKundenpreis'] = (String(Math.round((___arguments.selectedRecord['Vk1']) * (1 - (___arguments.context.pageData['Kundenrabatt']) / 100) * 100) / 100) + String(' €'));
      } else {
        ___arguments.context.pageData['uiKundenpreis'] = (String(___arguments.selectedRecord['Vk1']) + String(' €'));
      }
    } else {
      ___arguments.context.pageData['uiKundenpreis'] = (String(___arguments.selectedRecord['Vk1']) + String(' €'));
    }
  } else {
    ___arguments.context.pageData['uiSSB'] = (___arguments.selectedRecord['SSB']);
    ___arguments.context.pageData['uiKundenpreis'] = '0.00 € (SSB)';
  }
  if ((___arguments.selectedRecord['Staffelpreise']) != null) {
    ___arguments.context.pageData['uiStaffelpreisResult'] = '';
    help = (___arguments.selectedRecord['Staffelpreise']);
    preise = help.slice(((help.indexOf(':') + 1 + 1) - 1), help.length);
    staffeln = help.slice(0, (help.indexOf(':') + 1) - 1);
    listStaffeln = [];
    listPreise = [];
    while (!!staffeln.length) {
      staffelTemp = staffeln.slice(0, (staffeln.indexOf('/') + 1) - 1);
      staffeln = staffeln.slice(((staffeln.indexOf('/') + 1 + 1) - 1), staffeln.length);
      addItemToList(listStaffeln, staffelTemp);
      if (staffeln.indexOf('/') + 1 == 0) {
        addItemToList(listStaffeln, staffeln);
        staffeln = '';
      }
    }
    while (!!preise.length) {
      preiseTemp = preise.slice(0, (preise.indexOf(';') + 1) - 1);
      preise = preise.slice(((preise.indexOf(';') + 1 + 1) - 1), preise.length);
      addItemToList(listPreise, preiseTemp);
      if (preise.indexOf(';') + 1 == 0) {
        addItemToList(listPreise, preise);
        preise = '';
      }
    }
    var i_end = listStaffeln.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      if (i + 1 <= listStaffeln.length) {
        bisWert = listStaffeln[((i + 1) - 1)] - 1;
      } else {
        bisWert = '';
      }
      ___arguments.context.pageData['uiStaffelpreisResult'] = ([(___arguments.context.pageData['uiStaffelpreisResult']),listStaffeln[(i - 1)],'-',bisWert,'   |   ',listPreise[(i - 1)],' €','\n'].join(''));
    }
  } else {
    ___arguments.context.pageData['uiStaffelpreisResult'] = '';
  }

  },  
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/KundenPage/components/7f78932893c5dfd6f4f67a48e14df478/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['Kundennr'] = (getObjectProperty(___arguments.selectedRecord, 'Kundennr'));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundePage', ___arguments.context.appData);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/KundenPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  ___arguments.context.pageData['toggleNurEinlagerungskunden'] = false;
  ___arguments.context.pageData['toggleList'] = false;
  ___arguments.context.pageData['whereClause'] = 'Kundennr is not null';
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4782c788038ebc8f90db7f1c7d8330f')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/KundenPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundenPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundenPage/components/75687c5c480594b7317ee0382f91b47a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/KundenPage/components/46e8c5c81bb27c48c8688fecc608a6f2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, whereText, kdnrList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['toggleList'] = ___arguments.value;
    if (___arguments.value) {
      kdnrList = [];
      var item_list = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundennrAuftrag like \'%',(getObjectProperty(___arguments.context.pageData, 'valueSearch')),'%\''].join(''))).setPageSize(100)));
      for (var item_index in item_list) {
        item = item_list[item_index];
        addItemToList(kdnrList, (getObjectProperty(item, 'KundeTourID')));
      }
      whereText = '(';
      if (kdnrList.length > 0) {
        for (var item_index2 in kdnrList) {
          item = kdnrList[item_index2];
          whereText = String(whereText) + String(['\'',item,'\''].join(''));
          if (item != kdnrList.slice(-1)[0]) {
            whereText = String(whereText) + String(',');
          }
        }
      } else {
        whereText = String(whereText) + String('\'\'');
      }
      whereText = String(whereText) + String(')');
      ___arguments.context.pageData['whereClause'] = (['((Name1 like \'%',(getObjectProperty(___arguments.context.pageData, 'valueSearch')),'%\' or Kundennr like \'%',(getObjectProperty(___arguments.context.pageData, 'valueSearch')),'%\') and KundeTourExt is not null) OR Kundennr IN ',whereText].join(''));
    } else {
      ___arguments.context.pageData['whereClause'] = (['(Name1 like \'%',(getObjectProperty(___arguments.context.pageData, 'valueSearch')),'%\' or Kundennr like \'%',(getObjectProperty(___arguments.context.pageData, 'valueSearch')),'%\')'].join(''));
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/KundenPage/components/d4782c788038ebc8f90db7f1c7d8330f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, whereText, kdnrList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (getObjectProperty(___arguments.context.pageData, 'toggleList')) {
      kdnrList = [];
      var item_list = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundennrAuftrag like \'%',___arguments.value,'%\''].join(''))).setPageSize(100)));
      for (var item_index in item_list) {
        item = item_list[item_index];
        addItemToList(kdnrList, (getObjectProperty(item, 'KundeTourID')));
      }
      whereText = '(';
      if (kdnrList.length > 0) {
        for (var item_index2 in kdnrList) {
          item = kdnrList[item_index2];
          whereText = String(whereText) + String(['\'',item,'\''].join(''));
          if (item != kdnrList.slice(-1)[0]) {
            whereText = String(whereText) + String(',');
          }
        }
      } else {
        whereText = String(whereText) + String('\'\'');
      }
      whereText = String(whereText) + String(')');
      ___arguments.context.pageData['whereClause'] = (['((Name1 like \'%',___arguments.value,'%\' or Kundennr like \'%',___arguments.value,'%\') and KundeTourExt is not null) OR Kundennr IN ',whereText].join(''));
    } else {
      ___arguments.context.pageData['whereClause'] = (['(Name1 like \'%',___arguments.value,'%\' or Kundennr like \'%',___arguments.value,'%\')'].join(''));
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/LoginPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    
  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/LoginPage/components/f31888883beb0b3857784f6d45f81afc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'password')), true  );
    ___arguments.context.pageData['statusMessage'] = (String('Login successful') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21a8f868a3189a48f40e01f6bcda8d63', true);
    if (typeof (getObjectProperty(___arguments.context.pageData, 'redirect')) === 'undefined') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MainPage', ___arguments.context.pageData);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'redirect')), ___arguments.context.pageData);
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('Failed Login-Try at superstore.web', new Backendless.Bodyparts({ textmessage: (String('Mail: ') + String(getObjectProperty(___arguments.context.pageData, 'email'))) }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);
    ___arguments.context.pageData['statusMessage'] = 'Login fehlgeschlagen!';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21a8f868a3189a48f40e01f6bcda8d63', true);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/LoginPage/components/be43f9e33698f7a8087b559b95d8ae2a/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async onKeyDown(___arguments) {
    var error;


  if (___arguments.keyCode == 13) {
    try {
      await Backendless.UserService.login( (___arguments.context.pageData['email']), (___arguments.context.pageData['password']), true  );
      ___arguments.context.pageData['statusMessage'] = (String('Login successful') + String((await Backendless.UserService.getCurrentUser(false))['name']));
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21a8f868a3189a48f40e01f6bcda8d63', true);
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', ___arguments.context.pageData);

    } catch (error) {
      ___arguments.context.pageData['statusMessage'] = 'Login fehlgeschlagen!';
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21a8f868a3189a48f40e01f6bcda8d63', true);
      console.log(error);

    }
  }

  },  
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/LoginPage/components/0beaaa42adbf1bd8d498b0a856734e98/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == 13) {
    try {
      await Backendless.UserService.login( (getObjectProperty(___arguments.context.pageData, 'email')), (getObjectProperty(___arguments.context.pageData, 'password')), true  );
      ___arguments.context.pageData['statusMessage'] = (String('Login successful') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21a8f868a3189a48f40e01f6bcda8d63', true);
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MainPage', ___arguments.context.pageData);

    } catch (error) {
      ___arguments.context.pageData['statusMessage'] = 'Login fehlgeschlagen!';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('21a8f868a3189a48f40e01f6bcda8d63', true);
      console.log(error);

    }
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/LoginPage/components/4c1832483a28ea1529f87d0f5238fa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'email')) === 'undefined') {
      (function (message) { alert(message) })('E-Mail eingeben');
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'email')) == '') {
        (function (message) { alert(message) })('E-Mail eingeben');
      } else {
        await Backendless.UserService.restorePassword((getObjectProperty(___arguments.context.pageData, 'email')));
        (function (message) { alert(message) })('Falls der User bekannt ist, wird eine Mail zur Passwortwiederherstellung an die angegebene Mail gesendet.');
      }
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, j, k, sekunden, minuten, stunden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  try {
    if (!(await Backendless.UserService.isValidLogin())) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'gerrit.marttila@mar-med.de' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'marttila@outlook.com') {
        ___arguments.context.pageData['isAdmin'] = true;
      } else {
        ___arguments.context.pageData['isAdmin'] = false;
      }
    }

  } catch (error) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);

  }
  try {
    sekunden = 0;
    minuten = 0;
    stunden = 0;

    ;(function() {
      const callback = async () => {
          sekunden = sekunden + 1;
      if (sekunden == 60) {
        minuten = minuten + 1;
        sekunden = 0;
      }
      if (minuten == 60) {
        stunden = stunden + 1;
        minuten = 0;
      }
      ___arguments.context.pageData['sessionCounter'] = ([stunden,':',minuten,':',sekunden].join(''));

      };

      const timerId = 'sessionCounter';
      const timerDelay = 1000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    ___arguments.context.pageData['uiUser'] = (String('User: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'kuerzel')));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/MainPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('KundenPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TourArchivePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/10f7415fcd5b728b74ca76696c188d26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ArtikelChangePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SettingsPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/cca63bc26a26a9384308eff8bf1feafe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TempControlPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MainPage/components/d97c71e87a380fc4357fe4ce03e5c608/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('CarCharging', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileArtikel/components/87c5dd184fbc8279283f498e9f627bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileTestPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileArtikel/components/7f889d7226bdb948b4ec529804c891e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileEinstellungen', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileArtikel/components/0628ac7294a82d3bccb823e51584e408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileListe', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileArtikel/components/d5f860589308a8c92d4b5219150872ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileArtikel', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileArtikel/components/c5b3f958b97811821f28528803b15212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileInformation', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileEinstellungen/components/87c5dd184fbc8279283f498e9f627bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileTestPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileEinstellungen/components/7f889d7226bdb948b4ec529804c891e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileEinstellungen', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileEinstellungen/components/0628ac7294a82d3bccb823e51584e408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileListe', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileEinstellungen/components/d5f860589308a8c92d4b5219150872ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileArtikel', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileEinstellungen/components/c5b3f958b97811821f28528803b15212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileInformation', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileInformation/components/87c5dd184fbc8279283f498e9f627bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileTestPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileInformation/components/7f889d7226bdb948b4ec529804c891e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileEinstellungen', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileInformation/components/0628ac7294a82d3bccb823e51584e408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileListe', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileInformation/components/d5f860589308a8c92d4b5219150872ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileArtikel', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileInformation/components/c5b3f958b97811821f28528803b15212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileInformation', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileListe/components/87c5dd184fbc8279283f498e9f627bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileTestPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileListe/components/7f889d7226bdb948b4ec529804c891e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileEinstellungen', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileListe/components/0628ac7294a82d3bccb823e51584e408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileListe', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileListe/components/d5f860589308a8c92d4b5219150872ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileArtikel', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileListe/components/c5b3f958b97811821f28528803b15212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileInformation', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/87c5dd184fbc8279283f498e9f627bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileTestPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/7f889d7226bdb948b4ec529804c891e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileEinstellungen', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/0628ac7294a82d3bccb823e51584e408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileListe', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/d5f860589308a8c92d4b5219150872ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileArtikel', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/c5b3f958b97811821f28528803b15212/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MobileInformation', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/8b3d2828209fdfc8f01f6947bc885c58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f07fec8d85843a795383868d52812a8', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da78696b5f5ff90cd478d5b3654bd008', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f8c913686449d859bdcae79f789138', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c8a5f8dbc87758249b687897b8f028', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0b91e6a28e886186568c1088f082ce8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe898f42e2870b846e80c5b3e98a5e8', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('8b3d2828209fdfc8f01f6947bc885c58'))['color'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('22f8d38833751638b54292e857b991b8'))['background'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cda8c2f782c8f84b41f8ff399f28d718'))['color'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('84287318ecc869912e186958ef98f5f8'))['background'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d5428bf8c148cbe34362193851b3dd61'))['color'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a85cd842580f1878064709d2e829e8'))['background'] = 'white';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/cda8c2f782c8f84b41f8ff399f28d718/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f07fec8d85843a795383868d52812a8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da78696b5f5ff90cd478d5b3654bd008', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f8c913686449d859bdcae79f789138', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c8a5f8dbc87758249b687897b8f028', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0b91e6a28e886186568c1088f082ce8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe898f42e2870b846e80c5b3e98a5e8', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('8b3d2828209fdfc8f01f6947bc885c58'))['color'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('22f8d38833751638b54292e857b991b8'))['background'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cda8c2f782c8f84b41f8ff399f28d718'))['color'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('84287318ecc869912e186958ef98f5f8'))['background'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d5428bf8c148cbe34362193851b3dd61'))['color'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a85cd842580f1878064709d2e829e8'))['background'] = 'white';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/d5428bf8c148cbe34362193851b3dd61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f07fec8d85843a795383868d52812a8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da78696b5f5ff90cd478d5b3654bd008', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f8c913686449d859bdcae79f789138', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c8a5f8dbc87758249b687897b8f028', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0b91e6a28e886186568c1088f082ce8', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe898f42e2870b846e80c5b3e98a5e8', true);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('8b3d2828209fdfc8f01f6947bc885c58'))['color'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('22f8d38833751638b54292e857b991b8'))['background'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cda8c2f782c8f84b41f8ff399f28d718'))['color'] = 'black';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('84287318ecc869912e186958ef98f5f8'))['background'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d5428bf8c148cbe34362193851b3dd61'))['color'] = 'white';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a1a85cd842580f1878064709d2e829e8'))['background'] = 'black';

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/MobileTestPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f07fec8d85843a795383868d52812a8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da78696b5f5ff90cd478d5b3654bd008', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35f8c913686449d859bdcae79f789138', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('57c8a5f8dbc87758249b687897b8f028', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0b91e6a28e886186568c1088f082ce8', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3fe898f42e2870b846e80c5b3e98a5e8', false);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/NewTourPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var item, error, result, numberOfDays, input, varDate, listeOptionen, j, listeTouren, wochentag, getIntTag;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(await Backendless.UserService.isValidLogin())) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);
  }
  ___arguments.context.pageData['TitleTour'] = (___arguments.context.appData['TourCreate']);
  ___arguments.context.pageData['ValueDatumTour'] = (___arguments.context.appData['TourDatum']);
  ___arguments.context.pageData['TourDatum'] = (___arguments.context.appData['TourDatum']);
  try {
    getIntTag = (new Date((___arguments.context.appData['TourDatum'])).getDay());
    if (getIntTag == 1) {
      wochentag = 'Montag';
    } else if (getIntTag == 2) {
      wochentag = 'Dienstag';
    } else if (getIntTag == 3) {
      wochentag = 'Mittwoch';
    } else if (getIntTag == 4) {
      wochentag = 'Donnerstag';
    } else if (getIntTag == 5) {
      wochentag = 'Freitag';
    } else {
      wochentag = 'Wochenende';
    }
    if (wochentag != 'Wochenende') {
      listeTouren = (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Wochentag=\'',wochentag,'\''].join(''))).setSortBy('Name').setPageSize(10)));
      listeOptionen = [];
      for (var j_index in listeTouren) {
        j = listeTouren[j_index];
        addItemToList(listeOptionen, (j['Name']));
      }
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('8117c3fbc44cc913871f08a24f8cade1', (await Promise.all(listeOptionen.map(async item => {; return ({ 'value': item,'label': item });}))));
    } else {
    }
    input = (new Date((___arguments.context.appData['TourDatum'])));
    varDate = (new Date((String(new Date(input).getFullYear()) + String('-01-04'))));
    numberOfDays = Math.floor((input - varDate) / (24 * 60 * 60 * 1000));
    result = Math.ceil(((new Date(input).getDay()) + 1 + numberOfDays) / 7);
    ___arguments.context.pageData['kalenderwoche'] = result;
    try {
      ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])))))) == 0) {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
      }

    } catch (error) {

    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }
  ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('8117c3fbc44cc913871f08a24f8cade1', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ 'value': (item['Name']),'label': (item['Name']) });}))));
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('8117c3fbc44cc913871f08a24f8cade1', (___arguments.context.appData['TourCreate']));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/NewTourPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/f6bd6b489f283868e49c11f80f630705/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async onRecordSelect(___arguments) {
    var error, ausgewaehlterKunde, lat, lng, jsonResult, dbKunde;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8aa8285fc67d35c4f7284b9848389528', false);
    ___arguments.context.pageData['ValueCheckliste'] = '';
    ___arguments.context.pageData['selectedItem'] = (___arguments.selectedRecord['objectId']);
    ___arguments.context.pageData['KundeID'] = (___arguments.selectedRecord['KundeID']);
    ___arguments.context.pageData['KdnrListe'] = [(___arguments.selectedRecord['KundeID'])];
    ___arguments.context.pageData['aktuellerKundeObject'] = ___arguments.selectedRecord;
    ___arguments.context.pageData['ValueInfoFahrer'] = (___arguments.selectedRecord['InfoFuerFahrer']);
    dbKunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(___arguments.selectedRecord['KundeID']),'\''].join(''))).setPageSize(10)))[0];
    if ((dbKunde['Lieferadrid']) != null && !!(dbKunde['Lieferadrid']).length) {
      ausgewaehlterKunde = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(dbKunde['Lieferadrid']),'\''].join(''))).setPageSize(10)))[0];
    } else {
      ausgewaehlterKunde = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(dbKunde['Rgadrid']),'\''].join(''))).setPageSize(10)))[0];
    }
    if (ausgewaehlterKunde != !null) {
      if ((ausgewaehlterKunde['locationMaps']) == null) {
        jsonResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?address=',(ausgewaehlterKunde['Str']),' ',(ausgewaehlterKunde['Plz']),' ',(ausgewaehlterKunde['Ort1']),'&key=','AIzaSyA0LINu3Z7ryVNYTtilJM6I-HVrEgr3wzg'].join('')))).setEncoding('utf8').send());
        lat = (((((jsonResult['results'])[0])['geometry'])['location'])['lat']);
        lng = (((((jsonResult['results'])[0])['geometry'])['location'])['lng']);
        ausgewaehlterKunde['locationMaps'] = (new Backendless.Data.Point().setX(lng).setY(lat));
        await Backendless.Data.of('Adressen').save( ausgewaehlterKunde );
        ___arguments.context.pageData['GeodatenEinzel'] = (ausgewaehlterKunde['locationMaps']);
        ___arguments.context.pageData['GeodatenListe'] = [(ausgewaehlterKunde['locationMaps'])];
      } else {
        ___arguments.context.pageData['GeodatenEinzel'] = (ausgewaehlterKunde['locationMaps']);
        ___arguments.context.pageData['GeodatenListe'] = [(ausgewaehlterKunde['locationMaps'])];
      }
    } else {
      ;await ( async function (message){ alert(message) })('Fehler');
    }
    ___arguments.context.pageData['WhereClauseCheckliste'] = (['ExtId=\'',(___arguments.selectedRecord['objectId']),'\''].join(''));

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/NewTourPage/components/6798732761d8dd38d8984723b728af08/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
    var error;


  ___arguments.context.pageData['objectId'] = (___arguments.selectedRecord['objectId']);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/NewTourPage/components/12988a68ece4f7d8ee6852d937b969c8/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  onPointsAssignment(___arguments) {
      return ((___arguments.context.pageData['GeodatenListe']) == null ? [] : (___arguments.context.pageData['GeodatenListe']))

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  onMapCenterAssignment(___arguments) {
      return ((___arguments.context.pageData['GeodatenEinzel']) == null ? (new Backendless.Data.Point().setX(9.584453641765714).setY(54.31121263817992)) : (___arguments.context.pageData['GeodatenEinzel']))

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPanChange */
  onPanChange(___arguments) {
      ___arguments.context.pageData['GeodatenEinzel'] = ___arguments.value;

  },
  /* handler:onPanChange */
  /* handler:onMarkerClick */
  async onMarkerClick(___arguments) {
    var error, adressListe, j, k;


  var j_list = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Within(locationMaps,\'',(___arguments.point.asWKT()),'\') = True'].join(''))).setPageSize(10)));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (___arguments.context.pageData['KdnrListe']);
    for (var k_index in k_list) {
      k = k_list[k_index];
      if (k == (j['Kdliefnr'])) {
        adressListe = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(j['Kdliefnr']),'\''].join(''))).setPageSize(10)))[0];
        break;
      }
    }
  }
  try {
    ;(function (componentUid, marker, popupContent){ ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('12988a68ece4f7d8ee6852d937b969c8', ___arguments.point, (adressListe['Name1']));

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/NewTourPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/8117c3fbc44cc913871f08a24f8cade1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var error, directionsObject, resultList, adressListe, kundennrList, j;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['TitleTour'] = ___arguments.value;
  try {
    ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
    ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
    if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])))))) == 0) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
    }
    resultList = (await BackendlessUI.Functions.Custom['fn_ba0c3c756877806f7a8717c220f2462c']((___arguments.context.pageData['WhereClauseRealTour'])));
    kundennrList = [];
    var j_list = (await BackendlessUI.Functions.Custom['fn_3c1ee9467b71bb67e9ea12baf20f08d2']((___arguments.context.pageData['WhereClauseRealTour'])));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(kundennrList, j);
    }
    ___arguments.context.pageData['KdnrListe'] = kundennrList;
    directionsObject = (await BackendlessUI.Functions.Custom['fn_38ab1f0d78ea0eca78ce55d65199c92a'](resultList));
    adressListe = [];
    ___arguments.context.pageData['GeodatenListe'] = resultList;
    ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
    if (!(___arguments.context.pageData['GeodatenListe']).length) {
      ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
    } else {
      ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX((((directionsObject['Ost']) + (directionsObject['West'])) / 2)).setY((((directionsObject['Sued']) + (directionsObject['Nord'])) / 2)));
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/NewTourPage/components/dd577a3bc29435dc931e79f52ea27d95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/0fef343a2ba892e6c40eb5318c877228/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var error, result, numberOfDays, input, varDate, item, listeOptionen, j, listeTouren, wochentag, getIntTag;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['TourDatum'] = ___arguments.value;
    ___arguments.context.pageData['ValueDatumTour'] = ___arguments.value;
    getIntTag = (new Date(___arguments.value).getDay());
    if (getIntTag == 1) {
      wochentag = 'Montag';
    } else if (getIntTag == 2) {
      wochentag = 'Dienstag';
    } else if (getIntTag == 3) {
      wochentag = 'Mittwoch';
    } else if (getIntTag == 4) {
      wochentag = 'Donnerstag';
    } else if (getIntTag == 5) {
      wochentag = 'Freitag';
    } else {
      wochentag = 'Wochenende';
    }
    if (wochentag != 'Wochenende') {
      listeTouren = (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Wochentag=\'',wochentag,'\''].join(''))).setSortBy('Name').setPageSize(10)));
      listeOptionen = [];
      for (var j_index in listeTouren) {
        j = listeTouren[j_index];
        addItemToList(listeOptionen, (j['Name']));
      }
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('8117c3fbc44cc913871f08a24f8cade1', (await Promise.all(listeOptionen.map(async item => {; return ({ 'value': item,'label': item });}))));
    } else {
    }
    input = (new Date(___arguments.value));
    varDate = (new Date((String(new Date(input).getFullYear()) + String('-01-04'))));
    numberOfDays = Math.floor((input - varDate) / (24 * 60 * 60 * 1000));
    result = Math.ceil(((new Date(input).getDay()) + 1 + numberOfDays) / 7);
    ___arguments.context.pageData['kalenderwoche'] = result;
    try {
      ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])))))) == 0) {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
      }

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/NewTourPage/components/3958603de9362772b28fca782db83de2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var adressListe, aktuellerKunde, dbObject, directionsObject, error, j, kundennrList, monat, resultList, tag, timeStartDate;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate()) < 10) {
      tag = String('0') + String(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate());
    } else {
      tag = (new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate());
    }
    if ((new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1) < 10) {
      monat = String('0') + String(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1);
    } else {
      monat = (new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1);
    }
    aktuellerKunde = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(___arguments.context.pageData['objectId']),'\''].join(''))).setPageSize(10)))[0];
    timeStartDate = [monat,'/',tag,'/',(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getFullYear()),' 00:00:00',''].join('');
    dbObject = (await Backendless.Data.of('RealTour').save( ({ 'IdTour': [(new Date((___arguments.context.pageData['TourDatum'])).getDate()),(new Date((___arguments.context.pageData['TourDatum'])).getMonth() + 1),(new Date((___arguments.context.pageData['TourDatum'])).getFullYear()),(___arguments.context.pageData['TitleTour'])].join(''),'InfoFuerFahrer': (___arguments.context.pageData['ValueInfoFahrer']),'KundeID': (aktuellerKunde['KundeID']),'PosNr': (aktuellerKunde['Pos']),'Tour': undefined,'TourDate': (new Date(timeStartDate)),'KundeTour': undefined,'Name': (aktuellerKunde['Name']) }) ));
    await Backendless.Data.of('RealTour').setRelation(dbObject, 'Tour', [(await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(___arguments.context.pageData['TitleTour']),'\''].join(''))).setPageSize(10)))[0]]);
    await Backendless.Data.of('RealTour').setRelation(dbObject, 'KundeTour', [(await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(___arguments.context.pageData['objectId']),'\''].join(''))).setPageSize(10)))[0]]);
    await Backendless.Data.of('RealTour').setRelation(dbObject, 'KundeExt', [(await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(aktuellerKunde['KundeID']),'\''].join(''))).setPageSize(10)))[0]]);
    try {
      ___arguments.context.pageData['GeodatenListe'] = [];
      ___arguments.context.pageData['GeodatenEinzel'] = '';
      ___arguments.context.pageData['WhereClauseRealTour'] = '';
      ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      ___arguments.context.pageData['WhereClauseTour'] = '';
      ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])))))) == 0) {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
      }
      resultList = (await BackendlessUI.Functions.Custom['fn_ba0c3c756877806f7a8717c220f2462c']((___arguments.context.pageData['WhereClauseRealTour'])));
      directionsObject = (await BackendlessUI.Functions.Custom['fn_38ab1f0d78ea0eca78ce55d65199c92a'](resultList));
      adressListe = [];
      ___arguments.context.pageData['GeodatenListe'] = resultList;
      ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
      if (!(___arguments.context.pageData['GeodatenListe']).length) {
        ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
      } else {
        ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX((((directionsObject['Ost']) + (directionsObject['West'])) / 2)).setY((((directionsObject['Sued']) + (directionsObject['Nord'])) / 2)));
      }
      kundennrList = [];
      var j_list = (await BackendlessUI.Functions.Custom['fn_3c1ee9467b71bb67e9ea12baf20f08d2']((___arguments.context.pageData['WhereClauseRealTour'])));
      for (var j_index in j_list) {
        j = j_list[j_index];
        addItemToList(kundennrList, j);
      }
      ___arguments.context.pageData['KdnrListe'] = kundennrList;

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/9d75a883904abcd581ea253c6bca04d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/dcb25ca37189ecc52c34505d878250ab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      (___arguments.context.pageData['aktuellerKundeObject'])['InfoFuerFahrer'] = ___arguments.value;
  await Backendless.Data.of('RealTour').save( (___arguments.context.pageData['aktuellerKundeObject']) );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/NewTourPage/components/961b238622284e17ecd852788908bf53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, savedObject;


  try {
    if ((___arguments.context.pageData['ValueCheckliste']).length > 0) {
      savedObject = (await Backendless.Data.of('ChecklisteRealTour').save( ({ 'Bemerkung': (___arguments.context.pageData['ValueCheckliste']),'Status': false }) ));
      await Backendless.Data.of('ChecklisteRealTour').setRelation(savedObject, 'ExtId', [(await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(___arguments.context.pageData['selectedItem']),'\''].join(''))).setPageSize(10)))[0]]);
    } else {
      ;await ( async function (message){ alert(message) })('Keine Eingabe erfolgt');
    }
    ___arguments.context.pageData['WhereClauseCheckliste'] = (['ExtId=\'','','\''].join(''));
    ___arguments.context.pageData['WhereClauseCheckliste'] = (['ExtId=\'',(___arguments.context.pageData['selectedItem']),'\''].join(''));
    ___arguments.context.pageData['ValueCheckliste'] = '';

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/5fc8aed38ab81ef8becd64d8e70ce728/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
      ___arguments.context.pageData['selectedItemCheckliste'] = ___arguments.selectedRecord;
  ___arguments.context.pageData['ValueCheckliste'] = (___arguments.selectedRecord['Bemerkung']);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8aa8285fc67d35c4f7284b9848389528', true);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/NewTourPage/components/8aa8285fc67d35c4f7284b9848389528/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (___arguments.context.pageData['selectedItemCheckliste'])['Bemerkung'] = (___arguments.context.pageData['ValueCheckliste']);
  await Backendless.Data.of('ChecklisteRealTour').save( (___arguments.context.pageData['selectedItemCheckliste']) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/e647979c7e15a5aa59662021ee28f5fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, kundennrList, j, directionsObject, resultList, adressListe, savedObject, aktuellerKunde, timeStartDate, tag, monat;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((new Date((___arguments.context.pageData['TourDatum'])).getMonth() + 1) < 10) {
      monat = String('0') + String(new Date((___arguments.context.pageData['TourDatum'])).getMonth() + 1);
    } else {
      monat = (new Date((___arguments.context.pageData['TourDatum'])).getMonth() + 1);
    }
    if ((new Date((___arguments.context.pageData['TourDatum'])).getDate()) < 10) {
      tag = String('0') + String(new Date((___arguments.context.pageData['TourDatum'])).getDate());
    } else {
      tag = (new Date((___arguments.context.pageData['TourDatum'])).getDate());
    }
    var j_list = (await Backendless.Data.of('LieferscheinKunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lieferdatum = \'',monat,'/',tag,'/',(new Date((___arguments.context.pageData['TourDatum'])).getFullYear()),' 00:00:00\' and Tour like \'%',(___arguments.context.pageData['TitleTour']),'%\''].join(''))).setGroupBy('Kundennr').setPageSize(50)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      aktuellerKunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(j['Kundennr']),'\''].join(''))).setPageSize(10)))[0];
      timeStartDate = [monat,'/',tag,'/',(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getFullYear()),' 00:00:00',''].join('');
      savedObject = (await Backendless.Data.of('RealTour').save( ({ 'IdTour': [(new Date((___arguments.context.pageData['TourDatum'])).getDate()),(new Date((___arguments.context.pageData['TourDatum'])).getMonth() + 1),(new Date((___arguments.context.pageData['TourDatum'])).getFullYear()),(___arguments.context.pageData['TitleTour'])].join(''),'KundeExt': undefined,'KundeID': (aktuellerKunde['Kundennr']),'KundeTour': undefined,'PosNr': undefined,'Tour': undefined,'TourDate': (new Date(timeStartDate)),'Name': (aktuellerKunde['Name1']) }) ));
      await Backendless.Data.of('RealTour').setRelation(savedObject, 'KundeExt', [aktuellerKunde]);
      await Backendless.Data.of('RealTour').setRelation(savedObject, 'Tour', [(await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(___arguments.context.pageData['TitleTour']),'\''].join(''))).setPageSize(10)))[0]]);
    }
    try {
      ___arguments.context.pageData['GeodatenListe'] = [];
      ___arguments.context.pageData['GeodatenEinzel'] = '';
      ___arguments.context.pageData['WhereClauseRealTour'] = '';
      ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      ___arguments.context.pageData['WhereClauseTour'] = '';
      ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])))))) == 0) {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
      }
      resultList = (await BackendlessUI.Functions.Custom['fn_ba0c3c756877806f7a8717c220f2462c']((___arguments.context.pageData['WhereClauseRealTour'])));
      directionsObject = (await BackendlessUI.Functions.Custom['fn_38ab1f0d78ea0eca78ce55d65199c92a'](resultList));
      adressListe = [];
      ___arguments.context.pageData['GeodatenListe'] = resultList;
      ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
      if (!(___arguments.context.pageData['GeodatenListe']).length) {
        ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
      } else {
        ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX((((directionsObject['Ost']) + (directionsObject['West'])) / 2)).setY((((directionsObject['Sued']) + (directionsObject['Nord'])) / 2)));
      }
      kundennrList = [];
      var j_list2 = (await BackendlessUI.Functions.Custom['fn_3c1ee9467b71bb67e9ea12baf20f08d2']((___arguments.context.pageData['WhereClauseRealTour'])));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        addItemToList(kundennrList, j);
      }
      ___arguments.context.pageData['KdnrListe'] = kundennrList;

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/72afda2fb5f892e4dfd8d2582a88910d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var adressListe, aktuellerKunde, dbObject, directionsObject, error, j, kundennrList, monat, resultList, tag, timeStartDate;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (typeof (___arguments.context.pageData['AktuellerManuellerKunde']) === 'undefined') {
    ;await ( async function (message){ alert(message) })('Kein Kunde ausgewählt!');
  } else {
    try {
      if ((new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate()) < 10) {
        tag = String('0') + String(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate());
      } else {
        tag = (new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate());
      }
      if ((new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1) < 10) {
        monat = String('0') + String(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1);
      } else {
        monat = (new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1);
      }
      aktuellerKunde = (___arguments.context.pageData['AktuellerManuellerKunde']);
      timeStartDate = [monat,'/',tag,'/',(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getFullYear()),' 00:00:00',''].join('');
      dbObject = (await Backendless.Data.of('RealTour').save( ({ 'IdTour': [(new Date((___arguments.context.pageData['TourDatum'])).getDate()),(new Date((___arguments.context.pageData['TourDatum'])).getMonth() + 1),(new Date((___arguments.context.pageData['TourDatum'])).getFullYear()),(___arguments.context.pageData['TitleTour'])].join(''),'InfoFuerFahrer': (___arguments.context.pageData['ValueInfoFahrer']),'KundeID': (aktuellerKunde['Kundennr']),'PosNr': undefined,'Tour': undefined,'TourDate': (new Date(timeStartDate)),'KundeTour': undefined,'Name': (aktuellerKunde['Name1']) }) ));
      await Backendless.Data.of('RealTour').setRelation(dbObject, 'Tour', [(await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(___arguments.context.pageData['TitleTour']),'\''].join(''))).setPageSize(10)))[0]]);
      await Backendless.Data.of('RealTour').setRelation(dbObject, 'KundeExt', [(await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(aktuellerKunde['Kundennr']),'\''].join(''))).setPageSize(10)))[0]]);
      try {
        ___arguments.context.pageData['GeodatenListe'] = [];
        ___arguments.context.pageData['GeodatenEinzel'] = '';
        ___arguments.context.pageData['WhereClauseRealTour'] = '';
        ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
        ___arguments.context.pageData['WhereClauseTour'] = '';
        ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
        if ((await Backendless.Data.of('RealTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])))))) == 0) {
          ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
          ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
          ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
          ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
        }
        resultList = (await BackendlessUI.Functions.Custom['fn_ba0c3c756877806f7a8717c220f2462c']((___arguments.context.pageData['WhereClauseRealTour'])));
        directionsObject = (await BackendlessUI.Functions.Custom['fn_38ab1f0d78ea0eca78ce55d65199c92a'](resultList));
        adressListe = [];
        ___arguments.context.pageData['GeodatenListe'] = resultList;
        ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
        if (!(___arguments.context.pageData['GeodatenListe']).length) {
          ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
        } else {
          ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX((((directionsObject['Ost']) + (directionsObject['West'])) / 2)).setY((((directionsObject['Sued']) + (directionsObject['Nord'])) / 2)));
        }
        kundennrList = [];
        var j_list = (await BackendlessUI.Functions.Custom['fn_3c1ee9467b71bb67e9ea12baf20f08d2']((___arguments.context.pageData['WhereClauseRealTour'])));
        for (var j_index in j_list) {
          j = j_list[j_index];
          addItemToList(kundennrList, j);
        }
        ___arguments.context.pageData['KdnrListe'] = kundennrList;

      } catch (error) {
        ;await ( async function (message){ alert(message) })(error);

      }

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/91e8a89b1428e88eb088434a8628a598/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      try {
    if (___arguments.value) {
      ___arguments.context.pageData['KundenManuell'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6798732761d8dd38d8984723b728af08', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3958603de9362772b28fca782db83de2', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('67f55da82ef857c843f83283b41dbbfe', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d75a883904abcd581ea253c6bca04d9', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4d842a4a1781b2cc5c26f9852989438', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72afda2fb5f892e4dfd8d2582a88910d', true);
    } else {
      ___arguments.context.pageData['KundenManuell'] = false;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6798732761d8dd38d8984723b728af08', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3958603de9362772b28fca782db83de2', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('67f55da82ef857c843f83283b41dbbfe', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d75a883904abcd581ea253c6bca04d9', true);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4d842a4a1781b2cc5c26f9852989438', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72afda2fb5f892e4dfd8d2582a88910d', false);
    }

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/NewTourPage/components/67f55da82ef857c843f83283b41dbbfe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var adressListe, directionsObject, error, geloeschteChecklistpunkte, j, kundennrList, monat, resultList, tag;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate()) < 10) {
      tag = String('0') + String(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate());
    } else {
      tag = (new Date((new Date((___arguments.context.pageData['TourDatum'])))).getDate());
    }
    if ((new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1) < 10) {
      monat = String('0') + String(new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1);
    } else {
      monat = (new Date((new Date((___arguments.context.pageData['TourDatum'])))).getMonth() + 1);
    }
    await Backendless.Data.of('RealTour').remove( (___arguments.context.pageData['aktuellerKundeObject']) );
    geloeschteChecklistpunkte = (await Backendless.Data.of('ChecklisteRealTour').bulkDelete( (['ExtId.objectId=\'',((___arguments.context.pageData['aktuellerKundeObject'])['objectId']),'\''].join('')) ));
    if (geloeschteChecklistpunkte > 0) {
      ;await ( async function (message){ alert(message) })((['Kunde aus Tour gelöscht und es wurden zusätzlich ',geloeschteChecklistpunkte,' Punkte aus der Checkliste entfernt.'].join('')));
    }
    try {
      ___arguments.context.pageData['GeodatenListe'] = [];
      ___arguments.context.pageData['GeodatenEinzel'] = '';
      ___arguments.context.pageData['WhereClauseRealTour'] = '';
      ___arguments.context.pageData['WhereClauseRealTour'] = (await BackendlessUI.Functions.Custom['fn_0088331f232d637f1ba36c7945628da5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      ___arguments.context.pageData['WhereClauseTour'] = '';
      ___arguments.context.pageData['whereClauseTour'] = (await BackendlessUI.Functions.Custom['fn_d12f73c1433eb4b70f6aa6b50ce2e7b5']((___arguments.context.pageData['TourDatum']), (___arguments.context.pageData['TitleTour']), (___arguments.context.pageData['kalenderwoche'])));
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b01df3a5a37877f8054ec6e81c6fd3b1', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12155558d7722eb8ded4765833f8cd7d', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('961b238622284e17ecd852788908bf53', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fc8aed38ab81ef8becd64d8e70ce728', false);
      resultList = (await BackendlessUI.Functions.Custom['fn_ba0c3c756877806f7a8717c220f2462c']((___arguments.context.pageData['WhereClauseRealTour'])));
      directionsObject = (await BackendlessUI.Functions.Custom['fn_38ab1f0d78ea0eca78ce55d65199c92a'](resultList));
      adressListe = [];
      ___arguments.context.pageData['GeodatenListe'] = resultList;
      ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
      if (!(___arguments.context.pageData['GeodatenListe']).length) {
        ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
      } else {
        ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX((((directionsObject['Ost']) + (directionsObject['West'])) / 2)).setY((((directionsObject['Sued']) + (directionsObject['Nord'])) / 2)));
      }
      kundennrList = [];
      var j_list = (await BackendlessUI.Functions.Custom['fn_3c1ee9467b71bb67e9ea12baf20f08d2']((___arguments.context.pageData['WhereClauseRealTour'])));
      for (var j_index in j_list) {
        j = j_list[j_index];
        addItemToList(kundennrList, j);
      }
      ___arguments.context.pageData['KdnrListe'] = kundennrList;

    } catch (error) {
      ;await ( async function (message){ alert(message) })(error);

    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/NewTourPage/components/e4d842a4a1781b2cc5c26f9852989438/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
      ___arguments.context.pageData['AktuellerManuellerKunde'] = ___arguments.selectedRecord;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/ProduktePage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String((await Backendless.UserService.getCurrentUser())['kuerzel']));

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/ProduktePage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ProduktePage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ProduktePage/components/6792b77bb569c3c81121339326781175/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ProduktePage/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EinstellungenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ProduktePage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ProduktePage/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ProduktePage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ProduktePage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'gerrit.marttila@mar-med.de') {
    ___arguments.context.pageData['isAdmin'] = true;
  } else {
    ___arguments.context.pageData['isAdmin'] = false;
  }
  try {

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/SettingsPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/237d21f1e91dc70287a9c35afd3f6a3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, jsonResult, j, counter, adressListe, countDB;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['progessValue'] = 'Start';
    ___arguments.context.pageData['gesamtAnzahl'] = (await Backendless.Data.of('Adressen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('lat is null and Str is not null and Plz is not null  and Ort1 is not null')));
    countDB = (getObjectProperty(___arguments.context.pageData, 'gesamtAnzahl'));
    counter = 1;
    while (counter <= countDB) {
      ___arguments.context.pageData['progessValue'] = 'Progress';
      adressListe = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause('lat is null and Str is not null and Plz is not null  and Ort1 is not null').setPageSize(100)));
      for (var j_index in adressListe) {
        j = adressListe[j_index];
        counter = counter + 1;
        ___arguments.context.pageData['counterGesamt'] = counter;
        jsonResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?address=',(getObjectProperty(j, 'Str')),' ',(getObjectProperty(j, 'Plz')),' ',(getObjectProperty(j, 'Ort1')),' ','&key=','AIzaSyA0LINu3Z7ryVNYTtilJM6I-HVrEgr3wzg'].join('')))).setEncoding('utf8').send());
        try {
          j['lat'] = (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty(jsonResult, 'results'))[0]), 'geometry')), 'location')), 'lat'));
          j['lng'] = (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty(jsonResult, 'results'))[0]), 'geometry')), 'location')), 'lng'));
          j['locationMaps'] = (new Backendless.Data.Point().setX((getObjectProperty(j, 'lng'))).setY((getObjectProperty(j, 'lat'))));
          await Backendless.Data.of('Adressen').save( j );

        } catch (error) {
          await Backendless.Data.of('Log').save( ({ 'Bereich': 'Update Geolocation','Meldung': [(JSON.stringify(jsonResult)),'///',error].join(''),'User': 'SYS' }) );

        }
      }
    }
    ___arguments.context.pageData['gesamtAnzahl'] = 0;
    ___arguments.context.pageData['counterGesamt'] = 0;
    ___arguments.context.pageData['progessValue'] = 'Finish';
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/471bb4336d7804cf7238dfbe982e8d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MainPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/b2c82c7818d7fee8211841b5a4b813f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.restorePassword((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')));
  (function (message) { alert(message) })((String('Ein Link wurde an folgende Mail-Adresse gesendet: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/054e8bfe4e5824d859e66bb8b3c82798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.restorePassword((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')));
    (function (message) { alert(message) })('Es wurde eine Mail mit der Anforderung zum Passwort-Zurücksetzen geschickt!');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SettingsPage/components/ee083ae8f438e998b3c381d8cc7c5af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, gptResponseObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['sessionId'] = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/OpenAI/session`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'sessionId'));
    gptResponseObject = (await Backendless.Request.post(`${Backendless.appPath}/services/OpenAI/message`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'message': (getObjectProperty(___arguments.context.pageData, 'prompt')),'sessionId': (getObjectProperty(___arguments.context.pageData, 'sessionId')) }));
    ___arguments.context.pageData['gptResponse'] = (getObjectProperty(gptResponseObject, 'responseMessage'));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ShopTestPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    
  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/ShopTestPage/components/2818b5f87998e7246828ec5838b9a718/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, list, tempItem, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var j_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause('Aktiv = true').setPageSize(100)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      tempItem = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr = \'',(getObjectProperty(j, 'KundeID')),'\''].join(''))).setPageSize(10)))[0];
      if (tempItem !== null && !Array.isArray(tempItem) && (typeof tempItem === 'object')) {
        await Backendless.Data.of('Kunden').setRelation(tempItem, 'KundeTourExt', [j]);
      } else {
        (function (message) { alert(message) })((String('Nicht gefunden: ') + String(getObjectProperty(j, 'KundeID'))));
      }
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ShopTestPage/components/c2781078ad58b2746f765bf8cc68e023/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
      return (await Backendless.Data.of('ArtikelInLagerplatzDetails').find(Backendless.DataQueryBuilder.create().setPageSize(100)))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  ['onCellClick'](___arguments) {
    
  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/TempControlPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', ({ [`redirect`]: 'TourPage' }));
  }
  ___arguments.context.pageData['whereClauseTour'] = 'KundeTourID=\'999\'';
  ___arguments.context.pageData['LabelErsteTour'] = 'Tour';
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('a9988d28af58e25fdc88ae08d2a75a52', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Name')),[`label`]: (getObjectProperty(item, 'Name')) });}))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/TempControlPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', ({ 'redirect': 'TourPage' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TempControlPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TempControlPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TempControlPage/components/a9988d28af58e25fdc88ae08d2a75a52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var avgSum, avgTime, avgTimeMinuten, avgTimeStunden, checkDate, counter, diffSchnitt, diffTime, error, item, j, returnList, tempAvgItem, tempList, tempSumEnd, tempSumStart, tmpList, zeitMinuten, zeitStunden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    checkDate = (new Date());
    if (typeof (getObjectProperty(___arguments.context.pageData, 'datum')) === 'undefined') {
      tmpList = [];
      tmpList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Tour = \'',___arguments.value,'\''].join(''))).setSortBy('TourDate DESC').setPageSize(1)));
      if (tmpList.length > 0) {
        ___arguments.context.pageData['datum'] = (getObjectProperty((tmpList[0]), 'TourDate'));
        checkDate = (new Date((getObjectProperty((tmpList[0]), 'TourDate'))));
      } else {
        return ;
      }
    } else {
      checkDate = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
    }
    ___arguments.context.pageData['checkDate'] = (new Date(checkDate));
    tempList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourDate >= \'',(new Date(checkDate).getMonth() + 1) < 10 ? String('0') + String(new Date(checkDate).getMonth() + 1) : (new Date(checkDate).getMonth() + 1),'-',(new Date(checkDate).getDate()) < 10 ? String('0') + String(new Date(checkDate).getDate()) : (new Date(checkDate).getDate()),'-',(new Date(checkDate).getFullYear()),'\' AND TourDate < \'',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getFullYear()),'\' and KundeID != \'40336\' AND Tour = \'',___arguments.value,'\''].join(''))).setProperties(['*', 'EndTime-StartTime as Zeit']).setSortBy('EndTime').setGroupBy('KundeID').setPageSize(100)));
    returnList = [];
    for (var j_index in tempList) {
      j = tempList[j_index];
      avgTime = 0;
      avgSum = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(j, 'KundeID')),'\' AND TourDate < ',(getObjectProperty(j, 'TourDate'))].join(''))).setPageSize(10)));
      tempSumEnd = 0;
      tempSumStart = 0;
      counter = 0;
      for (var item_index in avgSum) {
        item = avgSum[item_index];
        tempSumStart = tempSumStart + (getObjectProperty(item, 'StartTime'));
        tempSumEnd = tempSumEnd + (getObjectProperty(item, 'EndTime'));
        counter = counter + 1;
      }
      tempAvgItem = ({ [`StartTimeAVG`]: Math.round(tempSumStart / counter),[`EndTimeAVG`]: Math.round(tempSumEnd / counter) });
      if (avgSum.length > 0) {
        diffSchnitt = tempSumEnd / counter - tempSumStart / counter;
        avgTimeStunden = Math.floor(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) / 60);
        avgTimeMinuten = Math.round(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) - avgTimeStunden * 60);
        avgTime = [avgTimeStunden,':',(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) < 10 ? String(0) + String(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) : (avgTimeMinuten < 0 ? 0 : avgTimeMinuten)].join('');
      } else {
        avgTime = 0;
      }
      diffTime = (getObjectProperty(j, 'EndTime')) - (getObjectProperty(j, 'StartTime'));
      zeitStunden = Math.floor(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) / 60);
      zeitMinuten = Math.round(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) - zeitStunden * 60);
      addItemToList(returnList, ({ [`KundeID`]: (getObjectProperty(j, 'KundeID')),[`Name`]: (getObjectProperty(j, 'Name')),[`StartTime`]: [(new Date((getObjectProperty(j, 'StartTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getDate()) : (new Date((getObjectProperty(j, 'StartTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'StartTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'StartTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getHours()) : (new Date((getObjectProperty(j, 'StartTime'))).getHours()),':',(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'StartTime'))).getMinutes())].join(''),[`EndTime`]: [(new Date((getObjectProperty(j, 'EndTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getDate()) : (new Date((getObjectProperty(j, 'EndTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'EndTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'EndTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getHours()) : (new Date((getObjectProperty(j, 'EndTime'))).getHours()),':',(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'EndTime'))).getMinutes())].join(''),[`TourDate`]: [(new Date((getObjectProperty(j, 'TourDate'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getDate()) : (new Date((getObjectProperty(j, 'TourDate'))).getDate()),'.',(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'TourDate'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'TourDate'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getHours()) : (new Date((getObjectProperty(j, 'TourDate'))).getHours()),':',(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) : (new Date((getObjectProperty(j, 'TourDate'))).getMinutes())].join(''),[`Zeit`]: [zeitStunden,':',(zeitMinuten < 0 ? 0 : zeitMinuten) < 10 ? String('0') + String(zeitMinuten < 0 ? 0 : zeitMinuten) : (zeitMinuten < 0 ? 0 : zeitMinuten)].join(''),[`DurchschnittLetzte10`]: avgTime,[`Differenz`]: [diffTime - diffSchnitt < 0 && (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) == 0 ? '-' : '',diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60),':',(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) < 10 ? String('0') + String(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) : (Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60))].join(''),[`InfoFahrer`]: (getObjectProperty(j, 'InfoVonFahrer')) }));
    }
    ___arguments.context.pageData['rowData'] = returnList;

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TempControlPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TempControlPage/components/85e6b328e74a8a153d38b68b85e9d05c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TourArchivePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TempControlPage/components/b2b8187aec84b6c8127bcc9890880058/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, returnList, j, diffSchnitt, diffTime, avgTime, zeitMinuten, zeitStunden, avgTimeMinuten, avgTimeStunden, tempAvgItem, counter, tempSumStart, tempSumEnd, avgSum, item, tempList, checkDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'tour')) === 'undefined') {
      return ;
    }
    checkDate = (new Date(___arguments.value));
    ___arguments.context.pageData['checkDate'] = (new Date(___arguments.value));
    tempList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourDate >= \'',(new Date(checkDate).getMonth() + 1) < 10 ? String('0') + String(new Date(checkDate).getMonth() + 1) : (new Date(checkDate).getMonth() + 1),'-',(new Date(checkDate).getDate()) < 10 ? String('0') + String(new Date(checkDate).getDate()) : (new Date(checkDate).getDate()),'-',(new Date(checkDate).getFullYear()),'\' AND TourDate < \'',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getFullYear()),'\' and KundeID != \'40336\' AND Tour = \'',(getObjectProperty(___arguments.context.pageData, 'tour')),'\''].join(''))).setProperties(['*', 'EndTime-StartTime as Zeit']).setSortBy('EndTime').setGroupBy('KundeID').setPageSize(100)));
    returnList = [];
    for (var j_index in tempList) {
      j = tempList[j_index];
      avgTime = 0;
      avgSum = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(j, 'KundeID')),'\' AND TourDate < ',(getObjectProperty(j, 'TourDate'))].join(''))).setPageSize(10)));
      tempSumEnd = 0;
      tempSumStart = 0;
      counter = 0;
      for (var item_index in avgSum) {
        item = avgSum[item_index];
        tempSumStart = tempSumStart + (getObjectProperty(item, 'StartTime'));
        tempSumEnd = tempSumEnd + (getObjectProperty(item, 'EndTime'));
        counter = counter + 1;
      }
      tempAvgItem = ({ [`StartTimeAVG`]: Math.round(tempSumStart / counter),[`EndTimeAVG`]: Math.round(tempSumEnd / counter) });
      if (avgSum.length > 0) {
        diffSchnitt = tempSumEnd / counter - tempSumStart / counter;
        avgTimeStunden = Math.floor(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) / 60);
        avgTimeMinuten = Math.round(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) - avgTimeStunden * 60);
        avgTime = [avgTimeStunden,':',(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) < 10 ? String(0) + String(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) : (avgTimeMinuten < 0 ? 0 : avgTimeMinuten)].join('');
      } else {
        avgTime = 0;
      }
      diffTime = (getObjectProperty(j, 'EndTime')) - (getObjectProperty(j, 'StartTime'));
      zeitStunden = Math.floor(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) / 60);
      zeitMinuten = Math.round(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) - zeitStunden * 60);
      addItemToList(returnList, ({ [`KundeID`]: (getObjectProperty(j, 'KundeID')),[`Name`]: (getObjectProperty(j, 'Name')),[`StartTime`]: [(new Date((getObjectProperty(j, 'StartTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getDate()) : (new Date((getObjectProperty(j, 'StartTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'StartTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'StartTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getHours()) : (new Date((getObjectProperty(j, 'StartTime'))).getHours()),':',(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'StartTime'))).getMinutes())].join(''),[`EndTime`]: [(new Date((getObjectProperty(j, 'EndTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getDate()) : (new Date((getObjectProperty(j, 'EndTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'EndTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'EndTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getHours()) : (new Date((getObjectProperty(j, 'EndTime'))).getHours()),':',(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'EndTime'))).getMinutes())].join(''),[`TourDate`]: [(new Date((getObjectProperty(j, 'TourDate'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getDate()) : (new Date((getObjectProperty(j, 'TourDate'))).getDate()),'.',(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'TourDate'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'TourDate'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getHours()) : (new Date((getObjectProperty(j, 'TourDate'))).getHours()),':',(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) : (new Date((getObjectProperty(j, 'TourDate'))).getMinutes())].join(''),[`Zeit`]: [zeitStunden,':',(zeitMinuten < 0 ? 0 : zeitMinuten) < 10 ? String('0') + String(zeitMinuten < 0 ? 0 : zeitMinuten) : (zeitMinuten < 0 ? 0 : zeitMinuten)].join(''),[`DurchschnittLetzte10`]: avgTime,[`Differenz`]: [diffTime - diffSchnitt < 0 && (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) == 0 ? '-' : '',diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60),':',(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) < 10 ? String('0') + String(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) : (Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60))].join(''),[`InfoFahrer`]: (getObjectProperty(j, 'InfoVonFahrer')) }));
    }
    ___arguments.context.pageData['rowData'] = returnList;

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TempControlPage/components/84d882680371d511c008be6ceef7a488/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'rowData'))

  },
  /* handler:rowsDataLogic */
  /* content */
}))

define('./pages/TempControlPage/components/dd577a3bc29435dc931e79f52ea27d95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MainPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);
  }
  ___arguments.context.pageData['uiUser'] = (String('User: ') + String((await Backendless.UserService.getCurrentUser())['kuerzel']));

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/TemplatePageMM/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/6792b77bb569c3c81121339326781175/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('MainPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/10de854922a81f3f04245d68e28c4948/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('EinstellungenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/c818f7c7ee880258ab082448fdf80e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('TourPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TemplatePageMM/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ProduktePage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TestMapCenter/components/d3acaba8741858b704723e583d2c7638/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async onRecordSelect(___arguments) {
      ;await ( async function (message){ alert(message) })((___arguments.selectedRecord['Geopoint']));
  ___arguments.context.pageData['mapCenter'] = (___arguments.selectedRecord['Geopoint']);

  },  
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/TestMapCenter/components/734b4b7ba4c144f4ca987a0777ec24a8/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  onMapCenterAssignment(___arguments) {
      return ((___arguments.context.pageData['mapCenter']) == null ? ({ 'lng': 9.584453641765714,'lat': 54.31121889719215 }) : ({ 'lng': 9.584453641765714,'lat': 54.31121889719215 }))

  },  
  /* handler:onMapCenterAssignment */
  /* handler:onPointsAssignment */
  onPointsAssignment(___arguments) {
      return [(new Backendless.Data.Point().setX(9.5840995902416).setY(54.31218590314351)), (new Backendless.Data.Point().setX(10.180451194173786).setY(54.32762988186244)), (new Backendless.Data.Point().setX(10.290314505817966).setY(54.247067291240356)), (new Backendless.Data.Point().setX(10.3081672879143).setY(53.94910902106182)), (new Backendless.Data.Point().setX(9.98407062831931).setY(54.08708008826464))]

  },  
  /* handler:onPointsAssignment */
  /* handler:onMarkerClick */
  async onMarkerClick(___arguments) {
      ;await ( async function (message){ alert(message) })(___arguments.point);

  },  
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/TestMapCenter/components/6c386adff64f0d37b397994894e8d7a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;


  try {
    ;(function (componentUid, points){ ___arguments.context.getComponentByUid(componentUid).points = points })('734b4b7ba4c144f4ca987a0777ec24a8', (new Backendless.Data.LineString([(new Backendless.Data.Point().setX(10.011177).setY(53.563152)), (new Backendless.Data.Point().setX(9.656631).setY(53.762514)), (new Backendless.Data.Point().setX(9.51714).setY(53.93022)), (new Backendless.Data.Point().setX(9.089761).setY(54.1986)), (new Backendless.Data.Point().setX(9.583853).setY(54.310315))])));

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TestMapCenter/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['ValueTest'] = 'Zeile 1 \\n Zeile 2 \\n Zeile 3';

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/TourArchivePage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', ({ [`redirect`]: 'TourPage' }));
  }
  ___arguments.context.pageData['whereClauseTour'] = 'KundeTourID=\'999\'';
  ___arguments.context.pageData['LabelErsteTour'] = 'Tour';
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('a9988d28af58e25fdc88ae08d2a75a52', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Name')),[`label`]: (getObjectProperty(item, 'Name')) });}))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/TourArchivePage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', ({ 'redirect': 'TourPage' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourArchivePage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TourArchivePage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TourArchivePage/components/a9988d28af58e25fdc88ae08d2a75a52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var avgSum, avgTime, avgTimeMinuten, avgTimeStunden, checkDate, counter, diffSchnitt, diffTime, error, item, j, returnList, tempAvgItem, tempList, tempSumEnd, tempSumStart, tmpList, zeitMinuten, zeitStunden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    checkDate = (new Date());
    if (typeof (getObjectProperty(___arguments.context.pageData, 'datum')) === 'undefined') {
      tmpList = [];
      tmpList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Tour = \'',___arguments.value,'\''].join(''))).setSortBy('TourDate DESC').setPageSize(1)));
      if (tmpList.length > 0) {
        ___arguments.context.pageData['datum'] = (getObjectProperty((tmpList[0]), 'TourDate'));
        checkDate = (new Date((getObjectProperty((tmpList[0]), 'TourDate'))));
      } else {
        return ;
      }
    } else {
      checkDate = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
    }
    ___arguments.context.pageData['checkDate'] = (new Date(checkDate));
    tempList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourDate >= \'',(new Date(checkDate).getMonth() + 1) < 10 ? String('0') + String(new Date(checkDate).getMonth() + 1) : (new Date(checkDate).getMonth() + 1),'-',(new Date(checkDate).getDate()) < 10 ? String('0') + String(new Date(checkDate).getDate()) : (new Date(checkDate).getDate()),'-',(new Date(checkDate).getFullYear()),'\' AND TourDate < \'',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getFullYear()),'\' and KundeID != \'40336\' AND Tour = \'',___arguments.value,'\''].join(''))).setProperties(['*', 'EndTime-StartTime as Zeit']).setSortBy('EndTime').setGroupBy('KundeID').setPageSize(100)));
    returnList = [];
    for (var j_index in tempList) {
      j = tempList[j_index];
      avgTime = 0;
      avgSum = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(j, 'KundeID')),'\' AND TourDate < ',(getObjectProperty(j, 'TourDate'))].join(''))).setPageSize(10)));
      tempSumEnd = 0;
      tempSumStart = 0;
      counter = 0;
      for (var item_index in avgSum) {
        item = avgSum[item_index];
        tempSumStart = tempSumStart + (getObjectProperty(item, 'StartTime'));
        tempSumEnd = tempSumEnd + (getObjectProperty(item, 'EndTime'));
        counter = counter + 1;
      }
      tempAvgItem = ({ [`StartTimeAVG`]: Math.round(tempSumStart / counter),[`EndTimeAVG`]: Math.round(tempSumEnd / counter) });
      if (avgSum.length > 0) {
        diffSchnitt = tempSumEnd / counter - tempSumStart / counter;
        avgTimeStunden = Math.floor(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) / 60);
        avgTimeMinuten = Math.round(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) - avgTimeStunden * 60);
        avgTime = [avgTimeStunden,':',(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) < 10 ? String(0) + String(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) : (avgTimeMinuten < 0 ? 0 : avgTimeMinuten)].join('');
      } else {
        avgTime = 0;
      }
      diffTime = (getObjectProperty(j, 'EndTime')) - (getObjectProperty(j, 'StartTime'));
      zeitStunden = Math.floor(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) / 60);
      zeitMinuten = Math.round(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) - zeitStunden * 60);
      addItemToList(returnList, ({ [`KundeID`]: (getObjectProperty(j, 'KundeID')),[`Name`]: (getObjectProperty(j, 'Name')),[`StartTime`]: [(new Date((getObjectProperty(j, 'StartTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getDate()) : (new Date((getObjectProperty(j, 'StartTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'StartTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'StartTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getHours()) : (new Date((getObjectProperty(j, 'StartTime'))).getHours()),':',(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'StartTime'))).getMinutes())].join(''),[`EndTime`]: [(new Date((getObjectProperty(j, 'EndTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getDate()) : (new Date((getObjectProperty(j, 'EndTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'EndTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'EndTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getHours()) : (new Date((getObjectProperty(j, 'EndTime'))).getHours()),':',(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'EndTime'))).getMinutes())].join(''),[`TourDate`]: [(new Date((getObjectProperty(j, 'TourDate'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getDate()) : (new Date((getObjectProperty(j, 'TourDate'))).getDate()),'.',(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'TourDate'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'TourDate'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getHours()) : (new Date((getObjectProperty(j, 'TourDate'))).getHours()),':',(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) : (new Date((getObjectProperty(j, 'TourDate'))).getMinutes())].join(''),[`Zeit`]: [zeitStunden,':',(zeitMinuten < 0 ? 0 : zeitMinuten) < 10 ? String('0') + String(zeitMinuten < 0 ? 0 : zeitMinuten) : (zeitMinuten < 0 ? 0 : zeitMinuten)].join(''),[`DurchschnittLetzte10`]: avgTime,[`Differenz`]: [diffTime - diffSchnitt < 0 && (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) == 0 ? '-' : '',diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60),':',(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) < 10 ? String('0') + String(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) : (Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60))].join(''),[`InfoFahrer`]: (getObjectProperty(j, 'InfoVonFahrer')) }));
    }
    ___arguments.context.pageData['rowData'] = returnList;

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourArchivePage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TourArchivePage/components/85e6b328e74a8a153d38b68b85e9d05c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TourArchivePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourArchivePage/components/b2b8187aec84b6c8127bcc9890880058/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, returnList, j, diffSchnitt, diffTime, avgTime, zeitMinuten, zeitStunden, avgTimeMinuten, avgTimeStunden, tempAvgItem, counter, tempSumStart, tempSumEnd, avgSum, item, tempList, checkDate;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if (typeof (getObjectProperty(___arguments.context.pageData, 'tour')) === 'undefined') {
      return ;
    }
    checkDate = (new Date(___arguments.value));
    ___arguments.context.pageData['checkDate'] = (new Date(___arguments.value));
    tempList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourDate >= \'',(new Date(checkDate).getMonth() + 1) < 10 ? String('0') + String(new Date(checkDate).getMonth() + 1) : (new Date(checkDate).getMonth() + 1),'-',(new Date(checkDate).getDate()) < 10 ? String('0') + String(new Date(checkDate).getDate()) : (new Date(checkDate).getDate()),'-',(new Date(checkDate).getFullYear()),'\' AND TourDate < \'',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getFullYear()),'\' and KundeID != \'40336\' AND Tour = \'',(getObjectProperty(___arguments.context.pageData, 'tour')),'\''].join(''))).setProperties(['*', 'EndTime-StartTime as Zeit']).setSortBy('EndTime').setGroupBy('KundeID').setPageSize(100)));
    returnList = [];
    for (var j_index in tempList) {
      j = tempList[j_index];
      avgTime = 0;
      avgSum = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(j, 'KundeID')),'\' AND TourDate < ',(getObjectProperty(j, 'TourDate'))].join(''))).setPageSize(10)));
      tempSumEnd = 0;
      tempSumStart = 0;
      counter = 0;
      for (var item_index in avgSum) {
        item = avgSum[item_index];
        tempSumStart = tempSumStart + (getObjectProperty(item, 'StartTime'));
        tempSumEnd = tempSumEnd + (getObjectProperty(item, 'EndTime'));
        counter = counter + 1;
      }
      tempAvgItem = ({ [`StartTimeAVG`]: Math.round(tempSumStart / counter),[`EndTimeAVG`]: Math.round(tempSumEnd / counter) });
      if (avgSum.length > 0) {
        diffSchnitt = tempSumEnd / counter - tempSumStart / counter;
        avgTimeStunden = Math.floor(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) / 60);
        avgTimeMinuten = Math.round(Math.round((((getObjectProperty(tempAvgItem, 'EndTimeAVG')).valueOf()) - ((getObjectProperty(tempAvgItem, 'StartTimeAVG')).valueOf())) / 60000) - avgTimeStunden * 60);
        avgTime = [avgTimeStunden,':',(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) < 10 ? String(0) + String(avgTimeMinuten < 0 ? 0 : avgTimeMinuten) : (avgTimeMinuten < 0 ? 0 : avgTimeMinuten)].join('');
      } else {
        avgTime = 0;
      }
      diffTime = (getObjectProperty(j, 'EndTime')) - (getObjectProperty(j, 'StartTime'));
      zeitStunden = Math.floor(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) / 60);
      zeitMinuten = Math.round(Math.round((((getObjectProperty(j, 'EndTime')).valueOf()) - ((getObjectProperty(j, 'StartTime')).valueOf())) / 60000) - zeitStunden * 60);
      addItemToList(returnList, ({ [`KundeID`]: (getObjectProperty(j, 'KundeID')),[`Name`]: (getObjectProperty(j, 'Name')),[`StartTime`]: [(new Date((getObjectProperty(j, 'StartTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getDate()) : (new Date((getObjectProperty(j, 'StartTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'StartTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'StartTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getHours()) : (new Date((getObjectProperty(j, 'StartTime'))).getHours()),':',(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'StartTime'))).getMinutes())].join(''),[`EndTime`]: [(new Date((getObjectProperty(j, 'EndTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getDate()) : (new Date((getObjectProperty(j, 'EndTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'EndTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'EndTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getHours()) : (new Date((getObjectProperty(j, 'EndTime'))).getHours()),':',(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'EndTime'))).getMinutes())].join(''),[`TourDate`]: [(new Date((getObjectProperty(j, 'TourDate'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getDate()) : (new Date((getObjectProperty(j, 'TourDate'))).getDate()),'.',(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'TourDate'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'TourDate'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getHours()) : (new Date((getObjectProperty(j, 'TourDate'))).getHours()),':',(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) : (new Date((getObjectProperty(j, 'TourDate'))).getMinutes())].join(''),[`Zeit`]: [zeitStunden,':',(zeitMinuten < 0 ? 0 : zeitMinuten) < 10 ? String('0') + String(zeitMinuten < 0 ? 0 : zeitMinuten) : (zeitMinuten < 0 ? 0 : zeitMinuten)].join(''),[`DurchschnittLetzte10`]: avgTime,[`Differenz`]: [diffTime - diffSchnitt < 0 && (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) == 0 ? '-' : '',diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60),':',(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) < 10 ? String('0') + String(Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60)) : (Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) < 0 ? Math.round(((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60) * -1) : Math.round((diffTime - diffSchnitt) / 60000 - (diffTime - diffSchnitt < 0 ? Math.ceil(Math.round((diffTime - diffSchnitt) / 60000) / 60) : Math.floor(Math.round((diffTime - diffSchnitt) / 60000) / 60)) * 60))].join(''),[`InfoFahrer`]: (getObjectProperty(j, 'InfoVonFahrer')) }));
    }
    ___arguments.context.pageData['rowData'] = returnList;

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourArchivePage/components/84d882680371d511c008be6ceef7a488/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'rowData'))

  },
  /* handler:rowsDataLogic */
  /* content */
}))

define('./pages/TourArchivePage/components/dd577a3bc29435dc931e79f52ea27d95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MainPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourArchivePage/components/e1af715a6e78aab2cb6f55c8b1d864e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TempControlPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var item;


  if (!(await Backendless.UserService.isValidLogin())) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', ({ 'redirect': 'TourPage' }));
  }
  ___arguments.context.pageData['whereClauseTour'] = 'KundeTourID=\'999\'';
  ___arguments.context.pageData['LabelErsteTour'] = 'Tour';
  ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('a9988d28af58e25fdc88ae08d2a75a52', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ 'value': (item['Name']),'label': (item['Name']) });}))));
  ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('d8766c4d0bc9361553942de118f98381', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ 'value': (item['Name']),'label': (item['Name']) });}))));
  ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('7d75656eff4276a4102decfa75d7d996', (await Promise.all((await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setSortBy('Name').setPageSize(50))).map(async item => {; return ({ 'value': (item['Name']),'label': (item['Name']) });}))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/TourPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', ({ 'redirect': 'TourPage' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/14c37caa79c8c46d960df8bd2de818b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('KundenPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/a9988d28af58e25fdc88ae08d2a75a52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var error, adressListe, nord, sued, west, ost, adresse, tourKunde, j;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6c07781e6527fe1c07e9c1fd90f3bc29', true);
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('6c07781e6527fe1c07e9c1fd90f3bc29', '*');
  try {
    ;(function (componentUid, traffic){ ___arguments.context.getComponentByUid(componentUid).traffic = traffic })('12988a68ece4f7d8ee6852d937b969c8', true);
    ___arguments.context.pageData['wochenart'] = '*';
    ___arguments.context.pageData['aktuelleTour'] = ___arguments.value;
    ___arguments.context.pageData['whereClauseTour'] = (['TourID.Name=\'',___arguments.value,'\''].join(''));
    adressListe = [];
    nord = 0;
    sued = 0;
    ost = 0;
    west = 0;
    var j_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',___arguments.value,'\''].join(''))).setSortBy('Pos').setPageSize(50)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      tourKunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(j, 'KundeID')),'\''].join(''))).setPageSize(10)))[0];
      if ((getObjectProperty(tourKunde, 'Lieferadrid')) != null && !!(getObjectProperty(tourKunde, 'Lieferadrid')).length) {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(getObjectProperty(tourKunde, 'Lieferadrid')),'\''].join(''))).setPageSize(10)))[0];
      } else {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(getObjectProperty(tourKunde, 'Rgadrid')),'\''].join(''))).setPageSize(10)))[0];
      }
      addItemToList(adressListe, (getObjectProperty(adresse, 'locationMaps')));
      if (nord != 0 && ost != 0 && sued != 0 && west != 0) {
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng')) > ost) {
          ost = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng')) < west) {
          west = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat')) > nord) {
          nord = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat')) < sued) {
          sued = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        }
      } else {
        nord = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        sued = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        ost = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        west = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
      }
    }
    ___arguments.context.pageData['GeodatenListe'] = adressListe;
    ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(((ost + west) / 2)).setY(((sued + nord) / 2)));
    ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
    if (!adressListe.length) {
      ;await ( async function (message){ alert(message) })('Leer');
      ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourPage/components/f6bd6b489f283868e49c11f80f630705/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async onRecordSelect(___arguments) {
    var ausgewaehlterKunde, lat, lng, jsonResult;


  ___arguments.context.pageData['aktuellerKunde'] = (___arguments.selectedRecord['Kundennr']);
  ___arguments.context.pageData['ValueName'] = (___arguments.selectedRecord['Name1']);
  if ((___arguments.selectedRecord['Lieferadrid']) != null && !!(___arguments.selectedRecord['Lieferadrid']).length) {
    ausgewaehlterKunde = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(___arguments.selectedRecord['Lieferadrid']),'\''].join(''))).setPageSize(10)))[0];
  } else {
    ausgewaehlterKunde = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(___arguments.selectedRecord['Rgadrid']),'\''].join(''))).setPageSize(10)))[0];
  }
  if (ausgewaehlterKunde != !null) {
    if ((ausgewaehlterKunde['Geopoint']) == null) {
      jsonResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?address=',(ausgewaehlterKunde['Str']),' ',(ausgewaehlterKunde['Plz']),' ',(ausgewaehlterKunde['Ort1']),'&key=','AIzaSyA0LINu3Z7ryVNYTtilJM6I-HVrEgr3wzg'].join('')))).setEncoding('utf8').send());
      lat = (((((jsonResult['results'])[0])['geometry'])['location'])['lat']);
      lng = (((((jsonResult['results'])[0])['geometry'])['location'])['lng']);
      ausgewaehlterKunde['Geopoint'] = (new Backendless.Data.Point().setX(lng).setY(lat));
      await Backendless.Data.of('Adressen').save( ausgewaehlterKunde );
      ___arguments.context.pageData['GeodatenEinzel'] = (ausgewaehlterKunde['Geopoint']);
      ___arguments.context.pageData['GeodatenListe'] = [(ausgewaehlterKunde['Geopoint'])];
    } else {
      ___arguments.context.pageData['GeodatenEinzel'] = (ausgewaehlterKunde['Geopoint']);
      ___arguments.context.pageData['GeodatenListe'] = [(ausgewaehlterKunde['Geopoint'])];
    }
  } else {
    ;await ( async function (message){ alert(message) })('Fehler');
  }
  ___arguments.context.pageData['whereClauseTour'] = 'TourID.Name=\'999\'';
  ___arguments.context.pageData['whereClauseTour'] = (['TourID.Name=\'',(___arguments.context.pageData['AktuelleTour']),'\''].join(''));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/TourPage/components/2ea890ef1b78cdd817088fdbfed63e0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, adressListe, nord, sued, west, ost, adresse, tourKunde, j, savedObject;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['whereClauseTour'] = (['TourID.Name=\'','999','\''].join(''));
  ___arguments.context.pageData['whereClauseTour'] = (['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''));
  if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == null) {
    ;await ( async function (message){ alert(message) })('Art der Tourenzugehörigkeit auswählen!');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) == null) {
    ;await ( async function (message){ alert(message) })('Intervall auswählen!');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'ValueName')) == null) {
    ;await ( async function (message){ alert(message) })('Kein Kunde ausgewählt!');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')) == null) {
    ;await ( async function (message){ alert(message) })('Kein Kunde ausgewählt!');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'ersteTour')) == null) {
    ;await ( async function (message){ alert(message) })('Tour auswählen!');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == 'unterschiedlich' && (getObjectProperty(___arguments.context.pageData, 'zweiteTour')) == null) {
    ;await ( async function (message){ alert(message) })('Zweite Tour nicht ausgewählt!');
    return null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == '*') {
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'gerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'gerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'ungerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'ungerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == 'gerade') {
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'gerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'gerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == 'ungerade') {
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'ungerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'ungerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == 'quartal') {
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'gerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'gerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'ungerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'ungerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
  } else if ((getObjectProperty(___arguments.context.pageData, 'TourArt')) == 'unterschiedlich') {
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'ersteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\' AND Wochenart = \'gerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'gerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
    savedObject = (await Backendless.Data.of('KundeTour').save( ({ 'KundeID': (getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'Name': (getObjectProperty(___arguments.context.pageData, 'ValueName')),'Tour': (getObjectProperty(___arguments.context.pageData, 'zweiteTour')),'Pos': 1 + (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Tour=\'',(getObjectProperty(___arguments.context.pageData, 'zweiteTour')),'\' AND Wochenart = \'ungerade\''].join(''))))),'StartDatum': (getObjectProperty(___arguments.context.pageData, 'ValueStartDatum')),'Intervall': (getObjectProperty(___arguments.context.pageData, 'ValueIntervall')) / 1,'Wochenart': 'ungerade','WochenartInit': (getObjectProperty(___arguments.context.pageData, 'TourArt')) }) ));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'TourID', (await Backendless.Data.of('Tour').find(Backendless.DataQueryBuilder.create().setWhereClause((['Name=\'',(getObjectProperty(___arguments.context.pageData, 'zweiteTour')),'\''].join(''))).setPageSize(10))));
    await Backendless.Data.of('KundeTour').setRelation(savedObject, 'KundeExt', (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(___arguments.context.pageData, 'aktuellerKunde')),'\''].join(''))).setPageSize(10))));
  } else {
    ;await ( async function (message){ alert(message) })('Not found');
  }
  ___arguments.context.pageData['ValueName'] = '';
  try {
    ;(function (componentUid, traffic){ ___arguments.context.getComponentByUid(componentUid).traffic = traffic })('12988a68ece4f7d8ee6852d937b969c8', true);
    ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('a9988d28af58e25fdc88ae08d2a75a52', (getObjectProperty(___arguments.context.pageData, 'ersteTour')));
    adressListe = [];
    nord = 0;
    sued = 0;
    ost = 0;
    west = 0;
    var j_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'ersteTour')),'\''].join(''))).setSortBy('Pos').setPageSize(50)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      tourKunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(j, 'KundeID')),'\''].join(''))).setPageSize(10)))[0];
      if ((getObjectProperty(tourKunde, 'Lieferadrid')) != null && !!(getObjectProperty(tourKunde, 'Lieferadrid')).length) {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(getObjectProperty(tourKunde, 'Lieferadrid')),'\''].join(''))).setPageSize(10)))[0];
      } else {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(getObjectProperty(tourKunde, 'Rgadrid')),'\''].join(''))).setPageSize(10)))[0];
      }
      addItemToList(adressListe, (getObjectProperty(adresse, 'locationMaps')));
      if (nord != 0 && ost != 0 && sued != 0 && west != 0) {
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng')) > ost) {
          ost = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng')) < west) {
          west = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat')) > nord) {
          nord = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat')) < sued) {
          sued = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        }
      } else {
        nord = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        sued = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        ost = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        west = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
      }
    }
    ___arguments.context.pageData['GeodatenListe'] = adressListe;
    ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(((ost + west) / 2)).setY(((sued + nord) / 2)));
    ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
    if (!adressListe.length) {
      ;await ( async function (message){ alert(message) })('Leer');
      ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/16473da8df5a4918f4425088a2e81e2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, zweiterKunde, ausgewaehlterKunde, varWochenart;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == '*' || (typeof (getObjectProperty(___arguments.context.pageData, 'wochenart')) === 'undefined')) {
      ;await ( async function (message){ alert(message) })('Gerade oder ungerade Tour auswählen');
      return ;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'objectId')) != null) {
      if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == 'gerade') {
        varWochenart = ' and Wochenart = \'gerade\'';
      } else if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == 'ungerade') {
        varWochenart = ' and Wochenart = \'ungerade\'';
      }
      ausgewaehlterKunde = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10)))[0];
      if ((getObjectProperty(ausgewaehlterKunde, 'Pos')) > 1) {
        zweiterKunde = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'aktuelleTour')),'\' AND Pos=\'',(getObjectProperty(ausgewaehlterKunde, 'Pos')) - 1,'\'',varWochenart].join(''))).setPageSize(10)))[0];
        ausgewaehlterKunde['Pos'] = ((getObjectProperty(ausgewaehlterKunde, 'Pos')) - 1);
        await Backendless.Data.of('KundeTour').save( ausgewaehlterKunde );
        zweiterKunde['Pos'] = ((getObjectProperty(zweiterKunde, 'Pos')) + 1);
        await Backendless.Data.of('KundeTour').save( zweiterKunde );
      } else {
        ;await ( async function (message){ alert(message) })('Kunde ist bereits an erster Position');
      }
    } else {
      ;await ( async function (message){ alert(message) })('Kein Kunde ausgewählt');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/6798732761d8dd38d8984723b728af08/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  onRecordSelect(___arguments) {
      ___arguments.context.pageData['objectId'] = (___arguments.selectedRecord['objectId']);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/TourPage/components/9f9281f289983c6b52382ae19a48debf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var zweiterKunde, ausgewaehlterKunde, varWochenart;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == '*' || (typeof (getObjectProperty(___arguments.context.pageData, 'wochenart')) === 'undefined')) {
    ;await ( async function (message){ alert(message) })('Gerade oder ungerade Tour auswählen');
    return ;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'objectId')) != null) {
    if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == 'gerade') {
      varWochenart = ' and Wochenart = \'gerade\'';
    } else if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == 'ungerade') {
      varWochenart = ' and Wochenart = \'ungerade\'';
    }
    ausgewaehlterKunde = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10)))[0];
    if ((getObjectProperty(ausgewaehlterKunde, 'Pos')) < (await Backendless.Data.of('KundeTour').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'aktuelleTour')),'\'',varWochenart].join('')))))) {
      zweiterKunde = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'aktuelleTour')),'\' AND Pos=\'',(getObjectProperty(ausgewaehlterKunde, 'Pos')) + 1,'\'',varWochenart].join(''))).setPageSize(10)))[0];
      ausgewaehlterKunde['Pos'] = ((getObjectProperty(ausgewaehlterKunde, 'Pos')) + 1);
      await Backendless.Data.of('KundeTour').save( ausgewaehlterKunde );
      zweiterKunde['Pos'] = ((getObjectProperty(zweiterKunde, 'Pos')) - 1);
      await Backendless.Data.of('KundeTour').save( zweiterKunde );
    } else {
      ;await ( async function (message){ alert(message) })('Kunde ist bereits an letzter Position');
    }
  } else {
    ;await ( async function (message){ alert(message) })('Kein Kunde ausgewählt');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/12988a68ece4f7d8ee6852d937b969c8/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  onPointsAssignment(___arguments) {
      return ((___arguments.context.pageData['GeodatenListe']) == null ? [] : (___arguments.context.pageData['GeodatenListe']))

  },
  /* handler:onPointsAssignment */
  /* handler:onMapCenterAssignment */
  onMapCenterAssignment(___arguments) {
      return ((___arguments.context.pageData['GeodatenEinzel']) == null ? (new Backendless.Data.Point().setX(9.584453641765714).setY(54.31121263817992)) : (___arguments.context.pageData['GeodatenEinzel']))

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPanChange */
  onPanChange(___arguments) {
      ___arguments.context.pageData['GeodatenEinzel'] = ___arguments.value;

  },
  /* handler:onPanChange */
  /* handler:onMarkerClick */
  async onMarkerClick(___arguments) {
    var adresse, adressListe, error, j, tourenListe, tourkunde, trefferAdresse;


  try {
    tourenListe = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(___arguments.context.pageData['aktuelleTour']),'\''].join(''))).setPageSize(10)));
    adressListe = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Within(locationMaps,\'',(___arguments.point.asWKT()),'\') = True'].join(''))).setPageSize(10)));
    for (var adresse_index in adressListe) {
      adresse = adressListe[adresse_index];
      for (var tourkunde_index in tourenListe) {
        tourkunde = tourenListe[tourkunde_index];
        if ((adresse['Kdliefnr']) == (tourkunde['KundeID'])) {
          trefferAdresse = adresse;
        }
      }
    }
    ;(function (componentUid, marker, popupContent){ ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('12988a68ece4f7d8ee6852d937b969c8', ___arguments.point, ([(trefferAdresse['Name1']),' -',(trefferAdresse['Ort1']),' -',(trefferAdresse['Kdliefnr'])].join('')));

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onMarkerClick */
  /* content */
}))

define('./pages/TourPage/components/c8385be82328d2b811ce3d88270e1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ArtikelPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/d8766c4d0bc9361553942de118f98381/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['ersteTour'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourPage/components/7d75656eff4276a4102decfa75d7d996/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['zweiteTour'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourPage/components/48cd80e3e33689f20bbce0bf2d7a0f91/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var error;


  try {
    ___arguments.context.pageData['TourArt'] = ___arguments.checkedValue;
    if (___arguments.checkedValue == '*') {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d75656eff4276a4102decfa75d7d996', false);
      ___arguments.context.pageData['LabelErsteTour'] = 'Tour';
      ___arguments.context.pageData['LabelZweiteTour'] = '---';
    } else if (___arguments.checkedValue == 'gerade') {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d75656eff4276a4102decfa75d7d996', false);
      ___arguments.context.pageData['LabelErsteTour'] = 'Gerade Wochen';
      ___arguments.context.pageData['LabelZweiteTour'] = '---';
    } else if (___arguments.checkedValue == 'ungerade') {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d75656eff4276a4102decfa75d7d996', false);
      ___arguments.context.pageData['LabelErsteTour'] = 'Ungerade Wochen';
      ___arguments.context.pageData['LabelZweiteTour'] = '---';
    } else if (___arguments.checkedValue == 'unterschiedlich') {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d75656eff4276a4102decfa75d7d996', true);
      ___arguments.context.pageData['LabelErsteTour'] = 'Gerade Wochen';
      ___arguments.context.pageData['LabelZweiteTour'] = 'Ungerade Wochen';
    } else if (___arguments.checkedValue == 'quartal') {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d75656eff4276a4102decfa75d7d996', false);
      ___arguments.context.pageData['LabelErsteTour'] = 'Quartalstour';
      ___arguments.context.pageData['LabelZweiteTour'] = '---';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourPage/components/6f1bf06d08bf002570a699cc17494517/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('NewTourPage', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/6c07781e6527fe1c07e9c1fd90f3bc29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var error, adressListe, nord, sued, west, ost, adresse, tourKunde, j, wochenart;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['wochenart'] = ___arguments.value;
    ;(function (componentUid, traffic){ ___arguments.context.getComponentByUid(componentUid).traffic = traffic })('12988a68ece4f7d8ee6852d937b969c8', true);
    adressListe = [];
    nord = 0;
    sued = 0;
    ost = 0;
    west = 0;
    if (___arguments.value == 'gerade') {
      wochenart = ' and Wochenart =\'gerade\'';
    } else if (___arguments.value == 'ungerade') {
      wochenart = ' and Wochenart =\'ungerade\'';
    } else {
      wochenart = '';
    }
    ___arguments.context.pageData['whereClauseTour'] = (['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'aktuelleTour')),'\'',wochenart].join(''));
    var j_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'aktuelleTour')),'\'',wochenart].join(''))).setSortBy('Pos').setPageSize(50)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      tourKunde = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause((['Kundennr=\'',(getObjectProperty(j, 'KundeID')),'\''].join(''))).setPageSize(10)))[0];
      if ((getObjectProperty(tourKunde, 'Lieferadrid')) != null && !!(getObjectProperty(tourKunde, 'Lieferadrid')).length) {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(getObjectProperty(tourKunde, 'Lieferadrid')),'\''].join(''))).setPageSize(10)))[0];
      } else {
        adresse = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id=\'',(getObjectProperty(tourKunde, 'Rgadrid')),'\''].join(''))).setPageSize(10)))[0];
      }
      addItemToList(adressListe, (getObjectProperty(adresse, 'locationMaps')));
      if (nord != 0 && ost != 0 && sued != 0 && west != 0) {
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng')) > ost) {
          ost = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng')) < west) {
          west = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat')) > nord) {
          nord = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        }
        if ((getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat')) < sued) {
          sued = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        }
      } else {
        nord = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        sued = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lat'));
        ost = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
        west = (getObjectProperty((getObjectProperty(adresse, 'locationMaps')), 'lng'));
      }
    }
    ___arguments.context.pageData['GeodatenListe'] = adressListe;
    ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(((ost + west) / 2)).setY(((sued + nord) / 2)));
    ;(function (componentUid, zoom){ ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('12988a68ece4f7d8ee6852d937b969c8', 8);
    if (!adressListe.length) {
      ;await ( async function (message){ alert(message) })('Leer');
      ___arguments.context.pageData['GeodatenEinzel'] = (new Backendless.Data.Point().setX(9.584474815344239).setY(54.311687344612245));
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/TourPage/components/481af3780ac855c82258519d4ebfbe68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var ausgewaehlterKunde, error, j, varWochenart;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == '*' || (typeof (getObjectProperty(___arguments.context.pageData, 'wochenart')) === 'undefined')) {
      ;await ( async function (message){ alert(message) })('Gerade oder ungerade Tour auswählen');
      return ;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'objectId')) != null) {
      if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == 'gerade') {
        varWochenart = ' and Wochenart = \'gerade\'';
      } else if ((getObjectProperty(___arguments.context.pageData, 'wochenart')) == 'ungerade') {
        varWochenart = ' and Wochenart = \'ungerade\'';
      }
      ausgewaehlterKunde = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(10)))[0];
      await Backendless.Data.of('KundeTour').remove( ausgewaehlterKunde );
      var j_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourID.Name=\'',(getObjectProperty(___arguments.context.pageData, 'aktuelleTour')),'\' AND Pos>\'',(getObjectProperty(ausgewaehlterKunde, 'Pos')),'\'',varWochenart].join(''))).setPageSize(10)));
      for (var j_index in j_list) {
        j = j_list[j_index];
        j['Pos'] = ((getObjectProperty(j, 'Pos')) - 1);
        await Backendless.Data.of('KundeTour').save( j );
      }
    } else {
      ;await ( async function (message){ alert(message) })('Kein Kunde ausgewählt');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TourPage/components/85e6b328e74a8a153d38b68b85e9d05c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('TourArchivePage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!(await Backendless.UserService.isValidLogin())) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);
    } else {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'gerrit.marttila@mar-med.de' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'marttila@outlook.com') {
        ___arguments.context.pageData['isAdmin'] = true;
      } else {
        ___arguments.context.pageData['isAdmin'] = false;
      }
    }

  } catch (error) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('LoginPage', undefined);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/TryErrorPage/components/5bf549a856d8a398c138396611486bc9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout()
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('LoginPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/7a08eb68489827184e987618ce48cf28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/237d21f1e91dc70287a9c35afd3f6a3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, jsonResult, j, counter, adressListe, countDB;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['progessValue'] = 'Start';
    ___arguments.context.pageData['gesamtAnzahl'] = (await Backendless.Data.of('Adressen').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('lat is null and Str is not null and Plz is not null  and Ort1 is not null')));
    countDB = (getObjectProperty(___arguments.context.pageData, 'gesamtAnzahl'));
    counter = 1;
    while (counter <= countDB) {
      ___arguments.context.pageData['progessValue'] = 'Progress';
      adressListe = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause('lat is null and Str is not null and Plz is not null  and Ort1 is not null').setPageSize(100)));
      for (var j_index in adressListe) {
        j = adressListe[j_index];
        counter = counter + 1;
        ___arguments.context.pageData['counterGesamt'] = counter;
        jsonResult = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?address=',(getObjectProperty(j, 'Str')),' ',(getObjectProperty(j, 'Plz')),' ',(getObjectProperty(j, 'Ort1')),' ','&key=','AIzaSyA0LINu3Z7ryVNYTtilJM6I-HVrEgr3wzg'].join('')))).setEncoding('utf8').send());
        try {
          j['lat'] = (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty(jsonResult, 'results'))[0]), 'geometry')), 'location')), 'lat'));
          j['lng'] = (getObjectProperty((getObjectProperty((getObjectProperty(((getObjectProperty(jsonResult, 'results'))[0]), 'geometry')), 'location')), 'lng'));
          j['locationMaps'] = (new Backendless.Data.Point().setX((getObjectProperty(j, 'lng'))).setY((getObjectProperty(j, 'lat'))));
          await Backendless.Data.of('Adressen').save( j );

        } catch (error) {
          await Backendless.Data.of('Log').save( ({ 'Bereich': 'Update Geolocation','Meldung': [(JSON.stringify(jsonResult)),'///',error].join(''),'User': 'SYS' }) );

        }
      }
    }
    ___arguments.context.pageData['gesamtAnzahl'] = 0;
    ___arguments.context.pageData['counterGesamt'] = 0;
    ___arguments.context.pageData['progessValue'] = 'Finish';
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/471bb4336d7804cf7238dfbe982e8d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MainPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/b2c82c7818d7fee8211841b5a4b813f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.UserService.restorePassword((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')));
  (function (message) { alert(message) })((String('Ein Link wurde an folgende Mail-Adresse gesendet: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/b56819766cf857a88b78342b156282c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause('ArtNrExt is null').setPageSize(100)));
    for (var j_index in list) {
      j = list[j_index];
      if ((await Backendless.Data.of('Artikel').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(j, 'ArtikelID')),'\''].join(''))))) > 0) {
        (function (message) { alert(message) })(([(await Backendless.Data.of('Artikel').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(j, 'ArtikelID')),'\''].join(''))))),'-',(getObjectProperty(j, 'ArtikelID'))].join('')));
        await Backendless.Data.of('ArtikelInLagerplatz').setRelation(j, 'ArtNrExt', [(await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(j, 'ArtikelID')),'\''].join(''))).setPageSize(10)))[0]]);
      } else {
        (function (message) { alert(message) })((getObjectProperty(j, 'ArtikelID')));
      }
    }
    (function (message) { alert(message) })('Fin');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/f3767b6474e172e1d575e728ffc649a8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var aenderungen, artikel, artikelInLagerplatz, bereich, bestellungen, bezText, bodyContentHtml, error, lagerplatz, obj, x;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'valueKunde')) != '40336') {
      await Backendless.Messaging.sendEmail('marmed superstore', new Backendless.Bodyparts({ textmessage: (['Es wurde eine Bestellung empfangen','\n','Hauptkundennr: ',(getObjectProperty(___arguments.context.pageData, 'valueKunde')),'\n','Name: ',(getObjectProperty(___arguments.context.pageData, 'Name')),''].join('')) }), ['gerrit.marttila@mar-med.de'], undefined);
      aenderungen = '';
      bodyContentHtml = '<h2><span style="color: #005ca8;"><strong>Bestellung vom marmed superstore</strong></span></h2><p><span style="color: #005ca8;">Hauptkundenr.:';
      bodyContentHtml = String(bodyContentHtml) + String(getObjectProperty(___arguments.context.pageData, 'valueKunde'));
      bodyContentHtml = String(bodyContentHtml) + String('</span></p><p><span style="color: #005ca8;">');
      bodyContentHtml = String(bodyContentHtml) + String(['Bemerkung von Fahrer: ',(getObjectProperty(___arguments.context.pageData, 'valueInfo')),'</span></p>'].join(''));
      var bestellungen_list = (await Backendless.Data.of('Bestellungen').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT = \'',(getObjectProperty(___arguments.context.pageData, 'valueExtid')),'\''].join(''))).setPageSize(100)));
      for (var bestellungen_index in bestellungen_list) {
        bestellungen = bestellungen_list[bestellungen_index];
        bodyContentHtml = String(bodyContentHtml) + String(['<hr/><p><span style="color: #8ec119;">Bestellung durch Mitarbeiter: ',(getObjectProperty(bestellungen, 'Erfasser')),'</span></p><p><span style="color: #8ec119;">','Kundennr: ',(getObjectProperty(bestellungen, 'Kundennr')),'</span></p><p><span style="color: #8ec119;">Listen-/Bereichsname: ',(getObjectProperty(bestellungen, 'Name')),'</span></p><p><span style="color: #8ec119;">Beschreibung: ',(getObjectProperty(bestellungen, 'Beschreibung')),'</span></p>',''].join(''));
        if ((await Backendless.Data.of('ArtikelInBestellung').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(bestellungen, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''))))) > 0) {
          bodyContentHtml = String(bodyContentHtml) + String(['<table>','<tr><td style="width: 100px"><strong>Artnr</strong></td><td style="width: 400px;"><strong>Bezeichnung</strong></td><td  style="text-align: center; width: 120px;"><strong>Bestellmenge</strong></td><td  style="text-align: center; width: 100px;"><strong>Bestellmenge Paketdienst</strong></td>','<td  style="text-align: center; width: 100px;"><strong>Gezaehlte Menge</strong></td><td  style="text-align: center; width: 100px;"><strong>Mindestbestand</strong></td><td  style="text-align: center; width: 100px;"><strong>WoVe</strong></td>','</tr>'].join(''));
        } else {
          bodyContentHtml = String(bodyContentHtml) + String(String('<p>Keine Artikel zum Bestellen</p>'));
        }
        var artikel_list = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(bestellungen, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''))).setPageSize(100)));
        for (var artikel_index in artikel_list) {
          artikel = artikel_list[artikel_index];
          try {
            if ((getObjectProperty(artikel, 'Aenderungsinfo')) != null) {
              if (!!(getObjectProperty(artikel, 'Aenderungsinfo')).length) {
                artikelInLagerplatz = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(artikel, 'objectIdInit')),'\''].join(''))).setPageSize(10)))[0];
                lagerplatz = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(artikelInLagerplatz, 'LagerplatzID')),'\''].join(''))).setPageSize(10)))[0];
                bereich = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(lagerplatz, 'BereichID')),'\''].join(''))).setPageSize(10)))[0];
                aenderungen = String(aenderungen) + String(['Artnr: ',(getObjectProperty(artikel, 'ArtikelID')),' | Aenderungsinfo vom Fahrer: ',(getObjectProperty(artikel, 'Aenderungsinfo')),'\n','Hauptkundennr: ',(getObjectProperty(res.result, 'KundeID')),' | Name: ',(getObjectProperty(res.result, 'Name')),'\n','Bereich: ',(getObjectProperty(bereich, 'Name')),' | Lagerort: ',(getObjectProperty(lagerplatz, 'LagerplatzName ')),'\n'].join(''));
              }
            }

          } catch (error) {
            await Backendless.Messaging.sendEmail('marmed superstore: Error', new Backendless.Bodyparts({ textmessage: error }), ['gerrit.marttila@mar-med.de'], undefined);

          }
          if ((await Backendless.Data.of('Artikel').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(artikel, 'ArtikelID')),'\''].join(''))))) > 0) {
            bezText = (getObjectProperty(((await Backendless.Data.of('Artikel').find(Backendless.DataQueryBuilder.create().setWhereClause((['Artnr = \'',(getObjectProperty(artikel, 'ArtikelID')),'\''].join(''))).setPageSize(10)))[0]), 'Bez1'));
          } else {
            bezText = '>>>Keine Artikel-Stammdaten gefunden<<<';
          }
          bodyContentHtml = String(bodyContentHtml) + String(['<tr><td style="width: 100px">',(getObjectProperty(artikel, 'ArtikelID')),'</td><td style="width: 400px">',bezText,'</td><td  style="text-align: center; width: 120px;">',(getObjectProperty(artikel, 'Bestellmenge')),'</td><td  style="text-align: center; width: 100px;">',(getObjectProperty(artikel, 'BestellmengePaketdienst')),'</td><td  style="text-align: center; width: 100px;">',(getObjectProperty(artikel, 'IstBestand')),'</td><td  style="text-align: center; width: 100px;">',(getObjectProperty(artikel, 'Vorrat')),'</td><td  style="text-align: center; width: 100px;">',(getObjectProperty(artikel, 'WoVe')),'</td></tr><tr><td colspan="4">','Info von Fahrer: ',(getObjectProperty(artikel, 'InfoVonFahrer')),'</td></tr>',''].join(''));
          if ((getObjectProperty(artikel, 'BestellmengePaketdienst')) > 0) {
            bodyContentHtml = String(bodyContentHtml) + String(['</tr><tr><td colspan="4"><span style="color: #ff0000;">','Achtung!!! Bitte folgende Menge mit dem Paketdienst rausschicken: ',(getObjectProperty(artikel, 'BestellmengePaketdienst')),'','</span></td></tr>'].join(''));
          }
          bodyContentHtml = String(bodyContentHtml) + String('<tr style="height: 10px;"> <td style="height: 10px;" colspan="4">&nbsp;</td> </tr>');
        }
        if ((await Backendless.Data.of('ArtikelInBestellung').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ID_EXT_ARTIKEL = \'',(getObjectProperty(bestellungen, 'ID_EXT_ARTIKEL')),'\' AND (Bestellmenge > 0 OR BestellmengePaketdienst > 0)'].join(''))))) > 0) {
          bodyContentHtml = String(bodyContentHtml) + String('</table>');
        }
      }
      await Backendless.Messaging.sendEmail('Bestellung marmed superstore', new Backendless.Bodyparts({ htmlmessage: bodyContentHtml }), [(getObjectProperty(___arguments.context.pageData, 'valueMail'))], undefined);
    }

  } catch (error) {
    (function (message) { alert(message) })(error);
    await Backendless.Messaging.sendEmail('marmed superstore - Error', new Backendless.Bodyparts({ textmessage: error }), ['gerrit.marttila@mar-med.de'], undefined);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/76581608d578daba09a876cdd568e887/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var count, error, gesamt, item, j, k, list, max, name2, offset, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    gesamt = (await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount());
    offset = 0;
    while (offset < gesamt) {
      var j_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setPageSize(100).setOffset(offset)));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((await Backendless.Data.of('ArtikelInBestellung').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['objectIdInit = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))))) > 0) {
          item = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectIdInit = \'',(getObjectProperty(j, 'objectId')),'\''].join(''))).setSortBy('created DESC').setPageSize(100)))[0];
          j['LetzterIstBestand'] = (getObjectProperty(item, 'IstBestand'));
        } else {
          j['LetzterIstBestand'] = 0;
        }
        await Backendless.Data.of('ArtikelInLagerplatz').save( j );
      }
      offset = offset + 100;
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/a5f53d181197236844de75125fe622b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, offset, listItem, searchitem, tempList, tempItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    offset = 0;
    while (true) {
      ___arguments.context.pageData['offsetValue'] = offset;
      tempList = [];
      tempList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setPageSize(100).setOffset(offset)));
      if (tempList.length == 0) {
        break;
      } else {
        for (var listItem_index in tempList) {
          listItem = tempList[listItem_index];
          searchitem = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectIdInit = \'',(getObjectProperty(listItem, 'objectId')),'\''].join(''))).setSortBy('created DESC').setPageSize(1)))[0];
          if (!(typeof searchitem === 'undefined')) {
            if ((getObjectProperty(searchitem, 'IstBestand')) != (getObjectProperty(listItem, 'LetzterIstBestand'))) {
              (function (message) { alert(message) })(([(getObjectProperty(listItem, 'ArtikelID')),' IstBestand: ',(getObjectProperty(searchitem, 'IstBestand')),' LetzterIstBestand: ',(getObjectProperty(listItem, 'LetzterIstBestand')),' created: ',(getObjectProperty(searchitem, 'created')),'\n',['objectIdInit = \'',(getObjectProperty(listItem, 'objectId')),'\''].join('')].join('')));
            }
          } else {
          }
        }
      }
      offset = offset + 100;
    }

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/4b0847520858b518a779aed3b4e85f89/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, returnText, offset, tempItem, schnitt, summe, j, tempList, bestList, counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    returnText = '';
    offset = 0;
    counter = 0;
    while (true) {
      tempList = [];
      tempList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((String('updated < ') + String((new Date((new Date()).getTime() - (1200 * 1000))).valueOf()))).setPageSize(100).setOffset(offset)));
      if (tempList.length == 0) {
        break;
      }
      for (var tempItem_index in tempList) {
        tempItem = tempList[tempItem_index];
        schnitt = (getObjectProperty(((await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectIdInit = \'',(getObjectProperty(tempItem, 'objectId')),'\''].join(''))).setProperties('AVG(Bestellmenge) as Durchschnitt').setPageSize(5)))[0]), 'Durchschnitt'));
        if (schnitt != (getObjectProperty(tempItem, 'BestellmengeDurchschnitt'))) {
          returnText = String(returnText) + String([(getObjectProperty(tempItem, 'ArtikelID')),';',(getObjectProperty(tempItem, 'objectId')),';','',schnitt,';','',(getObjectProperty(tempItem, 'BestellmengeDurchschnitt')),'\n'].join(''));
        }
      }
      offset = offset + 100;
    }
    await Backendless.Messaging.sendEmail('Durchschnittsberechnungsprüfung', new Backendless.Bodyparts({ textmessage: returnText }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/054e8bfe4e5824d859e66bb8b3c82798/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.restorePassword((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')));
    (function (message) { alert(message) })('Es wurde eine Mail mit der Anforderung zum Passwort-Zurücksetzen geschickt!');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/ce9a5675365e2a481e6493e8806c3c06/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, offset, item, tempCount, anzahlGesamt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    offset = 0;
    anzahlGesamt = (await Backendless.Data.of('ArtikelInBestellung').getObjectCount());
    while (offset < anzahlGesamt) {
      var item_list = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause('created > \'10/01/2022\'').setPageSize(100).setOffset(offset)));
      for (var item_index in item_list) {
        item = item_list[item_index];
        tempCount = (await Backendless.Data.of('ArtikelInBestellung').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ArtikelID = \'',(getObjectProperty(item, 'ArtikelID')),'\' and ID_EXT_ARTIKEL = \'',(getObjectProperty(item, 'ID_EXT_ARTIKEL')),'\' and Bestellmenge = \'',(getObjectProperty(item, 'Bestellmenge')),'\' and objectIdInit = \'',(getObjectProperty(item, 'objectIdInit')),'\''].join('')))));
        if (tempCount > 1) {
          (function (message) { alert(message) })((['ArtikelID = \'',(getObjectProperty(item, 'ArtikelID')),'\' and ID_EXT_ARTIKEL = \'',(getObjectProperty(item, 'ID_EXT_ARTIKEL')),'\' and Bestellmenge = \'',(getObjectProperty(item, 'Bestellmenge')),'\' and objectIdInit = \'',(getObjectProperty(item, 'objectIdInit')),'\''].join('')));
        }
      }
      offset = offset + 100;
      ___arguments.context.pageData['offsetValue'] = offset;
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    console.log(error);
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/d498ce3f4518485240bf7dc81d78a0d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var artikelItem, artikelProBesuch, bereichItem, besucheProHalbjahr, counter, counterAll, endZeit, error, gefunden, gesamt, gesamtAnzahl, gesamtListe, j, kundeTourItem, lagerplatzItem, letzterBesuch, naechsterBesuch, offset, returnText, searchItem, startZeit, tempDayList, tempList, tourDateObject, weiter, wochenIntervall;

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetRandomItem(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}


  try {
    startZeit = (new Date());
    returnText = '';
    await Backendless.Messaging.sendEmail('Prozess zum Setzen der Verfallskontrolle gestartet', new Backendless.Bodyparts({ textmessage: (String('Gestartet: ') + String(new Date())) }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);
    counterAll = 0;
    var kundeTourItem_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
    for (var kundeTourItem_index in kundeTourItem_list) {
      kundeTourItem = kundeTourItem_list[kundeTourItem_index];
      gesamtListe = [];
      counterAll = counterAll + 1;
      ___arguments.context.pageData['offsetValue'] = ([(getObjectProperty(kundeTourItem, 'KundeID')),'/',counterAll].join(''));
      var bereichItem_list = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeTourID = \'',(getObjectProperty(kundeTourItem, 'KundeID')),'\''].join(''))).setPageSize(100)));
      for (var bereichItem_index in bereichItem_list) {
        bereichItem = bereichItem_list[bereichItem_index];
        offset = 0;
        tempList = [];
        while (true) {
          tempList = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['BereichID = \'',(getObjectProperty(bereichItem, 'objectId')),'\''].join(''))).setPageSize(100).setOffset(offset)));
          if (tempList.length == 0) {
            break;
          }
          for (var lagerplatzItem_index in tempList) {
            lagerplatzItem = tempList[lagerplatzItem_index];
            var artikelItem_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzID = \'',(getObjectProperty(lagerplatzItem, 'objectId')),'\' AND Verfallskontrolle = TRUE '].join(''))).setPageSize(100)));
            for (var artikelItem_index in artikelItem_list) {
              artikelItem = artikelItem_list[artikelItem_index];
              addItemToList(gesamtListe, artikelItem);
            }
          }
          offset = offset + 100;
        }
      }
      gesamtAnzahl = gesamtListe.length;
      wochenIntervall = (getObjectProperty(kundeTourItem, 'Intervall')) / 7;
      besucheProHalbjahr = Math.floor(28 / wochenIntervall);
      artikelProBesuch = Math.ceil(gesamtAnzahl / besucheProHalbjahr);
      returnText = String(returnText) + String(['Kunde:',(getObjectProperty(kundeTourItem, 'KundeID')),'\n','Artikel zu prüfen:',gesamtAnzahl,'\n','Intervall: ',(getObjectProperty(kundeTourItem, 'Intervall')),'\n','Besuche pro Halbjahr: ',besucheProHalbjahr,'\n','Artikel pro Besuch: ',artikelProBesuch,'\n','\n'].join(''));
      tourDateObject = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(kundeTourItem, 'KundeID')),'\''].join(''))).setSortBy('TourDate DESC').setPageSize(1)))[0];
      if (typeof tourDateObject === 'undefined') {
        if ((getObjectProperty(kundeTourItem, 'StartDatum')) == null) {
          continue;
        } else {
          letzterBesuch = (getObjectProperty(kundeTourItem, 'StartDatum'));
        }
      } else {
        letzterBesuch = (getObjectProperty(tourDateObject, 'TourDate'));
      }
      naechsterBesuch = letzterBesuch;
      tempDayList = [];
      while (gesamtListe.length > 0) {
        tempDayList = [];
        naechsterBesuch = (new Date((new Date(naechsterBesuch)).getTime() + (((getObjectProperty(kundeTourItem, 'Intervall')) * 86400) * 1000)));
        while (tempDayList.length < artikelProBesuch) {
          if (gesamtListe.length == 0) {
            break;
          }
          addItemToList(tempDayList, (listsGetRandomItem(gesamtListe, true)));
        }
        for (var j_index in tempDayList) {
          j = tempDayList[j_index];
          j['NaechsteVerfallskontrolle'] = naechsterBesuch;
        }
        returnText = String(returnText) + String(['Anzahl Artikel: ',tempDayList.length,' Datum: ',naechsterBesuch,'\n'].join(''));
        await Backendless.Data.of('ArtikelInLagerplatz').bulkUpsert( tempDayList );
      }
      returnText = String(returnText) + String(['\n','\n','---------------------------------------------------------','\n','\n'].join(''));
    }
    endZeit = (new Date());
    (function (message) { alert(message) })((['Startzeit: ',startZeit,'\n','Endzeit: ',endZeit].join('')));
    await Backendless.Messaging.sendEmail('marmed.superstore: Verfallskontrolle Halbjahr gesetzt', new Backendless.Bodyparts({ textmessage: returnText }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/48b80ae8e23ec9d81ac8eaa86093d648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, offset, tempObject, j, searchId, gesamtAnzahl, response, loc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var j_list = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause('lat is null and Ort1 is not null and Plz is not null and Str is not null').setPageSize(250)));
    for (var j_index in j_list) {
      j = j_list[j_index];
      response = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((['https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBzwBo4uVxnWzR0gT_UhenW4FN28VB5Kfc&address=',(getObjectProperty(j, 'Str')),'%20',(getObjectProperty(j, 'Plz')),'%20',(getObjectProperty(j, 'Ort1'))].join('')))).setEncoding('utf8').send());
      try {
        loc = (getObjectProperty((getObjectProperty(((getObjectProperty(response, 'results'))[0]), 'geometry')), 'location'));

      } catch (error) {

      }
      if (loc !== null && !Array.isArray(loc) && (typeof loc === 'object')) {
        j['lat'] = (getObjectProperty(loc, 'lat'));
        j['lng'] = (getObjectProperty(loc, 'lng'));
        await Backendless.Data.of('Adressen').save( j );
      } else {
        (function (message) { alert(message) })((JSON.stringify(response)));
      }
    }
    var j_list2 = (await Backendless.Data.of('Kunden').find(Backendless.DataQueryBuilder.create().setWhereClause('LocationAdress is null and Aktiv = True').setPageSize(250)));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      searchId = !((getObjectProperty(j, 'Lieferadrid')) === null) ? (getObjectProperty(j, 'Lieferadrid')) : (!((getObjectProperty(j, 'Rgadrid')) === null) ? (getObjectProperty(j, 'Rgadrid')) : (!((getObjectProperty(j, 'Android')) === null) ? (getObjectProperty(j, 'Abadrid')) : 'NONE'));
      tempObject = (await Backendless.Data.of('Adressen').find(Backendless.DataQueryBuilder.create().setWhereClause((['Id = \'',searchId,'\''].join(''))).setPageSize(10)))[0];
      if (tempObject !== null && !Array.isArray(tempObject) && (typeof tempObject === 'object')) {
        await Backendless.Data.of('Kunden').setRelation(j, 'LocationAdress', [tempObject]);
      }
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/439d4be878c8b998d0283eb4bb38f7f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var artikelItem, artikelProBesuch, bereichItem, besucheProHalbjahr, error, gesamtAnzahl, gesamtListe, j, kundeTourItem, lagerplatzItem, letzterBesuch, naechsterBesuch, offset, returnText, tempDayList, tempList, tourDateObject, wochenIntervall;


  try {
    while (true) {
      tempList = [];
      tempList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause('WoVe = 0 and Vorrat = 0 and Verfallskontrolle = True').setPageSize(100)));
      if (tempList.length == 0) {
        break;
      }
      for (var j_index in tempList) {
        j = tempList[j_index];
        j['Verfallskontrolle'] = false;
        j['NaechsteVerfallskontrolle'] = null;
        await Backendless.Data.of('ArtikelInLagerplatz').save( j );
      }
    }
    (function (message) { alert(message) })('Fertig!');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/7c88b4bf3981eeb880788548c4381508/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var counter, counterGesamt, error, j, offset, resultList, tempItem, tempList;


  try {
    (function (message) { alert(message) })((await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('(LagerplatzId is null or LagerplatzId = \'\') and updated > ') + String((new Date((new Date()).getTime() - (8000 * 1000))).valueOf()))))));
    resultList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((String('(LagerplatzId is null or LagerplatzId = \'\') and updated > ') + String((new Date((new Date()).getTime() - (8000 * 1000))).valueOf()))).setPageSize(100)));
    for (var tempItem_index in resultList) {
      tempItem = resultList[tempItem_index];
      tempItem['LagerplatzID'] = 'E4E64136-56EF-4CB8-97B2-689B76BE9BE0';
      await Backendless.Data.of('ArtikelInLagerplatz').save( tempItem );
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/705ba7686354d5da83c86e3808034d98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var count, error, itemArtikelNB, itemBereich, j, list, offset, offsetLP, returnText, tempList, tempListLP, tempLoNB;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    offset = 0;
    while (true) {
      tempList = [];
      tempList = (await Backendless.Data.of('BereicheInTouren').find(Backendless.DataQueryBuilder.create().setPageSize(100).setOffset(offset)));
      if (tempList.length == 0) {
        break;
      }
      for (var itemBereich_index in tempList) {
        itemBereich = tempList[itemBereich_index];
        count = 1;
        ___arguments.context.pageData['offsetValue'] = (getObjectProperty(itemBereich, 'Name'));
        offsetLP = 0;
        while (true) {
          tempListLP = [];
          tempListLP = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause((['PosNr > 0 and PosNr < 9999 and BereichID = \'',(getObjectProperty(itemBereich, 'objectId')),'\''].join(''))).setSortBy('PosNr').setPageSize(100).setOffset(offsetLP)));
          if (tempListLP.length == 0) {
            break;
          }
          for (var j_index in tempListLP) {
            j = tempListLP[j_index];
            if ((getObjectProperty(j, 'PosNr')) != count) {
              j['PosNr'] = count;
              await Backendless.Data.of('LagerplatzInBereich').save( j );
            }
            count = count + 1;
          }
          offsetLP = offsetLP + 100;
        }
      }
      offset = offset + 100;
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/ce58d2c480b88518a528eeb927621008/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, offset, tempList;


  try {
    (function (message) { alert(message) })((await Backendless.Data.of('ArtikelInLagerplatz').bulkUpdate( 'NaechsteVerfallskontrolle is not null or LetzteVerfallskontrolle is not null', ({ 'NaechsteVerfallskontrolle': null,'LetzteVerfallskontrolle': null }) )));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/142bbe7fc058e79b0cf8284860058a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var checkDate, decision, error, filterList, gesamtListen, i, initList, initTourenList, item, j, list, list1A, list1B, list1C, list1D, list2A, list2B, list2C, list2D, list3A, list3B, list3C, list3D, list4A, list4B, list4C, list4D, list5A, list5B, list5C, list5D, listItem, num, tempList, tempObject, textos, tourItem, tourItemList, tourList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    list1A = [];
    list1B = [];
    list1C = [];
    list1D = [];
    list2A = [];
    list2B = [];
    list2C = [];
    list2D = [];
    list3A = [];
    list3B = [];
    list3C = [];
    list3D = [];
    list4A = [];
    list4B = [];
    list4C = [];
    list4D = [];
    list5A = [];
    list5B = [];
    list5C = [];
    list5D = [];
    gesamtListen = [];
    for (i = 0; i <= 180; i++) {
      checkDate = (new Date((new Date()).getTime() - ((i * 86400) * 1000)));
      tourList = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourDate >= \'',(new Date(checkDate).getMonth() + 1) < 10 ? String('0') + String(new Date(checkDate).getMonth() + 1) : (new Date(checkDate).getMonth() + 1),'-',(new Date(checkDate).getDate()) < 10 ? String('0') + String(new Date(checkDate).getDate()) : (new Date(checkDate).getDate()),'-',(new Date(checkDate).getFullYear()),'\' AND TourDate < \'',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getFullYear()),'\' and KundeID != \'40336\''].join(''))).setProperties('Tour').setSortBy('Tour').setGroupBy('Tour').setPageSize(100)));
      for (var tourItem_index in tourList) {
        tourItem = tourList[tourItem_index];
        tempObject = ({ [`tourName`]: (getObjectProperty(tourItem, 'Tour')),[`datum`]: checkDate,[`list`]: (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['TourDate >= \'',(new Date(checkDate).getMonth() + 1) < 10 ? String('0') + String(new Date(checkDate).getMonth() + 1) : (new Date(checkDate).getMonth() + 1),'-',(new Date(checkDate).getDate()) < 10 ? String('0') + String(new Date(checkDate).getDate()) : (new Date(checkDate).getDate()),'-',(new Date(checkDate).getFullYear()),'\' AND TourDate < \'',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getMonth() + 1),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) < 10 ? String('0') + String(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()) : (new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getDate()),'-',(new Date((new Date(checkDate.getTime() + (86400 * 1000)))).getFullYear()),'\' and KundeID != \'40336\' AND Tour = \'',(getObjectProperty(tourItem, 'Tour')),'\''].join(''))).setSortBy('TourDate').setGroupBy('KundeID').setPageSize(100))) });
        if ((getObjectProperty(tourItem, 'Tour')) == '1A') {
          addItemToList(list1A, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '1B') {
          addItemToList(list1B, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '1C') {
          addItemToList(list1C, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '1D') {
          addItemToList(list1D, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '2A') {
          addItemToList(list2A, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '2B') {
          addItemToList(list2B, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '2C') {
          addItemToList(list2C, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '2D') {
          addItemToList(list2D, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '3A') {
          addItemToList(list3A, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '3B') {
          addItemToList(list3B, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '3C') {
          addItemToList(list3C, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '3D') {
          addItemToList(list3D, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '4A') {
          addItemToList(list4A, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '4B') {
          addItemToList(list4B, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '4C') {
          addItemToList(list4C, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '4D') {
          addItemToList(list4D, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '5A') {
          addItemToList(list5A, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '5B') {
          addItemToList(list5B, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '5C') {
          addItemToList(list5C, tempObject);
        } else if ((getObjectProperty(tourItem, 'Tour')) == '5D') {
          addItemToList(list5D, tempObject);
        }
      }
    }
    addItemToList(gesamtListen, ({ [`list`]: list1A }));
    addItemToList(gesamtListen, ({ [`list`]: list1B }));
    addItemToList(gesamtListen, ({ [`list`]: list1C }));
    addItemToList(gesamtListen, ({ [`list`]: list1D }));
    addItemToList(gesamtListen, ({ [`list`]: list2A }));
    addItemToList(gesamtListen, ({ [`list`]: list2B }));
    addItemToList(gesamtListen, ({ [`list`]: list2C }));
    addItemToList(gesamtListen, ({ [`list`]: list2D }));
    addItemToList(gesamtListen, ({ [`list`]: list3A }));
    addItemToList(gesamtListen, ({ [`list`]: list3B }));
    addItemToList(gesamtListen, ({ [`list`]: list3C }));
    addItemToList(gesamtListen, ({ [`list`]: list3D }));
    addItemToList(gesamtListen, ({ [`list`]: list4A }));
    addItemToList(gesamtListen, ({ [`list`]: list4B }));
    addItemToList(gesamtListen, ({ [`list`]: list4C }));
    addItemToList(gesamtListen, ({ [`list`]: list4D }));
    addItemToList(gesamtListen, ({ [`list`]: list5A }));
    addItemToList(gesamtListen, ({ [`list`]: list5B }));
    addItemToList(gesamtListen, ({ [`list`]: list5C }));
    addItemToList(gesamtListen, ({ [`list`]: list5D }));
    textos = '';
    console.log(gesamtListen.length);
    for (var listItem_index in gesamtListen) {
      listItem = gesamtListen[listItem_index];
      console.log((getObjectProperty(listItem, 'list')).length);
      var item_list = (getObjectProperty(listItem, 'list'));
      for (var item_index in item_list) {
        item = item_list[item_index];
        console.log(getObjectProperty(item, 'tourName'));
        textos = String(textos) + String(String(getObjectProperty(item, 'tourName')) + String('\n'));
        console.log(getObjectProperty(item, 'datum'));
        textos = String(textos) + String(String([(new Date((getObjectProperty(item, 'datum'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(item, 'datum'))).getDate()) : (new Date((getObjectProperty(item, 'datum'))).getDate()),'.',(new Date((getObjectProperty(item, 'datum'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(item, 'datum'))).getMonth() + 1) : (new Date((getObjectProperty(item, 'datum'))).getMonth() + 1),'.',(new Date((getObjectProperty(item, 'datum'))).getFullYear())].join('')) + String('\n'));
        textos = String(textos) + String(String('Nr;Kdnr;Name;TourDate;StartTime;EndTime') + String('\n'));
        num = 1;
        var j_list = (getObjectProperty(item, 'list'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          console.log(getObjectProperty(j, 'Name'));
          textos = String(textos) + String([num,';',(getObjectProperty(j, 'KundeID')),';',(getObjectProperty(j, 'Name')),';',[(new Date((getObjectProperty(j, 'TourDate'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getDate()) : (new Date((getObjectProperty(j, 'TourDate'))).getDate()),'.',(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'TourDate'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'TourDate'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'TourDate'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getHours()) : (new Date((getObjectProperty(j, 'TourDate'))).getHours()),':',(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'TourDate'))).getMinutes()) : (new Date((getObjectProperty(j, 'TourDate'))).getMinutes())].join(''),';',[(new Date((getObjectProperty(j, 'StartTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getDate()) : (new Date((getObjectProperty(j, 'StartTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'StartTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'StartTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'StartTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getHours()) : (new Date((getObjectProperty(j, 'StartTime'))).getHours()),':',(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'StartTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'StartTime'))).getMinutes())].join(''),';',[(new Date((getObjectProperty(j, 'EndTime'))).getDate()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getDate()) : (new Date((getObjectProperty(j, 'EndTime'))).getDate()),'.',(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1) : (new Date((getObjectProperty(j, 'EndTime'))).getMonth() + 1),'.',(new Date((getObjectProperty(j, 'EndTime'))).getFullYear()),' ',(new Date((getObjectProperty(j, 'EndTime'))).getHours()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getHours()) : (new Date((getObjectProperty(j, 'EndTime'))).getHours()),':',(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) < 10 ? String('0') + String(new Date((getObjectProperty(j, 'EndTime'))).getMinutes()) : (new Date((getObjectProperty(j, 'EndTime'))).getMinutes())].join(''),'\n'].join(''));
          num = num + 1;
        }
        textos = String(textos) + String(String('\n') + String('\n'));
      }
      textos = String(textos) + String(String('\n') + String('\n'));
    }
    await Backendless.Messaging.sendEmail('Tourenplan der letzten 100 Tage', new Backendless.Bodyparts({ textmessage: textos }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);
    (function (message) { alert(message) })('Finished');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/08015cbe6b49971818d8368d5be85a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var counter, deleteCounter, deleteList, error, historyFound, idList, j, liste, offset, returnText, tempItem, tempList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (message) { alert(message) })(((await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause('ArtikelID != \'LOL\'').setHavingClause('Menge >= 2').setProperties('ArtikelID, LagerplatzID, LagerplatzIdExt.BereichExt.KundeTourID, COUNT(ArtikelID) as Menge').setGroupBy('ArtikelID, LagerplatzID, LagerplatzIdExt.BereichExt.KundeTourID').setPageSize(1000))).length));
    counter = 0;
    offset = 0;
    liste = [];
    returnText = '';
    while (true) {
      tempList = [];
      tempList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause('ArtikelID != \'LOL\'').setHavingClause('Menge >= 2').setProperties('ArtikelID, LagerplatzID, LagerplatzIdExt.BereichExt.KundeTourID, COUNT(ArtikelID) as Menge').setGroupBy('ArtikelID, LagerplatzID, LagerplatzIdExt.BereichExt.KundeTourID').setPageSize(1000)));
      if (tempList.length == 0) {
        break;
      }
      addItemToList(liste, tempList);
      counter = counter + tempList.length;
      break;
    }
    for (var tempItem_index in liste) {
      tempItem = liste[tempItem_index];
      deleteCounter = 1;
      deleteList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['ArtikelID = \'',(getObjectProperty(tempItem, 'ArtikelID')),'\' and LagerplatzID = \'',(getObjectProperty(tempItem, 'LagerplatzID')),'\' and LagerplatzIdExt.BereichExt.KundeTourID = \'',(getObjectProperty(tempItem, 'KundeTourID')),'\''].join(''))).setRelationsDepth(5).setSortBy('updated DESC').setPageSize(10)));
      historyFound = false;
      for (var j_index in deleteList) {
        j = deleteList[j_index];
        if (1 == deleteCounter) {
          idList = (getObjectProperty(j, 'objectId'));
        } else {
          if (!(typeof idList === 'undefined')) {
            await Backendless.Data.of('ArtikelInLagerplatzHistory').bulkUpdate( (['objectIdFromList = \'',(getObjectProperty(j, 'objectId')),'\''].join('')), ({ [`objectIdFromList`]: idList }) );
            await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(j, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(j, 'Bemerkung')),[`Datum`]: (new Date()),[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`deletedInfo`]: 'automatic deletion',[`LagerplatzID`]: (getObjectProperty(j, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(j, 'PosNr')),[`Vorrat`]: (getObjectProperty(j, 'Vorrat')),[`WoVe`]: (getObjectProperty(j, 'WoVe')),[`BestellenUnter`]: (getObjectProperty(j, 'BestellenAb')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`deleteOrUpdate`]: 'D',[`objectIdFromList`]: (getObjectProperty(j, 'objectId')) }) );
            await Backendless.Data.of('ArtikelInLagerplatz').remove( j );
          } else {
            (function (message) { alert(message) })('Kein Objekt');
          }
        }
        deleteCounter = deleteCounter + 1;
      }
    }
    (function (message) { alert(message) })(counter);
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/e067a468ab4882c8f7989ba34d68e195/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var artnrNew, artnrOld, error, item, offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    artnrNew = (getObjectProperty(___arguments.context.pageData, 'artnrnew'));
    artnrOld = (getObjectProperty(___arguments.context.pageData, 'artnrold'));
    await Backendless.Data.of('ArtikelInLagerplatz').bulkUpdate( (['ArtikelID = \'',artnrOld,'\''].join('')), ({ [`ArtikelID`]: artnrNew }) );
    await Backendless.Data.of('ArtikelInLagerplatzHistory').bulkUpdate( (['ArtikelID = \'',artnrOld,'\''].join('')), ({ [`ArtikelID`]: artnrNew }) );
    await Backendless.Data.of('ArtikelInBestellung').bulkUpdate( (['ArtikelID = \'',artnrOld,'\''].join('')), ({ [`ArtikelID`]: artnrNew }) );
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/7b889468c4b831188898c787a848ff88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var counter, error, kundeTourItem, lastDate, returnText, summe, tourItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    returnText = '';
    var kundeTourItem_list = (await Backendless.Data.of('KundeTour').find(Backendless.DataQueryBuilder.create().setSortBy('KundeID').setPageSize(100)));
    for (var kundeTourItem_index in kundeTourItem_list) {
      kundeTourItem = kundeTourItem_list[kundeTourItem_index];
      returnText = String(returnText) + String([(getObjectProperty(kundeTourItem, 'KundeID')),' | ',(getObjectProperty(kundeTourItem, 'Name')),'\n'].join(''));
      counter = 0;
      summe = 0;
      var tourItem_list = (await Backendless.Data.of('RealTour').find(Backendless.DataQueryBuilder.create().setWhereClause((['KundeID = \'',(getObjectProperty(kundeTourItem, 'KundeID')),'\''].join(''))).setSortBy('EndTime desc').setPageSize(100)));
      for (var tourItem_index in tourItem_list) {
        tourItem = tourItem_list[tourItem_index];
        summe = summe + Math.round((lastDate - (getObjectProperty(tourItem, 'EndTime'))) / 86400000);
        counter = counter + 1;
        if (counter > 1) {
          returnText = String(returnText) + String([(new Date((getObjectProperty(tourItem, 'EndTime')))),' : ',Math.round((lastDate - (getObjectProperty(tourItem, 'EndTime'))) / 86400000),'\n'].join(''));
        } else {
          returnText = String(returnText) + String([(new Date((getObjectProperty(tourItem, 'EndTime')))),' : ',0,'\n'].join(''));
        }
        lastDate = (getObjectProperty(tourItem, 'EndTime'));
      }
      returnText = String(returnText) + String(['Durchschnitt: ',Math.round(summe / counter),'\n'].join(''));
      returnText = String(returnText) + String('\n |n');
    }
    await Backendless.Messaging.sendEmail('Intervalle berechnen', new Backendless.Bodyparts({ textmessage: returnText }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);
    (function (message) { alert(message) })('');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/6648831890484578582e75c8368884be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, counter, deleteCounter, j, idList, deleteList, tempItem, historyFound, liste, offset, tempList, returnText;

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.Messaging.sendEmail('Testos', new Backendless.Bodyparts({ textmessage: (JSON.stringify((await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause('').setHavingClause('Menge >= 2').setProperties('LagerplatzName, BereichID, BereichExt.KundeTourID, BereichExt.Beschreibung, COUNT(LagerplatzName) as Menge').setGroupBy('LagerplatzName, BereichID, BereichExt.KundeTourID, BereichExt.Beschreibung').setPageSize(1000))))) }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);
    (function (message) { alert(message) })(((await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause('').setHavingClause('Menge >= 2').setProperties('LagerplatzName, BereichID, BereichExt.KundeTourID, COUNT(LagerplatzName) as Menge').setGroupBy('LagerplatzName, BereichID, BereichExt.KundeTourID').setPageSize(1000))).length));
    counter = 0;
    offset = 0;
    liste = [];
    returnText = '';
    while (true) {
      tempList = [];
      tempList = (await Backendless.Data.of('LagerplatzInBereich').find(Backendless.DataQueryBuilder.create().setWhereClause('').setHavingClause('Menge >= 2').setProperties('LagerplatzName, BereichID, BereichExt.KundeTourID, COUNT(LagerplatzName) as Menge').setGroupBy('LagerplatzName, BereichID, BereichExt.KundeTourID').setPageSize(1000)));
      if (tempList.length == 0) {
        break;
      }
      addItemToList(liste, tempList);
      counter = counter + tempList.length;
      break;
    }
    for (var tempItem_index in liste) {
      tempItem = liste[tempItem_index];
      deleteCounter = 1;
      deleteList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['ArtikelID = \'',(getObjectProperty(tempItem, 'ArtikelID')),'\' and LagerplatzID = \'',(getObjectProperty(tempItem, 'LagerplatzID')),'\' and LagerplatzIdExt.BereichExt.KundeTourID = \'',(getObjectProperty(tempItem, 'KundeTourID')),'\''].join(''))).setRelationsDepth(5).setSortBy('updated DESC').setPageSize(10)));
      historyFound = false;
      for (var j_index in deleteList) {
        j = deleteList[j_index];
        if (1 == deleteCounter) {
          idList = (getObjectProperty(j, 'objectId'));
        } else {
          if (!(typeof idList === 'undefined')) {
            await Backendless.Data.of('ArtikelInLagerplatzHistory').bulkUpdate( (['objectIdFromList = \'',(getObjectProperty(j, 'objectId')),'\''].join('')), ({ [`objectIdFromList`]: idList }) );
            await Backendless.Data.of('ArtikelInLagerplatzHistory').save( ({ [`ArtikelID`]: (getObjectProperty(j, 'ArtikelID')),[`Bemerkung`]: (getObjectProperty(j, 'Bemerkung')),[`Datum`]: (new Date()),[`fromUser`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`deletedInfo`]: 'automatic deletion',[`LagerplatzID`]: (getObjectProperty(j, 'LagerplatzID')),[`PosNr`]: (getObjectProperty(j, 'PosNr')),[`Vorrat`]: (getObjectProperty(j, 'Vorrat')),[`WoVe`]: (getObjectProperty(j, 'WoVe')),[`BestellenUnter`]: (getObjectProperty(j, 'BestellenAb')),[`Kundennr`]: (getObjectProperty(___arguments.context.appData, 'Kundennr')),[`deleteOrUpdate`]: 'D',[`objectIdFromList`]: (getObjectProperty(j, 'objectId')) }) );
            await Backendless.Data.of('ArtikelInLagerplatz').remove( j );
          } else {
            (function (message) { alert(message) })('Kein Objekt');
          }
        }
        deleteCounter = deleteCounter + 1;
      }
    }
    (function (message) { alert(message) })(counter);
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/61138a6877a871bfdc7d80b8d5b83438/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var counter, error, j, nbItem, offset, returnList, tempList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    (function (message) { alert(message) })((await Backendless.Data.of('ArtikelInLagerplatz').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('LagerplatzIdExt.LagerplatzName = \'NB\''))));
    counter = 0;
    returnList = [];
    offset = 0;
    for (var count = 0; count < 10; count++) {
      var nbItem_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause('LagerplatzIdExt.LagerplatzName = \'NeueArtikel\' OR LagerplatzIdExt.LagerplatzName = \'NB\' ').setProperties('ArtikelID, LagerplatzIdExt.BereichExt.KundeTourID, LagerplatzIdExt. LagerplatzName, LagerplatzIdExt.BereichExt.objectId, ArtNrExt.Bez1,created, LagerplatzIdExt.BereichExt.Name, LagerplatzIdExt.BereichExt.Beschreibung').setPageSize(500).setOffset(offset)));
      for (var nbItem_index in nbItem_list) {
        nbItem = nbItem_list[nbItem_index];
        counter = counter + 1;
        ___arguments.context.pageData['offsetValue'] = counter;
        tempList = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['LagerplatzIdExt.LagerplatzName != \'NeueArtikel\' AND LagerplatzIdExt.LagerplatzName != \'NB\'  AND LagerplatzIdExt.BereichExt.KundeTourID = \'',(getObjectProperty(nbItem, 'KundeTourID')),'\' and ArtikelID = \'',(getObjectProperty(nbItem, 'ArtikelID')),'\' AND LagerplatzIdExt.BereichExt.objectId = \'',(getObjectProperty(nbItem, 'objectId')),'\''].join(''))).setProperties('ArtikelID, LagerplatzIdExt.BereichExt.KundeTourID, LagerplatzIdExt. LagerplatzName, LagerplatzIdExt.BereichExt.objectId, ArtNrExt.Bez1,created, LagerplatzIdExt.BereichExt.Name, LagerplatzIdExt.BereichExt.Beschreibung').setPageSize(100)));
        if (tempList.length > 0) {
          for (var j_index in tempList) {
            j = tempList[j_index];
            addItemToList(returnList, ({ [`KundeTourID`]: (getObjectProperty(nbItem, 'KundeTourID')),[`Bereich`]: [(getObjectProperty(nbItem, 'Name')),' - ',(getObjectProperty(nbItem, 'Beschreibung'))].join(''),[`ArtikelID`]: (getObjectProperty(nbItem, 'ArtikelID')),[`Bez1`]: (getObjectProperty(nbItem, 'Bez1')),[`Lagerplatz1`]: (getObjectProperty(nbItem, 'LagerplatzName')),[`Lagerplatz2`]: (getObjectProperty(j, 'LagerplatzName')),[`created1`]: (new Date((getObjectProperty(nbItem, 'created')))),[`created2`]: (new Date((getObjectProperty(j, 'created')))) }));
          }
        }
      }
      offset = offset + 500;
    }
    await Backendless.Messaging.sendEmail('Testomania', new Backendless.Bodyparts({ textmessage: (JSON.stringify(returnList)) }), ensureArray(['gerrit.marttila@mar-med.de']), undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/72582768ac73aef80448c47a30881648/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, j, setItem, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var item_list = (await Backendless.Data.of('ArtikelInBestellung').find(Backendless.DataQueryBuilder.create().setWhereClause('ID_EXT_ARTIKEL = \'4CF23218-8D82-4F16-8F1C-D6213907E009\'').setPageSize(100)));
    for (var item_index in item_list) {
      item = item_list[item_index];
      var setItem_list = (await Backendless.Data.of('ArtikelInLagerplatz').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'objectIdInit')),'\''].join(''))).setPageSize(100)));
      for (var setItem_index in setItem_list) {
        setItem = setItem_list[setItem_index];
        setItem['LagerplatzID'] = '1AAA7A7E-1BD9-4063-BB51-29DB621BDF49';
        await Backendless.Data.of('ArtikelInLagerplatz').save(setItem, true);
      }
    }
    (function (message) { alert(message) })('Fertig');

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/TryErrorPage/components/da1a68187d6e11362b08a5189da59d48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, returnText, bestellItem, tempItem, artikelItem, lagerplatzItem, bereicheItem, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    (function (message) { alert(message) })('Go');
    item = (await Backendless.Data.of('ElectricCarCharging').find(Backendless.DataQueryBuilder.create().setSortBy('Datum desc').setPageSize(10)))[0];
    (function (message) { alert(message) })('Go2');
    await Backendless.Messaging.sendEmail('Neue Beantragung für das Laden zuhause', new Backendless.Bodyparts({ textmessage: (['Datum: ',(new Date((getObjectProperty(item, 'Datum'))).getDate()),'.',(new Date((getObjectProperty(item, 'Datum'))).getMonth() + 1),'.',(new Date((getObjectProperty(item, 'Datum'))).getFullYear()),'\n','Mitarbeiter: ',(getObjectProperty(item, 'User')),'\n','Kennzeichen: ',(getObjectProperty(item, 'User')),'\n','Monat/Jahr: ',(getObjectProperty(item, 'Monat')),'/',(getObjectProperty(item, 'Jahr')),'\n','Standort: ',(getObjectProperty(item, 'LocationChargingStation')),'\n','kWh: ',(getObjectProperty(item, 'KwhGesamt')),'\n','Preis pro kWh: ','0,3436 €','\n','Wert: ',(getObjectProperty(item, 'Wert'))].join('')) }), ensureArray(['gerrit.marttila@mar-med.de']), ensureArray([(getObjectProperty(item, 'File'))]).filter(item => !!item));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

